/* eslint-disable no-template-curly-in-string */
import { NamiInitialConfig } from "@namiml/web-sdk";

export const nflInitialConfig: NamiInitialConfig = {
  "platform_config": {
    "id": "09dc4fe6-dc7f-4ee8-ab56-f4fa5e954fbf",
    "capabilities": [
      "anonymous_allowed",
      "local_user_tagging",
      "paywall_personalization",
      "remote_user_tagging",
      "sdk",
      "third_party_analytics",
      "third_party_transactions"
    ],
    "marketplace_app_id": null
  },
  "products": [
    {
      "id": "7b1cc241-3678-4f03-ba16-34131f488903",
      "name": "NFL+ Premium Monthly",
      "sku_ref_id": "S176422819",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
          "entitlement_ref_id": "nflplus_premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        },
        {
          "id": "21a23c56-7699-4af5-99a1-85c1085be475",
          "entitlement_ref_id": "premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "8728648b-e784-4c27-b137-c8fba39226ce",
      "name": "NFL+ Monthly",
      "sku_ref_id": "S533943165",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
          "entitlement_ref_id": "nflplus",
          "name": "NFL+",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "086b7e07-a10e-4297-9a94-1f3dbc4ca8ee",
      "name": "NFL+ Annual",
      "sku_ref_id": "S749091632",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
          "entitlement_ref_id": "nflplus",
          "name": "NFL+",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "7cc0c0dd-2364-4b0e-ba68-3f4a38e6ed4c",
      "name": "NFL+ Premium Annual",
      "sku_ref_id": "S115046355",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
          "entitlement_ref_id": "nflplus_premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        },
        {
          "id": "21a23c56-7699-4af5-99a1-85c1085be475",
          "entitlement_ref_id": "premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "202514a5-24d7-472c-9174-826148ce99a9",
      "name": "[REC] NFL+ Annual",
      "sku_ref_id": "nfl_plus_annual",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
          "entitlement_ref_id": "nflplus",
          "name": "NFL+",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
      "name": "[REC] NFL+ Monthly",
      "sku_ref_id": "nfl_plus_monthly",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
          "entitlement_ref_id": "nflplus",
          "name": "NFL+",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
      "name": "[REC] NFL+ Premium Annual",
      "sku_ref_id": "nfl_plus_premium_annual",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
          "entitlement_ref_id": "nflplus_premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        },
        {
          "id": "21a23c56-7699-4af5-99a1-85c1085be475",
          "entitlement_ref_id": "premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
      "name": "[REC] NFL+ Premium Monthly",
      "sku_ref_id": "nfl_plus_premium_monthly",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
          "entitlement_ref_id": "nflplus_premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        },
        {
          "id": "21a23c56-7699-4af5-99a1-85c1085be475",
          "entitlement_ref_id": "premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
      "name": "[INT] NFL+ Premium Annual",
      "sku_ref_id": "nfl_plus_premium_annual_pass",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
          "entitlement_ref_id": "nflplus_premium",
          "name": "NFL+ Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    }
  ],
  "paywalls": [
    {
      "id": "04a04dea-a22e-4652-a240-3889b7826045",
      "name": "Preseason 25 Desktop",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "9ca86023-87af-4a24-972e-912160959e8f",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "d4222fcb-57ad-42c8-847d-d0d4f9b3fa07",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "spacer2",
                  "title": "Spacer2",
                  "height": 20,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "PRESEASON STARTS HERE!",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 40,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!",
                  "title": "Body Text",
                  "width": "fitContent",
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 20,
                  "textType": "body",
                  "alignment": "left",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 10,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image2",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 138,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList7",
                                      "texts": [
                                        "Live Out-of-Market Preseason Games"
                                      ],
                                      "title": "Bullet List7",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component0",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer4",
                                      "title": "Spacer4",
                                      "height": 48,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image1",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText9",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film",
                                        "Everything from NFL+ - including Live Out-of-Market Preseason Games, Live Game Audio, and More!"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "height": 0,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 25,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 17,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group3",
                                      "title": "premium list",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition7",
                                          "title": "Condition7",
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.entitlements}",
                                              "expected": "nflplus_premium",
                                              "operator": "notContains"
                                            }
                                          ],
                                          "components": [
                                            {
                                              "id": "group5",
                                              "title": "Group5",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "spacing": 4,
                                              "component": "container",
                                              "direction": "horizontal",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "customList1",
                                                  "title": "Custom List1",
                                                  "width": "100%",
                                                  "spacing": 12,
                                                  "alignment": "left",
                                                  "component": "container",
                                                  "direction": "vertical",
                                                  "components": [
                                                    {
                                                      "id": "listItem0",
                                                      "title": "List Item0",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon0",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon0",
                                                          "fontSize": 16,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText0",
                                                          "text": "Live Local and Primetime Regular and Postseason Games on Mobile",
                                                          "title": "List Item Body Text0",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 16,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    },
                                                    {
                                                      "id": "listItem1",
                                                      "title": "List Item1",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon1",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon1",
                                                          "fontSize": 16,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText1",
                                                          "text": "NFL Films' Programming and More On-Demand Content",
                                                          "title": "List Item Body Text1",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 16,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    },
                                                    {
                                                      "id": "listItem4",
                                                      "title": "List Item4",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon4",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon4",
                                                          "fontSize": 16,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText4",
                                                          "text": "And More!",
                                                          "title": "List Item Body Text4",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 16,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    }
                                                  ],
                                                  "namiComponentType": "customList",
                                                  "conditionAttributes": []
                                                },
                                                {
                                                  "id": "customList2",
                                                  "title": "Custom List2",
                                                  "width": "100%",
                                                  "spacing": 12,
                                                  "alignment": "left",
                                                  "component": "container",
                                                  "direction": "vertical",
                                                  "components": [
                                                    {
                                                      "id": "listItem3",
                                                      "title": "List Item3",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon3",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon3",
                                                          "fontSize": 16,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText3",
                                                          "text": "Live Game Audio",
                                                          "title": "List Item Body Text3",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 16,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    },
                                                    {
                                                      "id": "listItem5",
                                                      "title": "List Item5",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon5",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon5",
                                                          "fontSize": 16,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText5",
                                                          "text": "Ad-Free Highlights",
                                                          "title": "List Item Body Text5",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 16,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    }
                                                  ],
                                                  "namiComponentType": "customList"
                                                }
                                              ],
                                              "topPadding": 0,
                                              "borderColor": "transparent",
                                              "borderWidth": 0,
                                              "leftPadding": 0,
                                              "borderRadius": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "group",
                                              "verticalAlignment": "top",
                                              "horizontalAlignment": "center"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Condition4",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "group4",
                                          "title": "Group4",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "spacing": 4,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "customList",
                                              "title": "Custom List",
                                              "width": "100%",
                                              "spacing": 12,
                                              "alignment": "left",
                                              "component": "container",
                                              "direction": "vertical",
                                              "components": [
                                                {
                                                  "id": "listItem",
                                                  "title": "List Item",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText",
                                                      "text": "Live Local and Primetime Regular and Postseason Games on Mobile",
                                                      "title": "List Item Body Text",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                }
                                              ],
                                              "namiComponentType": "customList"
                                            },
                                            {
                                              "id": "customList0",
                                              "title": "Custom List0",
                                              "width": "100%",
                                              "spacing": 12,
                                              "alignment": "left",
                                              "component": "container",
                                              "direction": "vertical",
                                              "components": [
                                                {
                                                  "id": "listItem2",
                                                  "title": "List Item2",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon2",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon2",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText2",
                                                      "text": "NFL Pro (desktop & mobile web only)",
                                                      "title": "List Item Body Text2",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                }
                                              ],
                                              "namiComponentType": "customList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/04a04dea-a22e-4652-a240-3889b7826045/media/27518240-e175-48f8-88e7-ada868e2d5f0/CrossIcon.png",
                                    "title": "Image2",
                                    "width": "fitContent",
                                    "height": 40,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 18,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 18,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 10,
                                "borderRadius": 0,
                                "rightPadding": 10,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 20,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/04a04dea-a22e-4652-a240-3889b7826045/media/94802b10-fcca-4446-accf-25f3c0e3d21d/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image4",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/04a04dea-a22e-4652-a240-3889b7826045/media/fa02ffe4-91aa-430d-a59f-df1b91e94aab/desk25.jpeg",
                  "title": "BG Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                },
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 500,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "9ca86023-87af-4a24-972e-912160959e8f",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "d4222fcb-57ad-42c8-847d-d0d4f9b3fa07",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "9ca86023-87af-4a24-972e-912160959e8f",
          "selectedProducts": {
            "9ca86023-87af-4a24-972e-912160959e8f": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "d4222fcb-57ad-42c8-847d-d0d4f9b3fa07": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups",
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
      "name": "[RECURLY] Frigate Tablet for Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "b7fa1284-dbf8-405f-ae6f-22bd05e90fc8",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "0f85b83e-ee35-4b87-97e8-d260f79c2138",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/193c11c0-a288-4b4b-8887-66e6ac3aa54c/media/28156783-3e8d-4189-b5ce-defded1754c3/nami-nfl-logo.png",
                  "title": "Image",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 350,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "Live Out-of-Market Preseason Games",
                                                "NFL Network",
                                                "Live Game Audio",
                                                "And More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "productWrapper4",
                                          "title": "Phone List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText3",
                                              "text": "PHONE & TABLET",
                                              "title": "Phone List Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Phone list",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "NFL RedZone",
                                                "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                                "Everything from NFL+"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group3",
                                          "title": "Phone List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText6",
                                              "text": "PHONE & TABLET",
                                              "title": "Phone Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList1",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Phone List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList1BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Desktop Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList3",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Desktop List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList1BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List1 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 260
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 8,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper10",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.BasePriceText}",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${state.orientation}",
                                                  "expected": "portrait",
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "fontSize": 18
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.DurationText}",
                                          "moveY": 0,
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 15,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${state.orientation}",
                                                  "expected": "portrait",
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "moveY": 0,
                                                "fontSize": 11
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 24
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "moveY": 0,
                                            "fontSize": 13
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/193c11c0-a288-4b4b-8887-66e6ac3aa54c/media/33e7658a-65dc-47b0-985d-0759555c2516/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 20,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "group2",
                      "title": "Top Spacer",
                      "width": "100%",
                      "height": 60,
                      "spacing": 10,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "topMargin": "${state.safeAreaTop}",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "b7fa1284-dbf8-405f-ae6f-22bd05e90fc8",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "0f85b83e-ee35-4b87-97e8-d260f79c2138",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "b7fa1284-dbf8-405f-ae6f-22bd05e90fc8",
          "selectedProducts": {
            "b7fa1284-dbf8-405f-ae6f-22bd05e90fc8": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "0f85b83e-ee35-4b87-97e8-d260f79c2138": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "1e08c902-0887-4110-ada6-77d8efff33ad",
      "name": "STM Mobile 2025",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "234b32bb-4819-4e1d-8ed2-c821789e158f",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "4c0a6a69-a8c0-4e0a-b067-5deeca7116d6",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
              "featured": false,
              "name": "[INT] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual_pass",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "newprice": "/$59.99 per year",
                "oldprice": "$99.99",
                "promoKey": null,
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "REDEEM",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.53) 20%, rgba(16 17 25 / 1) 30%)",
              "components": [
                {
                  "id": "titleText",
                  "text": "Click \"Redeem\" Below For a 40% Discount on NFL+ Premium Annual",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 26,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText"
                },
                {
                  "id": "spacer1",
                  "title": "Spacer1",
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText"
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "hidden": true,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image0",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText11",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "Title Text11",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList8",
                                          "texts": [
                                            "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                            "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                          ],
                                          "title": "Bullet List8",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Regular",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List1 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Card Image",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText12",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text12",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                        "NFL RedZone",
                                        "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": false,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": false,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.oldprice}",
                                      "moveY": "40%",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.8)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.newprice}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton"
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "hidden": true,
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "condition7",
                                      "title": "Condition7",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "notContains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "group3",
                                          "title": "Group3",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText1",
                                              "text": "TV, PC, PHONE, & TABLET",
                                              "title": "Title Text1",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Group4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "condition6",
                                      "title": "Condition6",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text3",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        },
                                        {
                                          "id": "group5",
                                          "title": "Group5",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "rgba(215 219 224 / 0.4)",
                              "borderWidth": 0,
                              "borderRadius": 6,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 6,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/1e08c902-0887-4110-ada6-77d8efff33ad/media/e050d33b-1b39-4b23-af06-cec3b8ac83e2/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 24,
                                    "height": 24,
                                    "alignment": "center",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 14,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 6,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText"
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\n\nNFL+ Premium access for this offer will expire on 11:59:59 PM ET on 6/30/2026, regardless of date of redemption.\nSee https://www.nfl.com/legal/subscriptions_terms for additional terms for NFL+ Premium subscription.\n\nPlan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/1e08c902-0887-4110-ada6-77d8efff33ad/media/b6c12c98-d089-4f1e-87eb-358c36fb3e44/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/1e08c902-0887-4110-ada6-77d8efff33ad/media/1d919c85-989b-49e5-85cf-65159ebb87f8/screl_25mob.jpeg",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "234b32bb-4819-4e1d-8ed2-c821789e158f",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "4c0a6a69-a8c0-4e0a-b067-5deeca7116d6",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "4c0a6a69-a8c0-4e0a-b067-5deeca7116d6",
          "selectedProducts": {
            "234b32bb-4819-4e1d-8ed2-c821789e158f": null,
            "4c0a6a69-a8c0-4e0a-b067-5deeca7116d6": "cc279019-e4ec-41cd-950c-cef7bc6eab42"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "1eeabb2b-49c7-44f5-b49d-b3c7d57a6cad",
      "name": "STM Desktop 2025",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "6a0c3c74-6dd1-43db-912d-2220d85c1eb7",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "4910cd86-3332-4ac5-ae3e-68db035b1cc7",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
              "featured": false,
              "name": "[INT] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual_pass",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "REDEEM",
                "Duration": "/${sku.period}",
                "Oldprice": "$99.99",
                "newprice": "/$59.99 per year",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "titleText",
                  "text": "Click \"Redeem\" Below For a 40% Discount on NFL+ Premium Annual",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 35,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText"
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "hidden": true,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 10,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image2",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList7",
                                      "texts": [
                                        "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                        "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                      ],
                                      "title": "Bullet List7",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component0",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer4",
                                      "title": "Spacer4",
                                      "height": 48,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image1",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText9",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                        "NFL RedZone",
                                        "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "titleText10",
                                      "text": "PHONE & TABLET",
                                      "title": "Title Text10",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList8",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Bullet List8",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component0",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText11",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text11",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList9",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List9",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent1",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component1",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "height": 0,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Oldprice}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 26,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.7)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.newprice}",
                                      "moveX": "0%",
                                      "moveY": 0,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 30,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "hidden": true,
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group3",
                                      "title": "premium list",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper6",
                                          "title": "List 1",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText2",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text2",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": ""
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      ""
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper7",
                                          "title": "Product Wrapper7",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Condition4",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "productWrapper8",
                                          "title": "Product Wrapper8",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/1eeabb2b-49c7-44f5-b49d-b3c7d57a6cad/media/c678a97e-2093-45e4-a4c9-ea9845d79672/CrossIcon.png",
                                    "title": "Image2",
                                    "width": "fitContent",
                                    "height": 40,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 18,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 18,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 10,
                                "borderRadius": 0,
                                "rightPadding": 10,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 20,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "hidden": true,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\n\nNFL+ Premium access for this offer will expire on 11:59:59 PM ET on 6/30/2026, regardless of date of redemption.\nSee https://www.nfl.com/legal/subscriptions_terms for additional terms for NFL+ Premium subscription.\n\nPlan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText"
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/1eeabb2b-49c7-44f5-b49d-b3c7d57a6cad/media/0eab8d59-8943-44fb-88ef-c69365d10cdb/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image4",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/1eeabb2b-49c7-44f5-b49d-b3c7d57a6cad/media/bec239df-a0a1-4c78-a668-7b6901c24e2d/screl_25desk.jpeg",
                  "title": "BG Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                },
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 500,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "6a0c3c74-6dd1-43db-912d-2220d85c1eb7",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "4910cd86-3332-4ac5-ae3e-68db035b1cc7",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "4910cd86-3332-4ac5-ae3e-68db035b1cc7",
          "selectedProducts": {
            "6a0c3c74-6dd1-43db-912d-2220d85c1eb7": null,
            "4910cd86-3332-4ac5-ae3e-68db035b1cc7": "cc279019-e4ec-41cd-950c-cef7bc6eab42"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups",
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "29b79180-78ed-4a62-9765-ef41cf061037",
      "name": "Frigate Web Desktop Premium Monthly",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "0c4f92b7-92e7-49ab-83ba-56d6daeb131e",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "premium-all"
        },
        {
          "id": "27745ffd-93b7-4565-b2de-bf909084bfb7",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/29b79180-78ed-4a62-9765-ef41cf061037/media/4475b863-aafd-41f4-aefd-eb499df9b800/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "titleText0",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Title Text0",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 20,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(255 255 255 / 0.9)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 18,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 13,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 22,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 260,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 320,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "PHONE & TABLET",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Bullet List2",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText7",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text7",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/29b79180-78ed-4a62-9765-ef41cf061037/media/9ed9a5d6-999f-4df5-8cc1-d8d379ab6c92/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "0c4f92b7-92e7-49ab-83ba-56d6daeb131e",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "27745ffd-93b7-4565-b2de-bf909084bfb7",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "0c4f92b7-92e7-49ab-83ba-56d6daeb131e",
          "selectedProducts": {
            "0c4f92b7-92e7-49ab-83ba-56d6daeb131e": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "27745ffd-93b7-4565-b2de-bf909084bfb7": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "31f5fdea-f355-4cb8-8b2e-0f2ab01fabac",
      "name": "[RECURLY] Frigate Mobile Web Main // Annual Toggle",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "946ae6de-a0f5-4337-ba55-7c782ea070f1",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "251e6c6f-3a26-44eb-a978-831fb34809f1",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/31f5fdea-f355-4cb8-8b2e-0f2ab01fabac/media/7804a46f-ca8d-4ba1-adcb-7bcd77c971e6/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "Live Out-of-Market Preseason Games",
                                            "NFL Network",
                                            "Live Game Audio",
                                            "And More!"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text7",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList1",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 14,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper10",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.BasePriceText}",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": []
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.DurationText}",
                                          "moveY": 6,
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": []
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 30,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Learn More Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group2",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "namiComponentType": "legalText",
                          "conditionAttributes": []
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/31f5fdea-f355-4cb8-8b2e-0f2ab01fabac/media/68273b44-751e-4ec7-b7db-ef6c86d79303/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "946ae6de-a0f5-4337-ba55-7c782ea070f1",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "251e6c6f-3a26-44eb-a978-831fb34809f1",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "251e6c6f-3a26-44eb-a978-831fb34809f1",
          "selectedProducts": {
            "946ae6de-a0f5-4337-ba55-7c782ea070f1": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "251e6c6f-3a26-44eb-a978-831fb34809f1": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "48440e56-cebd-4faf-934c-f827c6951795",
      "name": "[RECURLY] Frigate Tablet for Mobile Web - Premium Only",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "5d3e9d40-0914-4368-af7c-dbdc852a1355",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "c920bb8d-4ba8-403c-a3fd-e8642e8b8a5a",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/48440e56-cebd-4faf-934c-f827c6951795/media/75ddb0b9-b964-43a5-a871-a767a0b96924/nami-nfl-logo.png",
                  "title": "Image",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 250,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "NFL Network",
                                                "Live Game Audio",
                                                "NFL Films' and More On-Demand Content - All Ad-Free",
                                                "And More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "productWrapper4",
                                          "title": "Phone List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText3",
                                              "text": "PHONE & TABLET",
                                              "title": "Phone List Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Phone list",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "NFL RedZone",
                                                "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                                "Everything from NFL+"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group3",
                                          "title": "Phone List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText6",
                                              "text": "PHONE & TABLET",
                                              "title": "Phone Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList1",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Phone List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList1BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Desktop Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList3",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Desktop List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList1BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List1 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 260
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 14,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper10",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.BasePriceText}",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 25,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${state.orientation}",
                                                  "expected": "portrait",
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "fontSize": 25
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.DurationText}",
                                          "moveY": 0,
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${state.orientation}",
                                                  "expected": "portrait",
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "moveY": 0,
                                                "fontSize": 14
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoPriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[EXPLORE ALL NFL+ PLANS](https://id.nfl.com/select-subscription?p=gc-eeal-nlpsca)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgba(255 255 255 / 0.8)",
                      "linkColor": "rgba(255 255 255 / 0.8)",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/48440e56-cebd-4faf-934c-f827c6951795/media/fad6939a-2e96-440d-8d43-845679f86e92/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 5,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "group2",
                      "title": "Top Spacer",
                      "width": "100%",
                      "height": 60,
                      "spacing": 10,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "topMargin": "${state.safeAreaTop}",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "5d3e9d40-0914-4368-af7c-dbdc852a1355",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "c920bb8d-4ba8-403c-a3fd-e8642e8b8a5a",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "5d3e9d40-0914-4368-af7c-dbdc852a1355",
          "selectedProducts": {
            "5d3e9d40-0914-4368-af7c-dbdc852a1355": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "c920bb8d-4ba8-403c-a3fd-e8642e8b8a5a": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
      "name": "[RECURLY] Frigate Mobile Web Main Premium",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "643753a2-3d44-48f7-b0f1-09075f6352dc",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "premium-all"
        },
        {
          "id": "f8eb9e79-e174-4910-b8d3-26b5f5608922",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/4b44cabb-853b-4ee6-9fd7-a7c522e1de92/media/c56f6669-f57a-48fc-907a-7266cb610998/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "NFL Network ",
                                            "Live Game Audio ",
                                            "NFL Films' and More On-Demand Content - All Ad-Free",
                                            "Fantasy+",
                                            "And More! "
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text7",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList1",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper10",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.BasePriceText}",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": []
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.DurationText}",
                                          "title": "Base Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": []
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 30,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[EXPLORE ALL NFL+ PLANS](https://id.nfl.com/select-subscription?p=gc-eeal-nlpsca)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "rgba(255 255 255 / 0.8)",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/4b44cabb-853b-4ee6-9fd7-a7c522e1de92/media/5377bdd5-0049-4e35-83e6-109d9cb446eb/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "643753a2-3d44-48f7-b0f1-09075f6352dc",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "f8eb9e79-e174-4910-b8d3-26b5f5608922",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "643753a2-3d44-48f7-b0f1-09075f6352dc",
          "selectedProducts": {
            "643753a2-3d44-48f7-b0f1-09075f6352dc": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "f8eb9e79-e174-4910-b8d3-26b5f5608922": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "4d9d4d99-5c1d-4e96-8b80-828524a05883",
      "name": "STM Tablet 2025",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "9c72eaba-2643-48cf-90f1-28e7d4bdb914",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "c0254d85-633b-4961-bd89-4ffc3f343c14",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
              "featured": false,
              "name": "[INT] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual_pass",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "newprice": "/$59.99 per year",
                "oldprice": "$99.99",
                "promoKey": null,
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "REDEEM"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "titleText",
                  "text": "Click \"Redeem\" Below For a 40% Discount on NFL+ Premium Annual",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText"
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "hidden": true,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 250,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                                "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                                "NFL RedZone",
                                                "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Regular",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "productWrapper11",
                                          "title": "Product Wrapper11",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList3",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List3",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List2 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "productWrapper12",
                                          "title": "Product Wrapper12",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText9",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text9",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List2 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 220
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 10,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [],
                                  "orAssertions": [],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.oldprice}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 25,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.57)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.newprice}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "moveY": 0,
                                            "fontSize": 32
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton"
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "hidden": true,
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group2",
                                      "title": "Group2",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper4",
                                          "title": "Product Wrapper4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText6",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text6",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": "PHONE & TABLET"
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "Live Local and Primetime Regular and Postseason Games"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper10",
                                          "title": "Product Wrapper10",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": "DESKTOP & MOBILE WEB ONLY"
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList1",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List1",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "NFL Pro"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/4d9d4d99-5c1d-4e96-8b80-828524a05883/media/3e511e0a-f059-458c-81f7-b4478e98880e/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 28,
                                    "height": 28,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 16,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 0,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\n\nNFL+ Premium access for this offer will expire on 11:59:59 PM ET on 6/30/2026, regardless of date of redemption.\nSee https://www.nfl.com/legal/subscriptions_terms for additional terms for NFL+ Premium subscription.\n\nPlan automatically renews until cancelled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/4d9d4d99-5c1d-4e96-8b80-828524a05883/media/a85e9de6-734b-4477-b559-0ffe55ad50a9/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 20,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/4d9d4d99-5c1d-4e96-8b80-828524a05883/media/db8e40ae-3e2e-43ed-b7c5-15a67caede91/screl_25desk.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "9c72eaba-2643-48cf-90f1-28e7d4bdb914",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "c0254d85-633b-4961-bd89-4ffc3f343c14",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "c0254d85-633b-4961-bd89-4ffc3f343c14",
          "selectedProducts": {
            "9c72eaba-2643-48cf-90f1-28e7d4bdb914": null,
            "c0254d85-633b-4961-bd89-4ffc3f343c14": "cc279019-e4ec-41cd-950c-cef7bc6eab42"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "51c383f6-45cb-46a0-9d62-0192900ab49b",
      "name": "Frigate Web Desktop Premium Annual",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "5177ae08-9a1d-443b-a3f8-27614cf9e8c4",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "premium-all"
        },
        {
          "id": "99422575-f1ce-47a3-9fb2-8d4ff63ab421",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/51c383f6-45cb-46a0-9d62-0192900ab49b/media/227e2a8b-e4ed-43d3-be2d-0b59651fd884/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "titleText0",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Title Text0",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 20,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(255 255 255 / 0.9)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 19,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 22,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 260,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 320,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text7",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList4",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Bullet List4",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent1",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component1",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/51c383f6-45cb-46a0-9d62-0192900ab49b/media/2b56f6da-5545-43c6-ae69-4fd2c7f14310/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "5177ae08-9a1d-443b-a3f8-27614cf9e8c4",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "99422575-f1ce-47a3-9fb2-8d4ff63ab421",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "99422575-f1ce-47a3-9fb2-8d4ff63ab421",
          "selectedProducts": {
            "5177ae08-9a1d-443b-a3f8-27614cf9e8c4": null,
            "99422575-f1ce-47a3-9fb2-8d4ff63ab421": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "532101b7-2ae8-4401-bba7-647d91ed3da0",
      "name": "Internal Coupon Distribution 25 Mobile Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "41dee082-287c-471b-95bb-4e3a92cff93b",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "af0ac83f-ac4a-4b8e-916c-7cc294774a1e",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
              "featured": false,
              "name": "[INT] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual_pass",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "REDEEM",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.53) 20%, rgba(16 17 25 / 1) 30%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 60,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "Click \"Redeem\" Below To Enter Your Coupon Code",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 26,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "spacer1",
                  "title": "Spacer1",
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a yearly subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "hidden": true,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image0",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText11",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "Title Text11",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList8",
                                          "texts": [
                                            "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                            "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                          ],
                                          "title": "Bullet List8",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Regular",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List1 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Card Image",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText12",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text12",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                        "NFL RedZone",
                                        "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "condition7",
                                      "title": "Condition7",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "notContains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "group3",
                                          "title": "Group3",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText1",
                                              "text": "TV, PC, PHONE, & TABLET",
                                              "title": "Title Text1",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Group4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "condition6",
                                      "title": "Condition6",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text3",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        },
                                        {
                                          "id": "group5",
                                          "title": "Group5",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "rgba(215 219 224 / 0.4)",
                              "borderWidth": 0,
                              "borderRadius": 6,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 6,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/532101b7-2ae8-4401-bba7-647d91ed3da0/media/44c69818-dff0-44dc-aff0-2a9139c43a64/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 24,
                                    "height": 24,
                                    "alignment": "center",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 14,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 6,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\nLocal games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/532101b7-2ae8-4401-bba7-647d91ed3da0/media/a63e2251-41cf-48fd-b73b-be14a34de876/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/532101b7-2ae8-4401-bba7-647d91ed3da0/media/dbc9303c-79c6-42a1-a56e-e1e13b4daf70/screl_25mob.jpeg",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "41dee082-287c-471b-95bb-4e3a92cff93b",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "af0ac83f-ac4a-4b8e-916c-7cc294774a1e",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "af0ac83f-ac4a-4b8e-916c-7cc294774a1e",
          "selectedProducts": {
            "41dee082-287c-471b-95bb-4e3a92cff93b": null,
            "af0ac83f-ac4a-4b8e-916c-7cc294774a1e": "cc279019-e4ec-41cd-950c-cef7bc6eab42"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "558e6971-00da-4190-853f-997b63af22d9",
      "name": "Schedule Release 25 Tablet for Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "c7fe8284-4cce-43b7-8de9-953f2363cda9",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "4840ce14-a195-4163-a33c-15308a2f1ffc",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 40,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "EVERY GAME REVEALED!",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a yearly subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 350,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                                "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                                "NFL RedZone",
                                                "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 180
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 10,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "moveY": 4,
                                            "fontSize": 14
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group2",
                                      "title": "Group2",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper4",
                                          "title": "Product Wrapper4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText6",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text6",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": "PHONE & TABLET"
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "Live Local and Primetime Regular and Postseason Games"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper10",
                                          "title": "Product Wrapper10",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": "DESKTOP & MOBILE WEB ONLY"
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList1",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List1",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "NFL Pro"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/558e6971-00da-4190-853f-997b63af22d9/media/671b4a2d-6e91-458b-9d44-c1a35a0d8c1c/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 28,
                                    "height": 28,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 16,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 0,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/558e6971-00da-4190-853f-997b63af22d9/media/4f05852f-51a7-44be-8f94-ef285ff7ab96/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 20,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/558e6971-00da-4190-853f-997b63af22d9/media/425be3d1-99af-4ad9-9c1c-000d84fa081c/screl_25desk.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "c7fe8284-4cce-43b7-8de9-953f2363cda9",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "4840ce14-a195-4163-a33c-15308a2f1ffc",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "c7fe8284-4cce-43b7-8de9-953f2363cda9",
          "selectedProducts": {
            "c7fe8284-4cce-43b7-8de9-953f2363cda9": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "4840ce14-a195-4163-a33c-15308a2f1ffc": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "567322b4-0a00-4feb-be64-24cfb76bb20a",
      "name": "[RECURLY] Frigate Web Desktop Main // Annual Toggle",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "03f3737e-8e17-4f96-887e-cf94cf3c5d95",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "9dcb18de-cf26-4fdf-9bc5-b1c2e948659b",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 12,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/567322b4-0a00-4feb-be64-24cfb76bb20a/media/9237af6c-892e-485e-b701-2d2054fc8a40/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Body Text",
                  "width": "fitContent",
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 20,
                  "textType": "body",
                  "alignment": "left",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "strikethrough": false,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 4,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.Price}",
                                          "moveX": "0%",
                                          "moveY": "0%",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "topMargin": 0,
                                          "leftMargin": 0,
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightMargin": 0,
                                          "bottomMargin": 0,
                                          "rightPadding": 5,
                                          "bottomPadding": 0,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.Duration}",
                                          "moveX": "0%",
                                          "moveY": "0%",
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 13,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "topMargin": 0,
                                          "leftMargin": 0,
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightMargin": 0,
                                          "bottomMargin": 0,
                                          "rightPadding": 5,
                                          "bottomPadding": 0,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 0,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 320,
                                  "spacing": 10,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "Live Out-of-Market Preseason Games",
                                        "NFL Network",
                                        "Live Game Audio",
                                        "And More!"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "top",
                                  "horizontalAlignment": "left"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 320,
                                  "spacing": 10,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All Devices Title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone Tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Web Only",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Web Only list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "top",
                                  "horizontalAlignment": "left"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 24,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 40,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 40,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 24,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/567322b4-0a00-4feb-be64-24cfb76bb20a/media/71db28f1-07ce-4c35-b1cb-fd5e607a98ab/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "03f3737e-8e17-4f96-887e-cf94cf3c5d95",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "9dcb18de-cf26-4fdf-9bc5-b1c2e948659b",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "9dcb18de-cf26-4fdf-9bc5-b1c2e948659b",
          "selectedProducts": {
            "03f3737e-8e17-4f96-887e-cf94cf3c5d95": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "9dcb18de-cf26-4fdf-9bc5-b1c2e948659b": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "6fd723c4-2342-44c5-a0d3-95ae223f95d7",
      "name": "Frigate Mobile Web Base Monthly",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "9d8d879a-dda6-4cc1-bb40-34e86259b85a",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "fbf960e0-b343-47e4-a803-f0e14add60b6",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/6fd723c4-2342-44c5-a0d3-95ae223f95d7/media/802cf4be-3224-4428-90b0-35af7083515c/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "Live Out-of-Market Preseason Games",
                                            "NFL Network",
                                            "Live Game Audio",
                                            "And More!"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 14,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 18,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Learn More Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group2",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "namiComponentType": "legalText",
                          "conditionAttributes": []
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/6fd723c4-2342-44c5-a0d3-95ae223f95d7/media/436a17b8-ea40-43c5-abad-be43d69ed4dd/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "9d8d879a-dda6-4cc1-bb40-34e86259b85a",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "fbf960e0-b343-47e4-a803-f0e14add60b6",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "9d8d879a-dda6-4cc1-bb40-34e86259b85a",
          "selectedProducts": {
            "9d8d879a-dda6-4cc1-bb40-34e86259b85a": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "fbf960e0-b343-47e4-a803-f0e14add60b6": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "70e4fe0e-f372-4e73-ac68-d0876336644b",
      "name": "Frigate Mobile Web Premium Annual",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "ef9d07c1-6cef-4887-a670-1ee494043e14",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "premium-all"
        },
        {
          "id": "80d97ace-505b-4881-8746-8bc59d960525",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/70e4fe0e-f372-4e73-ac68-d0876336644b/media/a74a607b-e640-4080-8ad8-1e30a9c2ce99/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "NFL Network ",
                                            "Live Game Audio ",
                                            "NFL Films' and More On-Demand Content - All Ad-Free",
                                            "Fantasy+",
                                            "And More! "
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                            "Everything from NFL+"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper10",
                                      "title": "Product Wrapper10",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText7",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text7",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList4",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List4",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 18,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/70e4fe0e-f372-4e73-ac68-d0876336644b/media/736b1656-a6fd-4d00-8087-1b43fd04d3ae/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "ef9d07c1-6cef-4887-a670-1ee494043e14",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "80d97ace-505b-4881-8746-8bc59d960525",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "80d97ace-505b-4881-8746-8bc59d960525",
          "selectedProducts": {
            "ef9d07c1-6cef-4887-a670-1ee494043e14": null,
            "80d97ace-505b-4881-8746-8bc59d960525": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
      "name": "[RECURLY] Frigate Mobile Web Main",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "0828c51b-34ec-4420-9358-a8855c1811e6",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "06707a04-9292-4b72-b6c8-84e0855ab547",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc/media/1e62bdc7-63e1-4e31-9f03-f371b0d413cb/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "Live Out-of-Market Preseason Games",
                                            "NFL Network",
                                            "Live Game Audio",
                                            "And More!"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text7",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList1",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 14,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper10",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.BasePriceText}",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": []
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.DurationText}",
                                          "moveY": 6,
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": []
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 30,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Learn More Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group2",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "namiComponentType": "legalText",
                          "conditionAttributes": []
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc/media/07a2599b-39dc-4ca7-a6a8-cc1896bacfc9/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "0828c51b-34ec-4420-9358-a8855c1811e6",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "06707a04-9292-4b72-b6c8-84e0855ab547",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "0828c51b-34ec-4420-9358-a8855c1811e6",
          "selectedProducts": {
            "0828c51b-34ec-4420-9358-a8855c1811e6": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "06707a04-9292-4b72-b6c8-84e0855ab547": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "7f03f50c-0440-4d39-b2b4-330f7b62865e",
      "name": "TV 5.0 Control",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "77d20a40-c00d-42c4-bb11-701a81909b84",
          "name": "NFL+",
          "display_name": "NFL+",
          "products": [],
          "ref": "base"
        },
        {
          "id": "1b1816e0-b77e-4e49-8450-d49a8784e7b9",
          "name": "NFL+ PREMIUM",
          "display_name": "NFL+ PREMIUM",
          "products": [],
          "ref": "premium-all"
        }
      ],
      "template": {
        "id": "b5d17618-937d-4304-9dc1-215be7ef3904",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 36,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Header Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group1",
                      "title": "Left Side of Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image",
                          "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/7f03f50c-0440-4d39-b2b4-330f7b62865e/media/395762a2-3509-4b3b-b2c3-4bc128950611/nami-nfl-logo.png",
                          "title": "Logo",
                          "width": "100%",
                          "height": 66,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "titleText1",
                      "text": "LIMITED TIME OFFER",
                      "title": "Header Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 45,
                      "textType": "title",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "group2",
                      "title": "Right Side of Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "right",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition1",
                          "title": "Show Login",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.isLoggedIn}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "fitContent",
                              "height": 52,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "ALREADY A SUBSCRIBER?",
                                  "title": "Login Button Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgba(29 29 37 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "rgb(255 255 255 / 1)",
                              "fillColorFallback": "transparent",
                              "namiComponentType": "loginButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "rgb(255 255 255 / 1)"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition",
                          "title": "Show TV Provider Signin?",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${launch.customAttributes.hideMVPDSignin}",
                              "expected": true,
                              "operator": "notSet"
                            }
                          ],
                          "components": [
                            {
                              "id": "deeplinkButton",
                              "url": "SIGN_IN_TV_PROVIDER",
                              "onTap": {
                                "function": "namiDeeplink",
                                "parameters": {
                                  "url": "SIGN_IN_TV_PROVIDER"
                                }
                              },
                              "title": "TV Provider Signin",
                              "width": "fitContent",
                              "height": 56,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "deeplinkButtonButtonText",
                                  "text": "SIGN IN WITH TV PROVIDER",
                                  "title": "Deeplink Button Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgba(29 29 37 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "rgb(255 255 255 / 1)",
                              "namiComponentType": "deeplinkButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8
                            }
                          ],
                          "namiComponentType": "condition"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group3",
                  "title": "Main Card Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 0,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group6",
                      "title": "Badge",
                      "width": "100%",
                      "height": 48,
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "rgba(0 79 255 / 1)",
                      "components": [
                        {
                          "id": "titleText6",
                          "text": "GET 20% OFF AN NFL+ ANNUAL PLAN",
                          "title": "Banner Text",
                          "width": "100%",
                          "fontName": "All-ProSans-Bold",
                          "fontSize": 25,
                          "textType": "title",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "titleText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 16,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "group4",
                      "title": "Main Card",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 24,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(29 29 37 / 1)",
                      "components": [
                        {
                          "id": "titleText",
                          "text": "NFL+ PREMIUM",
                          "title": "Title Text",
                          "width": "100%",
                          "fontName": "All-ProDisplayC-BoldItalic",
                          "fontSize": 56,
                          "textType": "title",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "titleText",
                          "conditionAttributes": []
                        },
                        {
                          "id": "group7",
                          "title": "Value Props Gallery",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 24,
                          "alignment": "center",
                          "component": "container",
                          "direction": "horizontal",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "group11",
                              "title": "Feature 4",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/league/apps/ctv/image/CTV_UpsellScreen_NFL_Plus_NFLPreseason.png",
                                  "title": "Feature 4 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText2",
                                  "text": "Watch live out-of-market preseason games.",
                                  "title": "Feature 4 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider1",
                              "title": "Divider 3",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group8",
                              "title": "Feature 1",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-redzone.png",
                                  "title": "Feature 1 Text",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText",
                                  "text": "Watch every touchdown, every Sunday afternoon during the regular sesason.",
                                  "title": "Text 1",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider",
                              "title": "Divider",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group9",
                              "title": "Feature 2",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Feature 2 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText0",
                                  "text": "Stream NFL Network 24/7, including seven exclusive live games in the 2025 NFL season.",
                                  "title": "Feature 2 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider0",
                              "title": "Divider 2",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group10",
                              "title": "Feature 3",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-gamereplays.png",
                                  "title": "Feature 3 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText1",
                                  "text": "Watch full and condensed game replays.",
                                  "title": "Feature 3 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        },
                        {
                          "id": "bodyText3",
                          "text": "AND MORE...",
                          "title": "Body Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        },
                        {
                          "id": "productContainer0",
                          "title": "Pro Product Group",
                          "width": "100%",
                          "spacing": 20,
                          "products": "subset",
                          "alignment": "center",
                          "component": "productContainer",
                          "direction": "horizontal",
                          "components": [
                            {
                              "id": "productButton0",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 96,
                              "spacing": 8,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "rgba(57 62 74 / 1)",
                              "components": [
                                {
                                  "id": "productWrapper",
                                  "title": "Product Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "condition6",
                                      "title": "Show Base Price",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText6",
                                          "text": "${sku.CurrentPriceDurationText}",
                                          "moveY": "12%",
                                          "title": "Product Text6",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 25,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "rightMargin": 10,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "productDisplayText0",
                                      "text": "${sku.productDisplayTextText}",
                                      "title": "Product Current Price",
                                      "width": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "focusedFontColor": "rgb(255 255 255 / 1)",
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroCurrentPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoproductDisplayTextText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText",
                                      "text": "${sku.DurationText}",
                                      "moveY": 7,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                },
                                {
                                  "id": "condition5",
                                  "title": "Show Subtext",
                                  "hidden": true,
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText3",
                                      "text": "${sku.TrialSubtext}",
                                      "title": "Product Text3",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroSubtext}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoTrialSubtext}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.freeTrialEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(84 90 104 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "focusedFillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "namiComponentType": "productButton",
                              "focusedBorderColor": "rgba(51 114 255 / 1)",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                            }
                          ],
                          "topPadding": 20,
                          "leftPadding": 0,
                          "subsetGroup": "${state.groups.1.id}",
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "productContainer"
                        }
                      ],
                      "topPadding": 40,
                      "borderColor": "rgba(29 29 37 / 1)",
                      "borderWidth": 0,
                      "leftPadding": 24,
                      "borderRadius": 16,
                      "rightPadding": 24,
                      "roundBorders": [
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 40,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "focusedBorderColor": "#ffffff",
                  "focusedBorderWidth": 2,
                  "focusedBorderRadius": 16
                },
                {
                  "id": "group5",
                  "title": "Secondary CTAs",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "navigatePageButton",
                      "onTap": {
                        "function": "namiNavigateToScreen",
                        "parameters": {
                          "screen": "page2"
                        }
                      },
                      "title": "Navigate Page Button",
                      "width": "100%",
                      "height": 72,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "rgba(0 79 255 / 1)",
                      "components": [
                        {
                          "id": "navigatePageButtonButtonText",
                          "text": "MORE PLANS",
                          "title": "Navigate Page Button Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgba(29 29 37 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 28,
                      "borderRadius": 8,
                      "rightPadding": 28,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "namiComponentType": "navigatePageButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8
                    },
                    {
                      "id": "restoreButton",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "100%",
                      "height": 72,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButtonButtonText",
                          "text": "RESTORE PURCHASE",
                          "title": "Restore Button Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgba(29 29 37 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 28,
                      "borderRadius": 8,
                      "rightPadding": 28,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "fillColorFallback": "transparent",
                      "namiComponentType": "restoreButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "#eeeeee"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 500,
                  "borderRadius": 0,
                  "rightPadding": 500,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "legalText",
                  "text": "Terms and Conditions Apply: nfl.com/terms. Promotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Live preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                  "title": "Legal Text",
                  "width": "100%",
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "legal",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(198 203 215 / 1)",
                  "linkColor": "rgba(198 203 215 / 1)",
                  "leftPadding": 120,
                  "rightPadding": 120,
                  "namiComponentType": "legalText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Terms and Conditions Apply: nfl.com/terms. Promotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Live preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                      }
                    }
                  ]
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [],
              "namiComponentType": "group"
            }
          },
          {
            "name": "page2",
            "footer": null,
            "header": [],
            "contentContainer": {
              "id": "contentContainer0",
              "title": "Content Container",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group12",
                  "title": "Header Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 20,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group13",
                      "title": "Left Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "left",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image1",
                          "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/7f03f50c-0440-4d39-b2b4-330f7b62865e/media/395762a2-3509-4b3b-b2c3-4bc128950611/nami-nfl-logo.png",
                          "title": "Logo",
                          "width": "100%",
                          "height": 66,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "titleText2",
                      "text": "READY FOR FOOTBALL?",
                      "title": "Title Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 45,
                      "textType": "title",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "LIMITED TIME OFFER"
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group14",
                      "title": "Right Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "right",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition2",
                          "title": "Show Login?",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.isLoggedIn}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "loginButton1",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button1",
                              "width": "fitContent",
                              "height": 52,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButton1ButtonText",
                                  "text": "ALREADY A SUBSCRIBER?",
                                  "title": "Login Button1 Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgb(0 0 0 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "#eeeeee",
                              "fillColorFallback": "transparent",
                              "namiComponentType": "loginButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "#eeeeee"
                            }
                          ],
                          "namiComponentType": "condition"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group15",
                  "title": "Card Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 20,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group20",
                      "title": "Base Card Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "spacer",
                          "title": "Badge Spacer",
                          "height": 48,
                          "component": "spacer",
                          "namiComponentType": "spacer"
                        },
                        {
                          "id": "group16",
                          "title": "Base Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 32,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText3",
                              "text": "NFL+",
                              "title": "Base Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            },
                            {
                              "id": "hostedImage3",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Base Image",
                              "width": "100%",
                              "height": 48,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image"
                            },
                            {
                              "id": "bulletList",
                              "texts": [
                                "Watch LIVE out-of-market preseason games",
                                "Watch LIVE NFL Network",
                                "Watch LIVE local and primetime regular and postseason games on mobile"
                              ],
                              "title": "Base List",
                              "width": "100%",
                              "spacing": 12,
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 24,
                              "textType": "body",
                              "alignment": "left",
                              "component": "text-list",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "bulletComponent": {
                                "id": "bulletListBulletComponent",
                                "name": "CheckOutlined",
                                "title": "Bullet List Bullet Component",
                                "fontSize": 24,
                                "component": "symbol",
                                "fontColor": "rgba(198 203 215 / 1)",
                                "namiComponentType": "bulletComponent"
                              },
                              "namiComponentType": "bulletList"
                            },
                            {
                              "id": "productContainer1",
                              "title": "Base Product Group",
                              "width": "100%",
                              "spacing": 32,
                              "products": "subset",
                              "alignment": "center",
                              "component": "productContainer",
                              "direction": "horizontal",
                              "components": [
                                {
                                  "id": "productButton1",
                                  "onTap": {
                                    "function": "namiBuySKU"
                                  },
                                  "title": "Product Button",
                                  "width": "100%",
                                  "height": 72,
                                  "spacing": 3,
                                  "alignment": "center",
                                  "component": "button",
                                  "direction": "vertical",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "productWrapper1",
                                      "title": "Price Duration Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition7",
                                          "title": "Show Base Price",
                                          "component": "condition",
                                          "components": [
                                            {
                                              "id": "productText7",
                                              "text": "${sku.CurrentPriceDurationText}",
                                              "moveY": "12%",
                                              "title": "Product Text7",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "fontName": "All-ProDisplayC-Bold",
                                              "fontSize": 22,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(255 255 255 / 0.5)",
                                              "strikethrough": true,
                                              "namiComponentType": "productText"
                                            }
                                          ],
                                          "orAssertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            },
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        },
                                        {
                                          "id": "productDisplayText1",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Price",
                                          "width": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 28,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "focusedFontColor": "rgb(255 255 255 / 1)",
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroCurrentPriceText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoproductDisplayTextText}"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText1",
                                          "text": "${sku.DurationText}",
                                          "moveY": 5,
                                          "title": "Product Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroDurationText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoDurationText}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "condition3",
                                      "title": "Show Subtext",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText4",
                                          "text": "${sku.TrialSubtext}",
                                          "title": "Trial Subtext",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "hidden": true,
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroSubtext}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoTrialSubtext}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(57 62 74 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 15,
                                  "borderRadius": 8,
                                  "rightPadding": 15,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "productButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 20,
                              "leftPadding": 0,
                              "subsetGroup": "${state.groups.0.id}",
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productContainer"
                            }
                          ],
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "borderRadius": 16,
                          "rightPadding": 48,
                          "bottomPadding": 48,
                          "namiComponentType": "group",
                          "focusedBorderColor": "#ffffff",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 16
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "group21",
                      "title": "Premium Card Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "group22",
                          "title": "Premium Badge",
                          "width": "100%",
                          "height": 48,
                          "spacing": 16,
                          "alignment": "center",
                          "component": "container",
                          "direction": "horizontal",
                          "fillColor": "rgba(0 79 255 / 1)",
                          "components": [
                            {
                              "id": "titleText5",
                              "text": "GET MORE NFL GAMES",
                              "title": "Premium Badge Text",
                              "width": "100%",
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 22,
                              "textType": "title",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "attributes": {
                                    "text": "GET 20% OFF AN NFL+ ANNUAL PLAN"
                                  },
                                  "orAssertions": [
                                    {
                                      "value": "${state.anySkuHasIntroOffer}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${state.anySkuHasPromoOffer}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 16,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        },
                        {
                          "id": "group17",
                          "title": "Premium Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 32,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText4",
                              "text": "NFL+ PREMIUM",
                              "title": "Premium Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            },
                            {
                              "id": "hostedImage4",
                              "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png",
                              "title": "Premium Image",
                              "width": "100%",
                              "height": 48,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image"
                            },
                            {
                              "id": "group19",
                              "title": "Group19",
                              "width": "100%",
                              "height": 135,
                              "spacing": 16,
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "bulletList0",
                                  "texts": [
                                    "Everything from NFL+​",
                                    "NFL RedZone ",
                                    "Game Replays - Full, Condensed, and All-22 Coaches Film"
                                  ],
                                  "title": "Premium List",
                                  "width": "100%",
                                  "spacing": 12,
                                  "fontName": "All-ProSans-Regular",
                                  "fontSize": 24,
                                  "textType": "body",
                                  "alignment": "left",
                                  "component": "text-list",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "bulletComponent": {
                                    "id": "bulletList0BulletComponent",
                                    "name": "CheckOutlined",
                                    "title": "Bullet List Bullet Component",
                                    "fontSize": 24,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "bulletComponent"
                                  },
                                  "namiComponentType": "bulletList"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "top",
                              "horizontalAlignment": "center"
                            },
                            {
                              "id": "productContainer2",
                              "title": "Premium Product Group",
                              "width": "100%",
                              "spacing": 32,
                              "products": "subset",
                              "alignment": "center",
                              "component": "productContainer",
                              "direction": "horizontal",
                              "components": [
                                {
                                  "id": "productButton2",
                                  "onTap": {
                                    "function": "namiBuySKU"
                                  },
                                  "title": "Product Button2",
                                  "width": "100%",
                                  "height": 72,
                                  "spacing": 6,
                                  "alignment": "center",
                                  "component": "button",
                                  "direction": "vertical",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "productWrapper2",
                                      "title": "Price Duration Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition8",
                                          "title": "Show Base Price",
                                          "component": "condition",
                                          "components": [
                                            {
                                              "id": "productText8",
                                              "text": "${sku.CurrentPriceDurationText}",
                                              "moveY": "12%",
                                              "title": "Product Text8",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "fontName": "All-ProDisplayC-Bold",
                                              "fontSize": 22,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(255 255 255 / 0.5)",
                                              "strikethrough": true,
                                              "namiComponentType": "productText"
                                            }
                                          ],
                                          "orAssertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            },
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        },
                                        {
                                          "id": "productDisplayText2",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Price Text",
                                          "width": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 28,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "focusedFontColor": "rgb(255 255 255 / 1)",
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroCurrentPriceText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoproductDisplayTextText}"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText2",
                                          "text": "${sku.DurationText}",
                                          "moveY": 5,
                                          "title": "Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoDurationText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroDurationText}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Show Subtext",
                                      "hidden": true,
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText5",
                                          "text": "${sku.TrialSubtext}",
                                          "title": "Product Subtext",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroSubtext}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoTrialSubtext}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(57 62 74 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 15,
                                  "borderRadius": 8,
                                  "rightPadding": 15,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "productButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 20,
                              "leftPadding": 0,
                              "subsetGroup": "${state.groups.1.id}",
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productContainer"
                            }
                          ],
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "borderRadius": 16,
                          "rightPadding": 48,
                          "roundBorders": [
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "group"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 16
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group18",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "restoreButton1",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "fitContent",
                      "height": 52,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButton1ButtonText",
                          "text": "RESTORE PURCHASE",
                          "title": "Restore Button Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 16,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgb(0 0 0 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 16,
                      "borderRadius": 8,
                      "rightPadding": 16,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "fillColorFallback": "transparent",
                      "namiComponentType": "restoreButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "#eeeeee"
                    },
                    {
                      "id": "legalText0",
                      "text": "Terms and Conditions Apply: nfl.com/terms. Promotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Live preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "leftPadding": 120,
                      "rightPadding": 120,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "Terms and Conditions Apply: nfl.com/terms. Promotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Live preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          }
                        }
                      ]
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer0",
              "title": "Background Container",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "5.0",
        "codename": "Frigate TV 2 Page (2024)",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tv",
        "changelog": "Improved promotional offer purchasing",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "77d20a40-c00d-42c4-bb11-701a81909b84",
              "displayName": "NFL+",
              "ref": "base"
            },
            {
              "id": "1b1816e0-b77e-4e49-8450-d49a8784e7b9",
              "displayName": "NFL+ PREMIUM",
              "ref": "premium-all"
            }
          ],
          "currentGroupId": "77d20a40-c00d-42c4-bb11-701a81909b84",
          "selectedProducts": {
            "77d20a40-c00d-42c4-bb11-701a81909b84": null,
            "1b1816e0-b77e-4e49-8450-d49a8784e7b9": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "product_groups",
          "multipage",
          "deeplink",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer"
        ],
        "displaySingleGroup": false
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
      "name": "[RECURLY] Frigate Web Desktop Main",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "00c4cf14-58e1-459f-9074-99d7eedb0185",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "c63d7feb-b5f6-4f2f-bdc0-fb116ef9f0a0",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 12,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/7fc627f3-a98f-4ad9-9496-0f568bee6dce/media/b740df82-a2b8-4c95-ac01-4432db720b03/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Body Text",
                  "width": "fitContent",
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 20,
                  "textType": "body",
                  "alignment": "left",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "strikethrough": false,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 4,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.Price}",
                                          "moveX": "0%",
                                          "moveY": "0%",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "topMargin": 0,
                                          "leftMargin": 0,
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightMargin": 0,
                                          "bottomMargin": 0,
                                          "rightPadding": 5,
                                          "bottomPadding": 0,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.Duration}",
                                          "moveX": "0%",
                                          "moveY": "0%",
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 13,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "topMargin": 0,
                                          "leftMargin": 0,
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightMargin": 0,
                                          "bottomMargin": 0,
                                          "rightPadding": 5,
                                          "bottomPadding": 0,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 0,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 320,
                                  "spacing": 10,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "Live Out-of-Market Preseason Games",
                                        "NFL Network",
                                        "Live Game Audio",
                                        "And More!"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "top",
                                  "horizontalAlignment": "left"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 320,
                                  "spacing": 10,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All Devices Title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone Tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Web Only",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Web Only list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "top",
                                  "horizontalAlignment": "left"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 24,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 40,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 40,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 24,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/7fc627f3-a98f-4ad9-9496-0f568bee6dce/media/decef656-4f67-46f0-8e32-7fa77f908f5c/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "00c4cf14-58e1-459f-9074-99d7eedb0185",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "c63d7feb-b5f6-4f2f-bdc0-fb116ef9f0a0",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "00c4cf14-58e1-459f-9074-99d7eedb0185",
          "selectedProducts": {
            "00c4cf14-58e1-459f-9074-99d7eedb0185": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "c63d7feb-b5f6-4f2f-bdc0-fb116ef9f0a0": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "87333cdc-c3e1-4474-881b-89463a7621b1",
      "name": "Frigate Desktop Base Monthly",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "a7bce090-fdfd-441d-8c34-e573bb6bb157",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "e210b98a-705b-44ce-8c31-cb52fee54d11",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/87333cdc-c3e1-4474-881b-89463a7621b1/media/eab7905b-1bbe-415d-bdd9-f2d0898374c1/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "titleText0",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Title Text0",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 25,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(255 255 255 / 0.8)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "hidden": true,
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 22,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 230,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "Live Out-of-Market Preseason Games",
                                        "NFL Network",
                                        "Live Game Audio",
                                        "And More!"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 290,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/87333cdc-c3e1-4474-881b-89463a7621b1/media/508b3cec-7bc5-47d8-af63-90e88a551da7/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "a7bce090-fdfd-441d-8c34-e573bb6bb157",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "e210b98a-705b-44ce-8c31-cb52fee54d11",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "a7bce090-fdfd-441d-8c34-e573bb6bb157",
          "selectedProducts": {
            "a7bce090-fdfd-441d-8c34-e573bb6bb157": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "e210b98a-705b-44ce-8c31-cb52fee54d11": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "8c94e6ba-f8f1-4e9d-8df1-2f87e6323982",
      "name": "Schedule Release 25 Desktop",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "24f566cb-488a-4c15-aa67-aced30f92167",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "ae497e45-0b5a-4c93-a75e-0835ecd9fd30",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "spacer2",
                  "title": "Spacer2",
                  "height": 20,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "EVERY GAME REVEALED!",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 40,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 10,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image2",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList7",
                                      "texts": [
                                        "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                        "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                      ],
                                      "title": "Bullet List7",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component0",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer4",
                                      "title": "Spacer4",
                                      "height": 48,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image1",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText9",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                        "NFL RedZone",
                                        "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "height": 0,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group3",
                                      "title": "premium list",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper6",
                                          "title": "List 1",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText2",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text2",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": ""
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      ""
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper7",
                                          "title": "Product Wrapper7",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Condition4",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "productWrapper8",
                                          "title": "Product Wrapper8",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/8c94e6ba-f8f1-4e9d-8df1-2f87e6323982/media/6b7e875a-92b8-41d7-b3f5-0cd58471f1fd/CrossIcon.png",
                                    "title": "Image2",
                                    "width": "fitContent",
                                    "height": 40,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 18,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 18,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 10,
                                "borderRadius": 0,
                                "rightPadding": 10,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 20,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\nLocal games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/8c94e6ba-f8f1-4e9d-8df1-2f87e6323982/media/d5e7c2fa-d482-41e4-a39a-8f419f5068ca/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image4",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/8c94e6ba-f8f1-4e9d-8df1-2f87e6323982/media/927c6080-913b-43ad-bb0b-56cf6d3406c7/screl_25desk.jpeg",
                  "title": "BG Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                },
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 500,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "24f566cb-488a-4c15-aa67-aced30f92167",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "ae497e45-0b5a-4c93-a75e-0835ecd9fd30",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "24f566cb-488a-4c15-aa67-aced30f92167",
          "selectedProducts": {
            "24f566cb-488a-4c15-aa67-aced30f92167": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "ae497e45-0b5a-4c93-a75e-0835ecd9fd30": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups",
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "917764d9-a0de-4bab-837a-49de1808b651",
      "name": "WK17 Desktop Tripleheader Games",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "8e0d392e-a46b-445a-9ed8-46d9abce6d79",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "8728648b-e784-4c27-b137-c8fba39226ce",
              "featured": false,
              "name": "NFL+ Monthly",
              "sku_ref_id": "S533943165",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "7b1cc241-3678-4f03-ba16-34131f488903",
              "featured": false,
              "name": "NFL+ Premium Monthly",
              "sku_ref_id": "S176422819",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "5c92936b-d420-49fd-86db-880e1ed08b2d",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "086b7e07-a10e-4297-9a94-1f3dbc4ca8ee",
              "featured": false,
              "name": "NFL+ Annual",
              "sku_ref_id": "S749091632",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            },
            {
              "id": "7cc0c0dd-2364-4b0e-ba68-3f4a38e6ed4c",
              "featured": false,
              "name": "NFL+ Premium Annual",
              "sku_ref_id": "S115046355",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.05) 0%, RGBA(16 17 25 / 0.45) 20%, rgba(16 17 25 / 1) 35%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "spacer2",
                  "title": "Spacer2",
                  "height": 200,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "condition7",
                  "title": "Show Group Toggle?",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.productGroups}",
                      "expected": "${state.groups.0.ref}",
                      "operator": "contains"
                    }
                  ],
                  "components": [
                    {
                      "id": "productGroupToggle",
                      "onTap": {
                        "function": "setState",
                        "parameters": {
                          "partialState": {
                            "currentGroupId": "${inactiveSegmentPickerId}"
                          }
                        }
                      },
                      "title": "Product Group Toggle",
                      "width": 210,
                      "height": 45,
                      "component": "segmentPicker",
                      "direction": "horizontal",
                      "fillColor": "rgba(255 255 255 / 0.1)",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "${state.groups.0.id}",
                          "text": "${state.groups.0.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 14,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 14,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        },
                        {
                          "id": "${state.groups.1.id}",
                          "text": "${state.groups.1.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 14,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 14,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 2,
                      "borderColor": "rgba(255 255 255 / 0.3)",
                      "borderWidth": 2,
                      "leftPadding": 2,
                      "rightMargin": 0,
                      "borderRadius": 30,
                      "bottomMargin": 10,
                      "rightPadding": 2,
                      "bottomPadding": 2,
                      "namiComponentType": "productGroupToggle"
                    }
                  ],
                  "namiComponentType": "condition"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList7",
                                      "texts": [
                                        "Watch the Tripleheader this Saturday, Dec. 28th, starting at 1pm ET only on NFL Network, also streaming with NFL+.​"
                                      ],
                                      "title": "Bullet List7",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component0",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer4",
                                      "title": "Spacer4",
                                      "height": 55,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image1",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "titleText9",
                                  "text": "TV, PC, PHONE & TABLET",
                                  "title": "Title Text9",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 16,
                                  "textType": "title",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "titleText"
                                },
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group3",
                                      "title": "premium list",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper6",
                                          "title": "List 1",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText2",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text2",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network",
                                                "Live Game Audio",
                                                "NFL Films' and More On-Demand Content - All Ad-Free",
                                                "And More!"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "Everything from NFL+ - including NFL Network, Live Game Audio, NFL Films' and On-Demand Content, and More!"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper7",
                                          "title": "Product Wrapper7",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Condition4",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "productWrapper8",
                                          "title": "Product Wrapper8",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/917764d9-a0de-4bab-837a-49de1808b651/media/d201ca44-52a2-4e23-b34b-05dad659e6be/CrossIcon.png",
                                    "title": "Image2",
                                    "width": "fitContent",
                                    "height": 40,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 18,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 18,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 10,
                                "borderRadius": 0,
                                "rightPadding": 10,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 20,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\n**Yearly plans begin on signup and renew on the date prior to the next NFL regular season.**\n\nLocal games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/917764d9-a0de-4bab-837a-49de1808b651/media/12719b1e-285b-4d12-8c13-bdd59c1486a3/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image4",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/917764d9-a0de-4bab-837a-49de1808b651/media/eb36e9ab-2279-4a7d-a5cc-7dcbf957d385/updtripheddes.jpeg",
                  "title": "BG Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                },
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 500,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "8e0d392e-a46b-445a-9ed8-46d9abce6d79",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "5c92936b-d420-49fd-86db-880e1ed08b2d",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "8e0d392e-a46b-445a-9ed8-46d9abce6d79",
          "selectedProducts": {
            "8e0d392e-a46b-445a-9ed8-46d9abce6d79": "7b1cc241-3678-4f03-ba16-34131f488903",
            "5c92936b-d420-49fd-86db-880e1ed08b2d": "7cc0c0dd-2364-4b0e-ba68-3f4a38e6ed4c"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups",
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "960bfa15-d5b4-47e3-b86a-53aad4ea9a33",
      "name": "Internal Coupon Distribution 25 Desktop",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "c1c4ec7b-e35c-4815-aa7c-c509971ce89b",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "abe0a40d-4abe-4c60-8183-beeeeb2bf821",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
              "featured": false,
              "name": "[INT] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual_pass",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "REDEEM",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "spacer2",
                  "title": "Spacer2",
                  "height": 20,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "Click \"Redeem\" Below To Enter Your Coupon Code",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 40,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "hidden": true,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 10,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image2",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList7",
                                      "texts": [
                                        "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                        "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                      ],
                                      "title": "Bullet List7",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component0",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer4",
                                      "title": "Spacer4",
                                      "height": 48,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image1",
                                  "width": "100%",
                                  "height": 32,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText9",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                        "NFL RedZone",
                                        "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "height": 0,
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group3",
                                      "title": "premium list",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper6",
                                          "title": "List 1",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText2",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text2",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": ""
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      ""
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper7",
                                          "title": "Product Wrapper7",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Condition4",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "productWrapper8",
                                          "title": "Product Wrapper8",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/960bfa15-d5b4-47e3-b86a-53aad4ea9a33/media/b0c364db-0750-4c50-973e-e1675dc9eedf/CrossIcon.png",
                                    "title": "Image2",
                                    "width": "fitContent",
                                    "height": 40,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 18,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 18,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 10,
                                "borderRadius": 0,
                                "rightPadding": 10,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 20,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "hidden": true,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\nLocal games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/960bfa15-d5b4-47e3-b86a-53aad4ea9a33/media/56a86742-a96c-414c-9dd1-995d2771b7bb/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image4",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/960bfa15-d5b4-47e3-b86a-53aad4ea9a33/media/d1793b3e-61e2-42b3-92de-4b4281d31893/screl_25desk.jpeg",
                  "title": "BG Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                },
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 500,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "c1c4ec7b-e35c-4815-aa7c-c509971ce89b",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "abe0a40d-4abe-4c60-8183-beeeeb2bf821",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "abe0a40d-4abe-4c60-8183-beeeeb2bf821",
          "selectedProducts": {
            "c1c4ec7b-e35c-4815-aa7c-c509971ce89b": null,
            "abe0a40d-4abe-4c60-8183-beeeeb2bf821": "cc279019-e4ec-41cd-950c-cef7bc6eab42"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups",
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "9e2addb5-752b-40c8-824e-e50997379b1f",
      "name": "Frigate Mobile Web Base Annual",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "bd1e10cc-a5cf-47db-8550-349762d21fe5",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "8187464c-8e45-401f-93fc-808bf4aaf125",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/9e2addb5-752b-40c8-824e-e50997379b1f/media/01409072-e28f-4d83-adda-a4a96d0160b4/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "Live Out-of-Market Preseason Games",
                                            "NFL Network",
                                            "Live Game Audio",
                                            "And More!"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 14,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 18,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Learn More Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group2",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "namiComponentType": "legalText",
                          "conditionAttributes": []
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/9e2addb5-752b-40c8-824e-e50997379b1f/media/e8892d63-3101-4991-952e-f5975096ccce/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "bd1e10cc-a5cf-47db-8550-349762d21fe5",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "8187464c-8e45-401f-93fc-808bf4aaf125",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "8187464c-8e45-401f-93fc-808bf4aaf125",
          "selectedProducts": {
            "bd1e10cc-a5cf-47db-8550-349762d21fe5": null,
            "8187464c-8e45-401f-93fc-808bf4aaf125": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "a56ae1f7-4535-4154-b1f0-10b238062405",
      "name": "WK17 Mobile Web Tripleheader Games",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "ae8385bb-5ff6-40f4-9762-1a7e284b9d19",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "8728648b-e784-4c27-b137-c8fba39226ce",
              "featured": false,
              "name": "NFL+ Monthly",
              "sku_ref_id": "S533943165",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "7b1cc241-3678-4f03-ba16-34131f488903",
              "featured": false,
              "name": "NFL+ Premium Monthly",
              "sku_ref_id": "S176422819",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "7726b1df-abbf-4629-bc15-83039a53538e",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "086b7e07-a10e-4297-9a94-1f3dbc4ca8ee",
              "featured": false,
              "name": "NFL+ Annual",
              "sku_ref_id": "S749091632",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "7cc0c0dd-2364-4b0e-ba68-3f4a38e6ed4c",
              "featured": false,
              "name": "NFL+ Premium Annual",
              "sku_ref_id": "S115046355",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.06) 0%, RGBA(16 17 25 / 0.43) 20%, rgba(16 17 25 / 1) 70%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 120,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a yearly subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "condition4",
                  "title": "Show Toggle",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.productGroups}",
                      "expected": "${state.groups.0.ref}",
                      "operator": "contains"
                    }
                  ],
                  "components": [
                    {
                      "id": "productGroupToggle",
                      "onTap": {
                        "function": "setState",
                        "parameters": {
                          "partialState": {
                            "currentGroupId": "${inactiveSegmentPickerId}"
                          }
                        }
                      },
                      "title": "Product Group Toggle",
                      "width": 184,
                      "height": 49,
                      "component": "segmentPicker",
                      "direction": "horizontal",
                      "fillColor": "rgba(255 255 255 / 0.1)",
                      "components": [
                        {
                          "id": "${state.groups.0.id}",
                          "text": "${state.groups.0.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 12,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 12,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        },
                        {
                          "id": "${state.groups.1.id}",
                          "text": "${state.groups.1.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 12,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 12,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "topPadding": 2,
                      "borderColor": "rgba(255 255 255 / 0.3)",
                      "borderWidth": 2,
                      "leftPadding": 2,
                      "borderRadius": 30,
                      "rightPadding": 2,
                      "bottomPadding": 2,
                      "namiComponentType": "productGroupToggle"
                    }
                  ],
                  "namiComponentType": "condition"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText11",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "Title Text11",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList8",
                                          "texts": [
                                            "Watch the Tripleheader this Saturday, Dec. 28th, starting at 1pm ET only on NFL Network, also streaming with NFL+.​"
                                          ],
                                          "title": "Bullet List8",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Regular",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List1 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Card Image",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText12",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text12",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free",
                                        "Everything from NFL+ - including NFL Network, Live Game Audio, NFL Films' and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "condition7",
                                      "title": "Condition7",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "notContains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "group4",
                                          "title": "Group4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "group3",
                                          "title": "Group3",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText1",
                                              "text": "TV, PC, PHONE, & TABLET",
                                              "title": "Title Text1",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network",
                                                "Live Game Audio",
                                                "NFL Films' and More On-Demand Content - All Ad-Free",
                                                "And More!"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "condition6",
                                      "title": "Condition6",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text3",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        },
                                        {
                                          "id": "group5",
                                          "title": "Group5",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "rgba(215 219 224 / 0.4)",
                              "borderWidth": 0,
                              "borderRadius": 6,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 6,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/a56ae1f7-4535-4154-b1f0-10b238062405/media/0bd0ca03-e145-42fd-841e-f9125cb0f8f7/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 24,
                                    "height": 24,
                                    "alignment": "center",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 14,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 6,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\n**Yearly plans begin on signup and renew on the date prior to the next NFL regular season.**\n\nLocal games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/a56ae1f7-4535-4154-b1f0-10b238062405/media/c493ef3f-c5c0-42d4-a6a2-c8ff2e08a8c2/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/a56ae1f7-4535-4154-b1f0-10b238062405/media/046475b4-7e8a-4b8e-b3b6-8cfbf914dc28/updtriplhed.jpeg",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "ae8385bb-5ff6-40f4-9762-1a7e284b9d19",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "7726b1df-abbf-4629-bc15-83039a53538e",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "ae8385bb-5ff6-40f4-9762-1a7e284b9d19",
          "selectedProducts": {
            "ae8385bb-5ff6-40f4-9762-1a7e284b9d19": "7b1cc241-3678-4f03-ba16-34131f488903",
            "7726b1df-abbf-4629-bc15-83039a53538e": "7cc0c0dd-2364-4b0e-ba68-3f4a38e6ed4c"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "a712cb0a-be8c-4132-bdbb-21575b2b1a8b",
      "name": "Schedule Release 25 Mobile Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "98bdd5d0-a1ed-437a-b37c-85b0fb6062c2",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "761c81ed-82c3-4f43-9165-93ca3bf78a26",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.53) 20%, rgba(16 17 25 / 1) 30%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 60,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "EVERY GAME REVEALED!",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 26,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "spacer1",
                  "title": "Spacer1",
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a yearly subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image0",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText11",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "Title Text11",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList8",
                                          "texts": [
                                            "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                            "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                          ],
                                          "title": "Bullet List8",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Regular",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList1BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List1 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Card Image",
                                  "width": "100%",
                                  "height": 24,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {
                                        "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "titleText12",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text12",
                                      "width": "100%",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                        "NFL RedZone",
                                        "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "condition7",
                                      "title": "Condition7",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "notContains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "group3",
                                          "title": "Group3",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText1",
                                              "text": "TV, PC, PHONE, & TABLET",
                                              "title": "Title Text1",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList4",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List4",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Group4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList5",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List5",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "condition6",
                                      "title": "Condition6",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text3",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        },
                                        {
                                          "id": "group5",
                                          "title": "Group5",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 10,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText8",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Title Text8",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList6",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Bullet List6",
                                              "width": "100%",
                                              "spacing": 10,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList4BulletComponent1",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List4 Bullet Component1",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "rgba(215 219 224 / 0.4)",
                              "borderWidth": 0,
                              "borderRadius": 6,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 6,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/a712cb0a-be8c-4132-bdbb-21575b2b1a8b/media/bc65f4f5-54ba-434b-bfc3-379abd12ff58/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 24,
                                    "height": 24,
                                    "alignment": "center",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 14,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "nflplus_premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 6,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "**[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)**\n\nLocal games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/a712cb0a-be8c-4132-bdbb-21575b2b1a8b/media/ae24ca3c-aa49-415a-a93a-ac5c3415a824/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/a712cb0a-be8c-4132-bdbb-21575b2b1a8b/media/80b8375f-c8b1-458b-95c9-bcf3fd623460/screl_25mob.jpeg",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "98bdd5d0-a1ed-437a-b37c-85b0fb6062c2",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "761c81ed-82c3-4f43-9165-93ca3bf78a26",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "98bdd5d0-a1ed-437a-b37c-85b0fb6062c2",
          "selectedProducts": {
            "98bdd5d0-a1ed-437a-b37c-85b0fb6062c2": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "761c81ed-82c3-4f43-9165-93ca3bf78a26": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "ac2bd315-859a-4d60-a808-89729c45ab4d",
      "name": "[RECURLY] Frigate RedZone Web Desktop",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "3819f678-f28f-4e47-b459-cd22dd13e6aa",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "premium-all"
        },
        {
          "id": "9bf37528-2bbd-4f4a-90fd-9b03e132eb88",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ac2bd315-859a-4d60-a808-89729c45ab4d/media/e499a20f-e0f8-4b21-b5f6-95f473103c83/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 40,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "titleText0",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Title Text0",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 20,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 10,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 260,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 100,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "NFL RedZone - Seven Hours of Live Football Coverage on Sundays",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "hidden": true,
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "condition4",
                                      "title": "Show Premium List",
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "components": [
                                        {
                                          "id": "group3",
                                          "title": "premium list",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 14,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "productWrapper6",
                                              "title": "List 1",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "spacing": 6,
                                              "component": "container",
                                              "direction": "vertical",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "titleText2",
                                                  "text": "TV, PC, PHONE & TABLET",
                                                  "title": "Title Text2",
                                                  "width": "100%",
                                                  "fontName": "All-ProSans-Bold",
                                                  "fontSize": 16,
                                                  "textType": "title",
                                                  "alignment": "left",
                                                  "component": "text",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "topPadding": 0,
                                                  "leftPadding": 0,
                                                  "rightPadding": 0,
                                                  "bottomPadding": 0,
                                                  "namiComponentType": "titleText"
                                                },
                                                {
                                                  "id": "bulletList4",
                                                  "texts": [
                                                    "NFL RedZone",
                                                    "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free",
                                                    "Everything from NFL+- including NFL Network, Ad-Free Highlights, Live Out-of-Market Preseason Games, and More!"
                                                  ],
                                                  "title": "Bullet List4",
                                                  "width": "100%",
                                                  "spacing": 10,
                                                  "fontName": "All-ProSans-Bold",
                                                  "fontSize": 16,
                                                  "textType": "body",
                                                  "alignment": "left",
                                                  "component": "text-list",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "bulletComponent": {
                                                    "id": "bulletList4BulletComponent",
                                                    "name": "CheckOutlined",
                                                    "title": "Bullet List4 Bullet Component",
                                                    "fontSize": 16,
                                                    "component": "symbol",
                                                    "fontColor": "rgba(198 203 215 / 1)",
                                                    "namiComponentType": "bulletComponent"
                                                  },
                                                  "namiComponentType": "bulletList"
                                                }
                                              ],
                                              "topPadding": 0,
                                              "borderColor": "transparent",
                                              "borderWidth": 0,
                                              "leftPadding": 0,
                                              "borderRadius": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "productWrapper",
                                              "verticalAlignment": "top",
                                              "horizontalAlignment": "center"
                                            },
                                            {
                                              "id": "productWrapper7",
                                              "title": "Product Wrapper7",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "spacing": 6,
                                              "component": "container",
                                              "direction": "vertical",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "titleText7",
                                                  "text": "PHONE & TABLET",
                                                  "title": "Title Text7",
                                                  "width": "100%",
                                                  "fontName": "All-ProSans-Bold",
                                                  "fontSize": 16,
                                                  "textType": "title",
                                                  "alignment": "left",
                                                  "component": "text",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "topPadding": 0,
                                                  "leftPadding": 0,
                                                  "rightPadding": 0,
                                                  "bottomPadding": 0,
                                                  "namiComponentType": "titleText"
                                                },
                                                {
                                                  "id": "bulletList5",
                                                  "texts": [
                                                    "Live Local and Primetime Regular and Postseason Games",
                                                    ""
                                                  ],
                                                  "title": "Bullet List5",
                                                  "width": "100%",
                                                  "spacing": 10,
                                                  "fontName": "All-ProSans-Bold",
                                                  "fontSize": 16,
                                                  "textType": "body",
                                                  "alignment": "left",
                                                  "component": "text-list",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "bulletComponent": {
                                                    "id": "bulletList4BulletComponent0",
                                                    "name": "CheckOutlined",
                                                    "title": "Bullet List4 Bullet Component0",
                                                    "fontSize": 16,
                                                    "component": "symbol",
                                                    "fontColor": "rgba(198 203 215 / 1)",
                                                    "namiComponentType": "bulletComponent"
                                                  },
                                                  "namiComponentType": "bulletList"
                                                }
                                              ],
                                              "topPadding": 0,
                                              "borderColor": "transparent",
                                              "borderWidth": 0,
                                              "leftPadding": 0,
                                              "borderRadius": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "productWrapper",
                                              "verticalAlignment": "top",
                                              "horizontalAlignment": "center"
                                            },
                                            {
                                              "id": "productWrapper8",
                                              "title": "Product Wrapper8",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "spacing": 6,
                                              "component": "container",
                                              "direction": "vertical",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "titleText8",
                                                  "text": "DESKTOP & MOBILE WEB ONLY",
                                                  "title": "Title Text8",
                                                  "width": "100%",
                                                  "fontName": "All-ProSans-Bold",
                                                  "fontSize": 16,
                                                  "textType": "title",
                                                  "alignment": "left",
                                                  "component": "text",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "topPadding": 0,
                                                  "leftPadding": 0,
                                                  "rightPadding": 0,
                                                  "bottomPadding": 0,
                                                  "namiComponentType": "titleText"
                                                },
                                                {
                                                  "id": "bulletList6",
                                                  "texts": [
                                                    "NFL Pro"
                                                  ],
                                                  "title": "Bullet List6",
                                                  "width": "100%",
                                                  "spacing": 10,
                                                  "fontName": "All-ProSans-Bold",
                                                  "fontSize": 16,
                                                  "textType": "body",
                                                  "alignment": "left",
                                                  "component": "text-list",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "bulletComponent": {
                                                    "id": "bulletList4BulletComponent1",
                                                    "name": "CheckOutlined",
                                                    "title": "Bullet List4 Bullet Component1",
                                                    "fontSize": 16,
                                                    "component": "symbol",
                                                    "fontColor": "rgba(198 203 215 / 1)",
                                                    "namiComponentType": "bulletComponent"
                                                  },
                                                  "namiComponentType": "bulletList"
                                                }
                                              ],
                                              "topPadding": 0,
                                              "borderColor": "transparent",
                                              "borderWidth": 0,
                                              "leftPadding": 0,
                                              "borderRadius": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "productWrapper",
                                              "verticalAlignment": "top",
                                              "horizontalAlignment": "center"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ac2bd315-859a-4d60-a808-89729c45ab4d/media/52d5e75e-0d0d-48b9-90f9-9c078418709c/CrossIcon.png",
                                    "title": "Image2",
                                    "width": "fitContent",
                                    "height": 40,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ PREMIUM FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 18,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText"
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 18,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 10,
                                "borderRadius": 0,
                                "rightPadding": 10,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 20,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ac2bd315-859a-4d60-a808-89729c45ab4d/media/10e63fb5-8c72-448b-94c1-10543ab6051d/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ac2bd315-859a-4d60-a808-89729c45ab4d/media/7f66bef8-98a5-48a8-92bd-da4e4e06f861/RedZone12.png",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "3819f678-f28f-4e47-b459-cd22dd13e6aa",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "9bf37528-2bbd-4f4a-90fd-9b03e132eb88",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "3819f678-f28f-4e47-b459-cd22dd13e6aa",
          "selectedProducts": {
            "3819f678-f28f-4e47-b459-cd22dd13e6aa": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "9bf37528-2bbd-4f4a-90fd-9b03e132eb88": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups",
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "c0c122dc-01f4-4a34-9ab5-bdabb843aa73",
      "name": "Preseason 25 Mobile Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "802ae8b1-d173-4667-877b-2a5f789cc7b2",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "ae9f48ce-acea-4c68-a4b0-ce3860e74666",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.53) 20%, rgba(16 17 25 / 1) 30%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 60,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "PRESEASON STARTS HERE!",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": false,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 26,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "spacer1",
                  "title": "Spacer1",
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "bodyText",
                  "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Hosted Image0",
                                  "width": "100%",
                                  "height": 24,
                                  "hidden": true,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "attributes": {

                                      }
                                    }
                                  ]
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText11",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "Title Text11",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "customList3",
                                          "title": "Custom List3",
                                          "width": "100%",
                                          "spacing": 12,
                                          "alignment": "left",
                                          "component": "container",
                                          "direction": "vertical",
                                          "components": [
                                            {
                                              "id": "listItem10",
                                              "title": "List Item10",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "spacing": 8,
                                              "component": "container",
                                              "direction": "horizontal",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "listItem10Icon",
                                                  "name": "CheckOutlined",
                                                  "title": "List Item10 Icon",
                                                  "fontSize": 16,
                                                  "component": "symbol",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "namiComponentType": "icon"
                                                },
                                                {
                                                  "id": "listItem10BodyText",
                                                  "text": "Live Out-of-Market Preseason Games",
                                                  "title": "List Item10 Body Text",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "fontName": "Helvetica",
                                                  "fontSize": 16,
                                                  "textType": "body",
                                                  "alignment": "left",
                                                  "component": "text",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "namiComponentType": "bodyText"
                                                }
                                              ],
                                              "namiComponentType": "listItem"
                                            },
                                            {
                                              "id": "listItem11",
                                              "title": "List Item11",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "spacing": 8,
                                              "component": "container",
                                              "direction": "horizontal",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "listItem10Icon0",
                                                  "name": "CheckOutlined",
                                                  "title": "List Item10 Icon0",
                                                  "fontSize": 16,
                                                  "component": "symbol",
                                                  "fontColor": "rgba(198 203 215 / 1)",
                                                  "namiComponentType": "icon"
                                                },
                                                {
                                                  "id": "image5",
                                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                                  "title": "Image5",
                                                  "width": "100%",
                                                  "height": 24,
                                                  "alignment": "left",
                                                  "component": "image",
                                                  "imageCropping": "fit",
                                                  "namiComponentType": "image"
                                                }
                                              ],
                                              "namiComponentType": "listItem"
                                            }
                                          ],
                                          "namiComponentType": "customList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper10",
                                  "title": "Product Wrapper10",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "customList1",
                                      "title": "Custom List1",
                                      "width": "100%",
                                      "spacing": 12,
                                      "alignment": "left",
                                      "component": "container",
                                      "direction": "vertical",
                                      "components": [
                                        {
                                          "id": "listItem4",
                                          "title": "List Item4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 8,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "listItemIcon4",
                                              "name": "CheckOutlined",
                                              "title": "List Item Icon4",
                                              "fontSize": 12,
                                              "component": "symbol",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "icon"
                                            },
                                            {
                                              "id": "listItemBodyText4",
                                              "text": "Live Local and Primetime Regular and Postseason Games on Mobile",
                                              "title": "List Item Body Text4",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "fontName": "Helvetica",
                                              "fontSize": 12,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "bodyText"
                                            }
                                          ],
                                          "namiComponentType": "listItem"
                                        },
                                        {
                                          "id": "listItem5",
                                          "title": "List Item5",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 8,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "listItemIcon5",
                                              "name": "CheckOutlined",
                                              "title": "List Item Icon5",
                                              "fontSize": 12,
                                              "component": "symbol",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "icon"
                                            },
                                            {
                                              "id": "image",
                                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-redzone.png",
                                              "title": "Image",
                                              "width": "100%",
                                              "height": 20,
                                              "alignment": "left",
                                              "component": "image",
                                              "imageCropping": "fit",
                                              "namiComponentType": "image"
                                            }
                                          ],
                                          "namiComponentType": "listItem"
                                        },
                                        {
                                          "id": "listItem6",
                                          "title": "List Item6",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 8,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "listItemIcon6",
                                              "name": "CheckOutlined",
                                              "title": "List Item Icon6",
                                              "fontSize": 12,
                                              "component": "symbol",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "icon"
                                            },
                                            {
                                              "id": "listItemBodyText6",
                                              "text": "Game Replays - Full, Condensed and All-22 Coaches Film",
                                              "title": "List Item Body Text6",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "fontName": "Helvetica",
                                              "fontSize": 12,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "bodyText"
                                            }
                                          ],
                                          "namiComponentType": "listItem"
                                        }
                                      ],
                                      "namiComponentType": "customList"
                                    },
                                    {
                                      "id": "customList2",
                                      "title": "Custom List2",
                                      "width": "100%",
                                      "spacing": 12,
                                      "alignment": "left",
                                      "component": "container",
                                      "direction": "vertical",
                                      "components": [
                                        {
                                          "id": "listItem7",
                                          "title": "List Item7",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 8,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "listItemIcon7",
                                              "name": "CheckOutlined",
                                              "title": "List Item Icon7",
                                              "fontSize": 12,
                                              "component": "symbol",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "icon"
                                            },
                                            {
                                              "id": "listItemBodyText7",
                                              "text": "Everything from NFL+",
                                              "title": "List Item Body Text7",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "fontName": "Helvetica",
                                              "fontSize": 12,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "bodyText"
                                            }
                                          ],
                                          "namiComponentType": "listItem"
                                        },
                                        {
                                          "id": "listItem8",
                                          "title": "List Item8",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 8,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "listItemIcon8",
                                              "name": "CheckOutlined",
                                              "title": "List Item Icon8",
                                              "fontSize": 12,
                                              "component": "symbol",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "icon"
                                            },
                                            {
                                              "id": "image4",
                                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                              "title": "Image4",
                                              "width": "100%",
                                              "height": 20,
                                              "alignment": "left",
                                              "component": "image",
                                              "imageCropping": "fit",
                                              "namiComponentType": "image"
                                            }
                                          ],
                                          "namiComponentType": "listItem"
                                        },
                                        {
                                          "id": "listItem9",
                                          "title": "List Item9",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 8,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "listItemIcon9",
                                              "name": "CheckOutlined",
                                              "title": "List Item Icon9",
                                              "fontSize": 12,
                                              "component": "symbol",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "icon"
                                            },
                                            {
                                              "id": "listItemBodyText8",
                                              "text": "NFL Pro (desktop & mobile web only)",
                                              "title": "List Item Body Text8",
                                              "width": "100%",
                                              "height": "fitContent",
                                              "fontName": "Helvetica",
                                              "fontSize": 12,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "namiComponentType": "bodyText"
                                            }
                                          ],
                                          "namiComponentType": "listItem"
                                        }
                                      ],
                                      "namiComponentType": "customList"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "top",
                                  "horizontalAlignment": "left"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 19,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 11,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition4",
                              "title": "Condition4",
                              "component": "condition",
                              "components": [
                                {
                                  "id": "collapse",
                                  "open": "collapse",
                                  "title": "Collapse",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "component": "collapseContainer",
                                  "direction": "vertical",
                                  "components": [
                                    {
                                      "id": "collapseCollapseBody",
                                      "title": "Collapse Collapse Body",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "rgba(220 220 220 / 0)",
                                      "components": [
                                        {
                                          "id": "condition7",
                                          "title": "Condition7",
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.entitlements}",
                                              "expected": "nflplus_premium",
                                              "operator": "notContains"
                                            }
                                          ],
                                          "components": [
                                            {
                                              "id": "productWrapper4",
                                              "title": "Product Wrapper4",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "spacing": 4,
                                              "component": "container",
                                              "direction": "horizontal",
                                              "fillColor": "transparent",
                                              "components": [
                                                {
                                                  "id": "customList",
                                                  "title": "Custom List",
                                                  "width": "100%",
                                                  "spacing": 12,
                                                  "alignment": "left",
                                                  "component": "container",
                                                  "direction": "vertical",
                                                  "components": [
                                                    {
                                                      "id": "listItem",
                                                      "title": "List Item",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon",
                                                          "fontSize": 12,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText",
                                                          "text": "Live Local and Primetime Regular and Postseason Games on Mobile",
                                                          "title": "List Item Body Text",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 12,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    },
                                                    {
                                                      "id": "listItem0",
                                                      "title": "List Item0",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon0",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon0",
                                                          "fontSize": 12,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText0",
                                                          "text": "NFL Films' Programming and More On-Demand Content",
                                                          "title": "List Item Body Text0",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 12,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    },
                                                    {
                                                      "id": "listItem1",
                                                      "title": "List Item1",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon1",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon1",
                                                          "fontSize": 12,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText1",
                                                          "text": "And More!",
                                                          "title": "List Item Body Text1",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 12,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    }
                                                  ],
                                                  "namiComponentType": "customList"
                                                },
                                                {
                                                  "id": "customList0",
                                                  "title": "Custom List0",
                                                  "width": "100%",
                                                  "spacing": 12,
                                                  "alignment": "left",
                                                  "component": "container",
                                                  "direction": "vertical",
                                                  "components": [
                                                    {
                                                      "id": "listItem2",
                                                      "title": "List Item2",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon2",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon2",
                                                          "fontSize": 12,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText2",
                                                          "text": "Live Game Audio",
                                                          "title": "List Item Body Text2",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 12,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    },
                                                    {
                                                      "id": "listItem3",
                                                      "title": "List Item3",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "spacing": 8,
                                                      "component": "container",
                                                      "direction": "horizontal",
                                                      "fillColor": "transparent",
                                                      "components": [
                                                        {
                                                          "id": "listItemIcon3",
                                                          "name": "CheckOutlined",
                                                          "title": "List Item Icon3",
                                                          "fontSize": 12,
                                                          "component": "symbol",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "icon"
                                                        },
                                                        {
                                                          "id": "listItemBodyText3",
                                                          "text": "Ad-Free Highlights",
                                                          "title": "List Item Body Text3",
                                                          "width": "100%",
                                                          "height": "fitContent",
                                                          "fontName": "Helvetica",
                                                          "fontSize": 12,
                                                          "textType": "body",
                                                          "alignment": "left",
                                                          "component": "text",
                                                          "fontColor": "rgba(198 203 215 / 1)",
                                                          "namiComponentType": "bodyText"
                                                        }
                                                      ],
                                                      "namiComponentType": "listItem"
                                                    }
                                                  ],
                                                  "namiComponentType": "customList"
                                                }
                                              ],
                                              "topPadding": 0,
                                              "borderColor": "transparent",
                                              "borderWidth": 0,
                                              "leftPadding": 0,
                                              "borderRadius": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "productWrapper",
                                              "verticalAlignment": "top",
                                              "horizontalAlignment": "left"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        }
                                      ],
                                      "topPadding": 15,
                                      "leftPadding": 15,
                                      "borderRadius": 0,
                                      "rightPadding": 15,
                                      "roundBorders": [
                                        "lowerLeft",
                                        "lowerRight"
                                      ],
                                      "bottomPadding": 15,
                                      "namiComponentType": "collapseBody"
                                    }
                                  ],
                                  "borderColor": "rgba(215 219 224 / 0.4)",
                                  "borderWidth": 0,
                                  "borderRadius": 6,
                                  "collapseHeader": {
                                    "id": "collapseHeader",
                                    "title": "Collapse Header",
                                    "width": "100%",
                                    "height": "fitContent",
                                    "spacing": 6,
                                    "component": "container",
                                    "direction": "horizontal",
                                    "fillColor": "rgba(220 220 220 / 0)",
                                    "components": [
                                      {
                                        "id": "image2",
                                        "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/c0c122dc-01f4-4a34-9ab5-bdabb843aa73/media/967651ec-ea83-43c6-a094-bc43151a1008/CrossIcon.png",
                                        "title": "Image2",
                                        "width": 24,
                                        "height": 24,
                                        "alignment": "center",
                                        "component": "image",
                                        "imageCropping": "fit",
                                        "namiComponentType": "image"
                                      },
                                      {
                                        "id": "collapseHeaderTitleText",
                                        "text": "MORE NFL+ FEATURES",
                                        "title": "Collapse Header Title Text",
                                        "width": "100%",
                                        "fontName": "All-ProDisplayC-BoldItalic",
                                        "fontSize": 14,
                                        "textType": "title",
                                        "alignment": "left",
                                        "component": "text",
                                        "fontColor": "rgba(255 255 255 / 1)",
                                        "topPadding": 0,
                                        "leftPadding": 0,
                                        "rightPadding": 0,
                                        "bottomPadding": 0,
                                        "namiComponentType": "titleText",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.entitlements}",
                                                "expected": "nflplus_premium",
                                                "operator": "contains"
                                              }
                                            ],
                                            "attributes": {
                                              "text": "MORE NFL+ PREMIUM FEATURES"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "id": "collapseHeaderIcon",
                                        "name": "DownOutlined",
                                        "title": "Collapse Header Icon",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "icon",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${state.openHeaderIds}",
                                                "expected": "collapse",
                                                "operator": "contains"
                                              }
                                            ],
                                            "attributes": {
                                              "name": "UpOutlined"
                                            }
                                          }
                                        ]
                                      }
                                    ],
                                    "topPadding": 15,
                                    "leftPadding": 15,
                                    "borderRadius": 6,
                                    "rightPadding": 15,
                                    "roundBorders": [
                                      "lowerLeft",
                                      "lowerRight",
                                      "upperLeft",
                                      "upperRight"
                                    ],
                                    "bottomPadding": 15,
                                    "namiComponentType": "collapseHeader",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "roundBorders": [
                                            "upperLeft",
                                            "upperRight"
                                          ]
                                        }
                                      }
                                    ]
                                  },
                                  "namiComponentType": "collapse"
                                }
                              ],
                              "orAssertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "namiComponentType": "condition"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/c0c122dc-01f4-4a34-9ab5-bdabb843aa73/media/c597ddc0-1b73-4e22-884c-9543de4fabe7/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/c0c122dc-01f4-4a34-9ab5-bdabb843aa73/media/0fba59e2-70ee-4a68-9639-8cd5cb0d5474/mob25.jpeg",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "802ae8b1-d173-4667-877b-2a5f789cc7b2",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "ae9f48ce-acea-4c68-a4b0-ce3860e74666",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "802ae8b1-d173-4667-877b-2a5f789cc7b2",
          "selectedProducts": {
            "802ae8b1-d173-4667-877b-2a5f789cc7b2": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "ae9f48ce-acea-4c68-a4b0-ce3860e74666": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "c5a91a13-be48-4792-8674-ed4b78ebc6cf",
      "name": "[RECURLY] Frigate Tablet for Web // Annual Toggle",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "cf309e10-73cb-4726-ba94-5230a2f4b220",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "912d665a-54af-49df-8843-21e8e4f499e3",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/c5a91a13-be48-4792-8674-ed4b78ebc6cf/media/276ea38f-4fcc-412e-9414-23056fe69944/nami-nfl-logo.png",
                  "title": "Image",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 350,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "Live Out-of-Market Preseason Games",
                                                "NFL Network",
                                                "Live Game Audio",
                                                "And More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "productWrapper4",
                                          "title": "Phone List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText3",
                                              "text": "PHONE & TABLET",
                                              "title": "Phone List Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Phone list",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "NFL RedZone",
                                                "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                                "Everything from NFL+"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group3",
                                          "title": "Phone List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText6",
                                              "text": "PHONE & TABLET",
                                              "title": "Phone Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList1",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Phone List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList1BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "DESKTOP & MOBILE WEB ONLY",
                                              "title": "Desktop Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList3",
                                              "texts": [
                                                "NFL Pro"
                                              ],
                                              "title": "Desktop List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList1BulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List1 Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 260
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 8,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper10",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 3,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.BasePriceText}",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${state.orientation}",
                                                  "expected": "portrait",
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "fontSize": 18
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.DurationText}",
                                          "moveY": 0,
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 15,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "strikethrough": true,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${state.orientation}",
                                                  "expected": "portrait",
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "moveY": 0,
                                                "fontSize": 11
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 24
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 0,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "moveY": 0,
                                            "fontSize": 13
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/c5a91a13-be48-4792-8674-ed4b78ebc6cf/media/4aece4b2-557d-4744-b74b-fd20ce5bee19/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 20,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "group2",
                      "title": "Top Spacer",
                      "width": "100%",
                      "height": 60,
                      "spacing": 10,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "topMargin": "${state.safeAreaTop}",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "cf309e10-73cb-4726-ba94-5230a2f4b220",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "912d665a-54af-49df-8843-21e8e4f499e3",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "912d665a-54af-49df-8843-21e8e4f499e3",
          "selectedProducts": {
            "cf309e10-73cb-4726-ba94-5230a2f4b220": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "912d665a-54af-49df-8843-21e8e4f499e3": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
      "name": "[RECURLY] Frigate Web Desktop Main Premium",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "781d499d-fdf7-4ec5-a1c7-43db93f319a7",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "premium-all"
        },
        {
          "id": "fed0148f-b0de-439e-8219-7dd0888b80a2",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 12,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ccfd8d1f-8095-43e0-a390-df1862081b3c/media/028d0c00-b1dc-417e-9f45-0e477cac18cc/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Body Text",
                  "width": 275,
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "left",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "strikethrough": false,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 4,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "hidden": true,
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "hidden": true,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "hidden": true,
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Base Price Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 2,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productText2",
                                          "text": "${sku.Price}",
                                          "moveX": "0%",
                                          "moveY": "0%",
                                          "title": "Base Price Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 20,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "topMargin": 0,
                                          "leftMargin": 0,
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightMargin": 0,
                                          "bottomMargin": 0,
                                          "rightPadding": 5,
                                          "bottomPadding": 0,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        },
                                        {
                                          "id": "productText3",
                                          "text": "${sku.Duration}",
                                          "moveX": "0%",
                                          "moveY": "0%",
                                          "title": "Product Text3",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProSans-Medium",
                                          "fontSize": 13,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "topMargin": 0,
                                          "leftMargin": 0,
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightMargin": 0,
                                          "bottomMargin": 0,
                                          "rightPadding": 5,
                                          "bottomPadding": 0,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 0,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper",
                                  "verticalAlignment": "center",
                                  "horizontalAlignment": "center"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "hidden": true,
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 260,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network ",
                                        "Live Game Audio ",
                                        "NFL Films' and More On-Demand Content - All Ad-Free",
                                        "Fantasy+",
                                        "And More! "
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText7",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "Title Text7",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                        "Everything from NFL+"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games",
                                        ""
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 24,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 24,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "group3",
                      "title": "Group3",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 10,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "linkButton",
                          "text": "[EXPLORE ALL NFL+ PLANS](https://id.nfl.com/select-subscription?p=gc-eeal-nlpsca)",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Link Button",
                          "width": "fitContent",
                          "height": 56,
                          "zIndex": 1,
                          "fontName": "All-ProDisplayC-BoldItalic",
                          "fontSize": 15,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fillColor": "transparent",
                          "fontColor": "rgba(255 255 255 / 0.8)",
                          "linkColor": "rgba(255 255 255 / 0.8)",
                          "topMargin": 0,
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 0,
                          "borderColor": "rgba(28 72 225 / 1)",
                          "borderWidth": 1,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 8,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "strikethrough": false,
                          "namiComponentType": "linkButton"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ccfd8d1f-8095-43e0-a390-df1862081b3c/media/f10fe79f-f4e5-42a1-9557-e635e2aec946/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "781d499d-fdf7-4ec5-a1c7-43db93f319a7",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "fed0148f-b0de-439e-8219-7dd0888b80a2",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "781d499d-fdf7-4ec5-a1c7-43db93f319a7",
          "selectedProducts": {
            "781d499d-fdf7-4ec5-a1c7-43db93f319a7": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "fed0148f-b0de-439e-8219-7dd0888b80a2": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "da780949-9e81-47bc-9618-158a6232df25",
      "name": "Internal Coupon Distribution 25 Tablet for Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "4e3f9e04-b5d3-4121-8056-41346f5ed283",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "23eca945-da61-4fa4-9ba9-3e0b8fc43d1f",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "cc279019-e4ec-41cd-950c-cef7bc6eab42",
              "featured": false,
              "name": "[INT] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual_pass",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "REDEEM"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 40,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "Click \"Redeem\" Below To Enter Your Coupon Code",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a yearly subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "hidden": true,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 350,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "Get ready for the Schedule Release ’25 Show presented by Verizon on May 14th starting at 8pm ET on NFL Network!",
                                                "Watch Rich Eisen, Maurice Jones-Drew, and Michael Robinson break down the 2025 NFL Schedule!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "Game Replays - Full, Condensed and All-22 Coaches Film - All Ad-Free",
                                                "NFL RedZone",
                                                "Everything from NFL+ - including NFL Network, Ad-Free Highlights, NFL Films' Programming and On-Demand Content, and More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 120
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 10,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "moveY": 4,
                                            "fontSize": 14
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group2",
                                      "title": "Group2",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper4",
                                          "title": "Product Wrapper4",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText6",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "Title Text6",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "nflplus_premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": "PHONE & TABLET"
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList",
                                              "texts": [
                                                "NFL Network - 24/7 Football News and Coverage",
                                                "Live Game Audio",
                                                "NFL Films' Programming and More On-Demand Content - All Ad-Free",
                                                "Out-of-Market Preseason Games Across Devices"
                                              ],
                                              "title": "Bullet List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "Live Local and Primetime Regular and Postseason Games"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        },
                                        {
                                          "id": "productWrapper10",
                                          "title": "Product Wrapper10",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 5,
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText7",
                                              "text": "PHONE & TABLET",
                                              "title": "Title Text7",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "text": "DESKTOP & MOBILE WEB ONLY"
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "id": "bulletList1",
                                              "texts": [
                                                "Live Local and Primetime Regular and Postseason Games"
                                              ],
                                              "title": "Bullet List1",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletListBulletComponent0",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component0",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList",
                                              "conditionAttributes": [
                                                {
                                                  "component": "condition",
                                                  "assertions": [
                                                    {
                                                      "value": "${sku.entitlements}",
                                                      "expected": "premium",
                                                      "operator": "contains"
                                                    }
                                                  ],
                                                  "attributes": {
                                                    "texts": [
                                                      "NFL Pro"
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "conditionAttributes": [],
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/da780949-9e81-47bc-9618-158a6232df25/media/ed88830a-a162-47c8-9e80-8dec7fcb7ed6/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 28,
                                    "height": 28,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 16,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 0,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/da780949-9e81-47bc-9618-158a6232df25/media/a7afca34-f2a3-4389-a485-20566e6c53ca/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 20,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/da780949-9e81-47bc-9618-158a6232df25/media/1e2d9ac1-7bdf-4ca1-8e93-5f7e1848bfbe/screl_25desk.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "4e3f9e04-b5d3-4121-8056-41346f5ed283",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "23eca945-da61-4fa4-9ba9-3e0b8fc43d1f",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "23eca945-da61-4fa4-9ba9-3e0b8fc43d1f",
          "selectedProducts": {
            "4e3f9e04-b5d3-4121-8056-41346f5ed283": null,
            "23eca945-da61-4fa4-9ba9-3e0b8fc43d1f": "cc279019-e4ec-41cd-950c-cef7bc6eab42"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "de246ff5-93d2-4b28-8c2b-eca06cf93fd5",
      "name": "Frigate Mobile Web Premium Monthly",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "d8e97e97-6745-4f73-961a-10b10b1d9827",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "premium-all"
        },
        {
          "id": "96dfa514-ad6d-4f47-b5ba-ad8da6accd80",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/de246ff5-93d2-4b28-8c2b-eca06cf93fd5/media/c760c785-b00a-4718-aa02-ba2f9557d5ed/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "NFL Network ",
                                            "Live Game Audio ",
                                            "NFL Films' and More On-Demand Content - All Ad-Free",
                                            "Fantasy+",
                                            "And More! "
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Game Replays - Full, Condensed, and All-22 Coaches Film",
                                            "Everything from NFL+"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper10",
                                      "title": "Product Wrapper10",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText7",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text7",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList4",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List4",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 18,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/de246ff5-93d2-4b28-8c2b-eca06cf93fd5/media/5ec25493-9ac8-47df-8cb2-7b809caa4e51/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "d8e97e97-6745-4f73-961a-10b10b1d9827",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "96dfa514-ad6d-4f47-b5ba-ad8da6accd80",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "d8e97e97-6745-4f73-961a-10b10b1d9827",
          "selectedProducts": {
            "d8e97e97-6745-4f73-961a-10b10b1d9827": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "96dfa514-ad6d-4f47-b5ba-ad8da6accd80": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "df32ddb0-f5a3-4ddb-992b-b7fd6307d52e",
      "name": "[RECURLY] Frigate RedZone Mobile Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "f8e39a59-b731-4f5d-aca9-7a8ad5042e72",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "premium-all"
        },
        {
          "id": "1632585d-5d8e-4f47-b79a-4392230990d4",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE",
                "screenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "promoDurationText": "/${sku.promoPeriod:0}",
                "promoBasePriceText": "${sku.promoPrice:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW",
                "trialproductDisplayTextText": "START 7-DAY FREE TRIAL"
              }
            }
          ],
          "ref": "premium-annual"
        }
      ],
      "template": {
        "id": "c83e319c-c800-4234-8c5c-3c7f3c8385ab",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/df32ddb0-f5a3-4ddb-992b-b7fd6307d52e/media/c5ff3b47-462f-40b4-882e-36f460705c7f/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 40,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "GAMEDAY STARTS HERE",
                  "title": "Title Text",
                  "width": "100%",
                  "hidden": true,
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "NFL Network ",
                                            "Live Game Audio ",
                                            "NFL Films' and More On-Demand Content - All Ad-Free",
                                            "Fantasy+",
                                            "And More! "
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone - Seven Hours of Live Football Coverage on Sundays",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper9",
                                      "title": "Product Wrapper9",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "hidden": true,
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText6",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text6",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 15,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList3",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List3",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List2 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 18,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 12,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "group3",
                                      "title": "Group3",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText1",
                                          "text": "TV, PC, PHONE, & TABLET",
                                          "title": "Title Text1",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList4",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, Condensed and All-22 Coaches Film Replays - All Ad-Free",
                                            "Everything from NFL+- including NFL Network, Ad-Free Highlights, Live Out-of-Market Preseason Games, and More!"
                                          ],
                                          "title": "Bullet List4",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList4BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List4 Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "group4",
                                      "title": "Group4",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText7",
                                          "text": "PHONE & TABLET",
                                          "title": "Title Text7",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList5",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Bullet List5",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList4BulletComponent0",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List4 Bullet Component0",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    },
                                    {
                                      "id": "group5",
                                      "title": "Group5",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 10,
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText8",
                                          "text": "DESKTOP & MOBILE WEB ONLY",
                                          "title": "Title Text8",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList6",
                                          "texts": [
                                            "NFL Pro"
                                          ],
                                          "title": "Bullet List6",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList4BulletComponent1",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List4 Bullet Component1",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "top",
                                      "horizontalAlignment": "center"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "rgba(215 219 224 / 0.4)",
                              "borderWidth": 0,
                              "borderRadius": 6,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 6,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/df32ddb0-f5a3-4ddb-992b-b7fd6307d52e/media/3c2ecf51-e16a-4a0c-8834-b7fb9ac02a60/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 24,
                                    "height": 24,
                                    "alignment": "center",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ PREMIUM FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 16,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText"
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 6,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "title": "Legal Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "hidden": true,
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText0",
                      "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                      "title": "Legal Bot",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": []
                    }
                  ],
                  "topPadding": 12,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 12,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "#ffffff",
                      "linkColor": "#ffffff",
                      "topPadding": 10,
                      "borderColor": "rgba(0 79 255 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 70,
                      "borderRadius": 8,
                      "rightPadding": 70,
                      "bottomPadding": 10,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/df32ddb0-f5a3-4ddb-992b-b7fd6307d52e/media/9a192ff5-ff4e-455d-9191-a493028a4a8a/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 60,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image3",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/df32ddb0-f5a3-4ddb-992b-b7fd6307d52e/media/bc746d24-a72c-41e5-b3fe-de8852ee6128/NFLRZFootball.png",
                  "title": "Image3",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.1",
        "codename": "Frigate Mobile Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-mobile-web",
        "changelog": "Remove unneeded Matchup Image spacer",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "f8e39a59-b731-4f5d-aca9-7a8ad5042e72",
              "displayName": "MONTHLY",
              "ref": "premium-all"
            },
            {
              "id": "1632585d-5d8e-4f47-b79a-4392230990d4",
              "displayName": "YEARLY",
              "ref": "premium-annual"
            }
          ],
          "currentGroupId": "f8e39a59-b731-4f5d-aca9-7a8ad5042e72",
          "selectedProducts": {
            "f8e39a59-b731-4f5d-aca9-7a8ad5042e72": "6c585039-a58e-4897-89b4-4274a5b0259e",
            "1632585d-5d8e-4f47-b79a-4392230990d4": "30c528fb-9610-4d6e-ab1b-5b21b61233b5"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "ece8b1c1-690b-49be-8421-ba2c228ca852",
      "name": "Preseason 25 Tablet for Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "1e56962e-67ef-43a8-8737-6d38aab3f782",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
              "featured": false,
              "name": "[REC] NFL+ Monthly",
              "sku_ref_id": "nfl_plus_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "6c585039-a58e-4897-89b4-4274a5b0259e",
              "featured": false,
              "name": "[REC] NFL+ Premium Monthly",
              "sku_ref_id": "nfl_plus_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "monthly"
        },
        {
          "id": "fb07c9c0-f703-44b4-adc8-3f01b33f3f98",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            },
            {
              "id": "30c528fb-9610-4d6e-ab1b-5b21b61233b5",
              "featured": false,
              "name": "[REC] NFL+ Premium Annual",
              "sku_ref_id": "nfl_plus_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "a29a70c5-89d5-4aa5-acb8-047911898043",
                  "entitlement_ref_id": "nflplus_premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                },
                {
                  "id": "21a23c56-7699-4af5-99a1-85c1085be475",
                  "entitlement_ref_id": "premium",
                  "name": "NFL+ Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Badge": "THE ULTIMATE NFL+ EXPERIENCE",
                "promoKey": "${sku.promo:0}",
                "DurationText": "/${sku.period}",
                "TrialCTAText": "START 7-DAY FREE TRIAL",
                "BasePriceText": "${sku.price}",
                "IntroPriceText": "${sku.introductoryPrice}",
                "PromoPriceText": "${sku.promoPrice:0}",
                "ScreenreaderText": "purchase product for ${sku.price} per ${sku.period}",
                "IntroDurationText": "/${sku.introductoryPeriod}",
                "PromoDurationText": "/${sku.promoPeriod:0}",
                "IntroScreenreaderText": "purchase product for ${sku.introductoryPrice} per ${sku.introductoryPrice}",
                "PromoScreenreaderText": "purchase product for ${sku.promoPrice:0} per ${sku.promoPeriod:0}",
                "productDisplayTextText": "SIGN UP NOW"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "7b2babb5-6d82-4856-955f-0af90eadc067",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "spacer",
                  "title": "Spacer",
                  "height": 40,
                  "component": "spacer",
                  "namiComponentType": "spacer"
                },
                {
                  "id": "titleText",
                  "text": "PRESEASON STARTS HERE!",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 184,
                  "height": 49,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 12,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 12,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "borderRadius": 30,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.Badge}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition7",
                          "title": "Show Badge Spacer",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper9",
                              "title": "Lists Wrapper",
                              "width": "100%",
                              "height": 350,
                              "spacing": 5,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition1",
                                  "title": "Show Base List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "notContains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper3",
                                      "title": "Base List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper5",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText4",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList0",
                                              "texts": [
                                                "Live Out-of-Market Preseason Games"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList0BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "condition2",
                                  "title": "Show Premium List",
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "components": [
                                    {
                                      "id": "productWrapper6",
                                      "title": "Premium List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 14,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "productWrapper7",
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "titleText5",
                                              "text": "TV, PC, PHONE & TABLET",
                                              "title": "All Devices Title",
                                              "width": "100%",
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 16,
                                              "textType": "title",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "topPadding": 0,
                                              "leftPadding": 0,
                                              "rightPadding": 0,
                                              "bottomPadding": 0,
                                              "namiComponentType": "titleText"
                                            },
                                            {
                                              "id": "bulletList2",
                                              "texts": [
                                                "Game Replays - Full, Condensed and All-22 Coaches Film",
                                                "Everything from NFL+ - including Live Out-of-Market Preseason Games, Live Game Audio, and More!"
                                              ],
                                              "title": "All Devices List",
                                              "width": "100%",
                                              "spacing": 8,
                                              "fontName": "All-ProSans-Bold",
                                              "fontSize": 15,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text-list",
                                              "fontColor": "rgba(198 203 215 / 1)",
                                              "bulletComponent": {
                                                "id": "bulletList2BulletComponent",
                                                "name": "CheckOutlined",
                                                "title": "Bullet List Bullet Component",
                                                "fontSize": 16,
                                                "component": "symbol",
                                                "fontColor": "rgba(198 203 215 / 1)",
                                                "namiComponentType": "bulletComponent"
                                              },
                                              "namiComponentType": "bulletList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper"
                                        },
                                        {
                                          "id": "group4",
                                          "title": "Desktop List",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "spacing": 6,
                                          "alignment": "center",
                                          "component": "container",
                                          "direction": "vertical",
                                          "fillColor": "transparent",
                                          "components": [],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "group"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "spacer2",
                                  "title": "List Align Spacer",
                                  "component": "spacer",
                                  "namiComponentType": "spacer"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.orientation}",
                                      "expected": "landscape",
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "height": 180
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 10,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 22,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.DurationText}",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 17,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 18
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "fontSize": 25
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.PromoDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${state.orientation}",
                                              "expected": "portrait",
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "moveY": 4,
                                            "fontSize": 14
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.TrialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.ScreenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "collapse",
                              "open": "collapse",
                              "title": "Collapse",
                              "width": "100%",
                              "height": "fitContent",
                              "component": "collapseContainer",
                              "direction": "vertical",
                              "components": [
                                {
                                  "id": "collapseCollapseBody",
                                  "title": "Collapse Collapse Body",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 10,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "rgba(220 220 220 / 0)",
                                  "components": [
                                    {
                                      "id": "condition4",
                                      "title": "Condition4",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productWrapper4",
                                          "title": "Product Wrapper4",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "spacing": 4,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "customList",
                                              "title": "Custom List",
                                              "width": "100%",
                                              "spacing": 12,
                                              "alignment": "left",
                                              "component": "container",
                                              "direction": "vertical",
                                              "components": [
                                                {
                                                  "id": "listItem",
                                                  "title": "List Item",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText",
                                                      "text": "Live Local and Primetime Regular and Postseason Games on Mobile",
                                                      "title": "List Item Body Text",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                },
                                                {
                                                  "id": "listItem0",
                                                  "title": "List Item0",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon0",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon0",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText0",
                                                      "text": "NFL Films' Programming and More On-Demand Content",
                                                      "title": "List Item Body Text0",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                },
                                                {
                                                  "id": "listItem1",
                                                  "title": "List Item1",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon1",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon1",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText1",
                                                      "text": "And More!",
                                                      "title": "List Item Body Text1",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                }
                                              ],
                                              "namiComponentType": "customList"
                                            },
                                            {
                                              "id": "customList0",
                                              "title": "Custom List0",
                                              "width": "100%",
                                              "spacing": 12,
                                              "alignment": "left",
                                              "component": "container",
                                              "direction": "vertical",
                                              "components": [
                                                {
                                                  "id": "listItem2",
                                                  "title": "List Item2",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon2",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon2",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText2",
                                                      "text": "Live Game Audio",
                                                      "title": "List Item Body Text2",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                },
                                                {
                                                  "id": "listItem3",
                                                  "title": "List Item3",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon3",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon3",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText3",
                                                      "text": "Ad-Free Highlights",
                                                      "title": "List Item Body Text3",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                }
                                              ],
                                              "namiComponentType": "customList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "notContains"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "condition6",
                                      "title": "Condition6",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productWrapper10",
                                          "title": "Product Wrapper10",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "spacing": 4,
                                          "component": "container",
                                          "direction": "horizontal",
                                          "fillColor": "transparent",
                                          "components": [
                                            {
                                              "id": "customList1",
                                              "title": "Custom List1",
                                              "width": "100%",
                                              "spacing": 12,
                                              "alignment": "left",
                                              "component": "container",
                                              "direction": "vertical",
                                              "components": [
                                                {
                                                  "id": "listItem4",
                                                  "title": "List Item4",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon4",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon4",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText4",
                                                      "text": "Live Local and Primetime Regular and Postseason Games on Mobile",
                                                      "title": "List Item Body Text4",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                }
                                              ],
                                              "namiComponentType": "customList"
                                            },
                                            {
                                              "id": "customList2",
                                              "title": "Custom List2",
                                              "width": "100%",
                                              "spacing": 12,
                                              "alignment": "left",
                                              "component": "container",
                                              "direction": "vertical",
                                              "components": [
                                                {
                                                  "id": "listItem7",
                                                  "title": "List Item7",
                                                  "width": "100%",
                                                  "height": "fitContent",
                                                  "spacing": 8,
                                                  "component": "container",
                                                  "direction": "horizontal",
                                                  "fillColor": "transparent",
                                                  "components": [
                                                    {
                                                      "id": "listItemIcon7",
                                                      "name": "CheckOutlined",
                                                      "title": "List Item Icon7",
                                                      "fontSize": 16,
                                                      "component": "symbol",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "icon"
                                                    },
                                                    {
                                                      "id": "listItemBodyText7",
                                                      "text": "NFL Pro (desktop & mobile web only)",
                                                      "title": "List Item Body Text7",
                                                      "width": "100%",
                                                      "height": "fitContent",
                                                      "fontName": "Helvetica",
                                                      "fontSize": 16,
                                                      "textType": "body",
                                                      "alignment": "left",
                                                      "component": "text",
                                                      "fontColor": "rgba(198 203 215 / 1)",
                                                      "namiComponentType": "bodyText"
                                                    }
                                                  ],
                                                  "namiComponentType": "listItem"
                                                }
                                              ],
                                              "namiComponentType": "customList"
                                            }
                                          ],
                                          "topPadding": 0,
                                          "borderColor": "transparent",
                                          "borderWidth": 0,
                                          "leftPadding": 0,
                                          "borderRadius": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "productWrapper",
                                          "verticalAlignment": "top",
                                          "horizontalAlignment": "center"
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.entitlements}",
                                          "expected": "nflplus_premium",
                                          "operator": "contains"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 15,
                                  "leftPadding": 15,
                                  "borderRadius": 0,
                                  "rightPadding": 15,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 15,
                                  "namiComponentType": "collapseBody"
                                }
                              ],
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "borderRadius": 0,
                              "collapseHeader": {
                                "id": "collapseHeader",
                                "title": "Collapse Header",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "rgba(220 220 220 / 0)",
                                "components": [
                                  {
                                    "id": "image2",
                                    "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ece8b1c1-690b-49be-8421-ba2c228ca852/media/77760f71-beda-4b94-b57c-c21620ea7977/CrossIcon.png",
                                    "title": "Image2",
                                    "width": 28,
                                    "height": 28,
                                    "alignment": "left",
                                    "component": "image",
                                    "imageCropping": "fit",
                                    "namiComponentType": "image"
                                  },
                                  {
                                    "id": "collapseHeaderTitleText",
                                    "text": "MORE NFL+ FEATURES",
                                    "title": "Collapse Header Title Text",
                                    "width": "100%",
                                    "fontName": "All-ProDisplayC-BoldItalic",
                                    "fontSize": 16,
                                    "textType": "title",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "rgba(255 255 255 / 1)",
                                    "topPadding": 0,
                                    "leftPadding": 0,
                                    "rightPadding": 0,
                                    "bottomPadding": 0,
                                    "namiComponentType": "titleText",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.entitlements}",
                                            "expected": "premium",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "text": "MORE NFL+ PREMIUM FEATURES"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "id": "collapseHeaderIcon",
                                    "name": "DownOutlined",
                                    "title": "Collapse Header Icon",
                                    "fontSize": 16,
                                    "component": "symbol",
                                    "fontColor": "rgba(198 203 215 / 1)",
                                    "namiComponentType": "icon",
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${state.openHeaderIds}",
                                            "expected": "collapse",
                                            "operator": "contains"
                                          }
                                        ],
                                        "attributes": {
                                          "name": "UpOutlined"
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "topPadding": 15,
                                "leftPadding": 15,
                                "borderRadius": 0,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight",
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 15,
                                "namiComponentType": "collapseHeader",
                                "conditionAttributes": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${state.openHeaderIds}",
                                        "expected": "collapse",
                                        "operator": "contains"
                                      }
                                    ],
                                    "attributes": {
                                      "roundBorders": [
                                        "upperLeft",
                                        "upperRight"
                                      ]
                                    }
                                  }
                                ]
                              },
                              "namiComponentType": "collapse"
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged. Promotional pricing may not be available on all platforms.\n\nLive preseason games are subject to local blackouts; certain games are restricted to mobile devices. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ece8b1c1-690b-49be-8421-ba2c228ca852/media/eb6e065f-d9f0-408d-b77e-7675d8edbe35/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA Image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "topPadding": 20,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 48,
              "rightPadding": 48,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ece8b1c1-690b-49be-8421-ba2c228ca852/media/fe2e237c-a904-4d90-a063-57517b36e5c2/desk25.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.orientation}",
                          "expected": "portrait",
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/ece8b1c1-690b-49be-8421-ba2c228ca852/media/b5ac1e2b-8719-4e66-94e9-e70eeb2e59ed/mob25.jpeg"
                      }
                    }
                  ]
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "3.1",
        "codename": "Frigate Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tablet",
        "changelog": "Add Game Availability schema",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "openHeaderIds": [],
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "1e56962e-67ef-43a8-8737-6d38aab3f782",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "fb07c9c0-f703-44b4-adc8-3f01b33f3f98",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "1e56962e-67ef-43a8-8737-6d38aab3f782",
          "selectedProducts": {
            "1e56962e-67ef-43a8-8737-6d38aab3f782": "ad764d0e-49ee-4c27-a16c-68ab92fd7f4c",
            "fb07c9c0-f703-44b4-adc8-3f01b33f3f98": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.2",
        "capabilities": [
          "custom_launch_context",
          "product_groups",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "conditional_product_groups",
          "featured_product",
          "accessibility",
          "custom_launch_object"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    },
    {
      "id": "eeec8188-3283-402e-91c0-75a52990a2a5",
      "name": "Frigate Web Desktop Base Annual",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "a0a4d99e-f5d1-44a7-9fe3-47e10d109e33",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "bda0aa40-492c-46e2-9ccc-e8cd23fda9a3",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [
            {
              "id": "202514a5-24d7-472c-9174-826148ce99a9",
              "featured": false,
              "name": "[REC] NFL+ Annual",
              "sku_ref_id": "nfl_plus_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "e43a48d9-42d9-4f68-9992-8d80f004593f",
                  "entitlement_ref_id": "nflplus",
                  "name": "NFL+",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "SIGN UP NOW",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "SIGN UP NOW",
                "IntroDuration": "/${sku.introductoryDuration}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "productBadgeText": "THE ULTIMATE NFL+ EXPERIENCE"
              }
            }
          ],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "4feca87c-916a-42a3-ad3c-2324dabdb1c5",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/eeec8188-3283-402e-91c0-75a52990a2a5/media/12898507-6be5-4596-90fd-4a4f8e14319f/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": 300,
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "LIMITED TIME OFFER",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 50,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "LIMITED TIME OFFER"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "titleText0",
                  "text": "Get 20% off an NFL+ Annual Plan!",
                  "title": "Title Text0",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 25,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(255 255 255 / 0.9)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Get 20% off an NFL+ Annual Plan!"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition5",
                          "title": "No Badge Spacer",
                          "hidden": true,
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "spacer1",
                              "title": "Spacer1",
                              "width": "100%",
                              "height": 32,
                              "component": "spacer",
                              "namiComponentType": "spacer"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 3,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    },
                                    {
                                      "id": "productText3",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": "30%",
                                      "title": "Product Text3",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 5,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 22,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "hostedImage1",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Hosted Image1",
                              "width": "100%",
                              "height": 32,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 290,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "Live Out-of-Market Preseason Games",
                                        "NFL Network",
                                        "Live Game Audio",
                                        "And More!"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList0BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 14,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 290,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList2BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List2 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 14,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText6",
                                      "text": "DESKTOP & MOBILE WEB ONLY",
                                      "title": "Title Text6",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList3",
                                      "texts": [
                                        "NFL Pro"
                                      ],
                                      "title": "Bullet List3",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 15,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent0",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List1 Bullet Component0",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "spacer3",
                                      "title": "Premium List Top Align Spacer",
                                      "component": "spacer",
                                      "namiComponentType": "spacer"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": 56,
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled.",
                      "title": "Legal Top",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nPromotional Terms: Offer Ends 9/15/2025. Promotional pricing applies to this year only. Following the promotional period, then-current annual subscription price will be charged.\n\nLive preseason games are subject to local and other geographic blackouts. Local games are the games that are available on TV in your market. Plan automatically renews at then-current price until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "group",
                      "title": "Legal Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "hidden": true,
                      "spacing": 12,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(0 0 0 / 0)",
                      "components": [
                        {
                          "id": "legalText0",
                          "text": "Local games are the games that are available on TV in your market.\n\nYour subscription will auto-renew at the then-current price for your subscription. Plan automatically renews until cancelled.",
                          "title": "Legal Bot",
                          "width": "100%",
                          "height": "fitContent",
                          "hidden": true,
                          "fontName": "All-ProSans-Regular",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "rgba(198 203 215 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "legalText",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.anySkuHasTrialOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                              }
                            },
                            {
                              "component": "condition",
                              "attributes": {
                                "text": "[Terms and Conditions Apply.](https://www.nfl.com/legal/subscriptions_terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                              },
                              "orAssertions": [
                                {
                                  "value": "${state.anySkuHasPromoOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                },
                                {
                                  "value": "${state.anySkuHasIntroOffer}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(51 51 51 / 0)",
                      "borderWidth": 2,
                      "leftPadding": 0,
                      "borderRadius": 8,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/paywall/eeec8188-3283-402e-91c0-75a52990a2a5/media/5f30422a-fc4f-4331-8589-0fd0aa9cefbe/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "condition6",
                      "title": "Show Login Button?",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "moveX": "0%",
                          "moveY": "0%",
                          "title": "Login Button Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "zIndex": 0,
                          "spacing": 5,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "strikethrough": false,
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 64,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 48,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [
                {
                  "id": "condition4",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "hostedImage",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Hosted Image",
                      "width": "100%",
                      "height": 500,
                      "alignment": "left",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e",
        "version": "1.4",
        "codename": "Frigate Web",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-web",
        "changelog": "Fixed Premium List alignment",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "a0a4d99e-f5d1-44a7-9fe3-47e10d109e33",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "bda0aa40-492c-46e2-9ccc-e8cd23fda9a3",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "bda0aa40-492c-46e2-9ccc-e8cd23fda9a3",
          "selectedProducts": {
            "a0a4d99e-f5d1-44a7-9fe3-47e10d109e33": null,
            "bda0aa40-492c-46e2-9ccc-e8cd23fda9a3": "202514a5-24d7-472c-9174-826148ce99a9"
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_groups"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "8d51ba92-6c9a-453e-b025-c76dbd83aea5",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Regular.ttf"
        },
        "All-ProSans-Bold": {
          "id": "03d80304-1e9c-48af-8c76-6679bbca06dd",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Bold.ttf"
        },
        "All-ProSans-Medium": {
          "id": "59d28f33-c0e9-4cf2-9aba-160c4ecb86b0",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Sans-Medium.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "553b533e-fc93-4cef-86ec-bd2e412a915e",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "f06ca16b-f5c0-4926-9223-eedd2c25df64",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content.namiml.com/org/9b51e64f-a6ad-4845-9a14-8ad51a4c3a5e/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        }
      }
    }
  ],
  "campaign_rules": [
    {
      "external_segment": null,
      "name": "Preauth Network CTV Anonymous",
      "rule": "9b0d6723-ea56-4ef0-b896-41b4a1bc092d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "7f03f50c-0440-4d39-b2b4-330f7b62865e",
          "segment": "060b01ca-b3e6-4bb6-b349-569504933f3a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "preauth_network"
    },
    {
      "external_segment": null,
      "name": "Mobile Web Generic Base Anonymous",
      "rule": "ee28014e-0977-48a5-bd7a-09d42adb6392",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "6ad3be09-3dce-41f4-8191-66b74a2abaed",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "web-direct-all"
    },
    {
      "external_segment": null,
      "name": "Desktop Web Generic Base Anonymous",
      "rule": "41ea1f7f-4b16-4d48-b559-15349aef1e93",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "dcbfde56-a437-44b8-8c95-7886b110d8b6",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "web-direct-all"
    },
    {
      "external_segment": null,
      "name": "Tablet Web Generic Base - Anonymous",
      "rule": "5b8d0435-b4a5-42f5-94fd-5fe29fcee050",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "8d9b4048-ad18-4a90-8f6a-540df97456c3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "web-direct-all"
    },
    {
      "external_segment": null,
      "name": "Mobile Web Generic Premium Anonymous",
      "rule": "b2d4e16e-8328-4304-b89f-8bd6b7ceadc3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "10c8c417-d6cd-4d80-bee3-edd548415e63",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "web-direct-premium"
    },
    {
      "external_segment": null,
      "name": "Desktop Web Generic Premium Anonymous",
      "rule": "a2c62034-4415-4625-98f5-9a45cc5f7b19",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "28b50c51-5978-4744-8804-3bd3d84eadd5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "web-direct-premium"
    },
    {
      "external_segment": null,
      "name": "Tablet Web Generic Premium - Anonymous",
      "rule": "b918623f-eaad-4e8e-a8e5-bba4ebc30101",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "36db8bc0-037c-4521-af01-84469d2bb01d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "web-direct-premium"
    },
    {
      "external_segment": null,
      "name": "Mobile Web NFL+ \u003E watch-live-card Anonymous",
      "rule": "1d261ee3-21cd-4478-9897-de4ea67e7368",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "28c43be7-8ab1-4c0e-8c2c-c8cc25a77d1f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "t-vcd6z9"
    },
    {
      "external_segment": null,
      "name": "Desktop Web NFL+ \u003E watch-live-card Anonymous",
      "rule": "d1a4938e-5062-4484-9696-c6741fbe7ab6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "f178c35b-d530-4b0f-94a6-d5aab66f7a7d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "t-vcd6z9"
    },
    {
      "external_segment": null,
      "name": "Tablet Web NFL+ \u003E watch-live-card - Anonymous",
      "rule": "0d59b3a1-183f-4b63-9d2c-9134c6196e57",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "c39de3ff-75da-45da-8aa1-b3de3a11452d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "t-vcd6z9"
    },
    {
      "external_segment": null,
      "name": "Mobile Web NFL+ \u003E nfl-network-hero-cta Anonymous",
      "rule": "0f70c2b8-f171-4c12-96c7-80c6576df6ea",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "b04b9be2-ad5b-4b8c-8b59-4ee0ef14d48c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "leo-rcc1"
    },
    {
      "external_segment": null,
      "name": "Desktop Web NFL+ \u003E nfl-network-hero-cta Anonymous",
      "rule": "eeeacd3e-b9e3-436b-a244-380fb538bd6a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "f66296a4-9a25-4534-92e8-2237a7b19dc3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "leo-rcc1"
    },
    {
      "external_segment": null,
      "name": "Tablet Web NFL+ \u003E nfl-network-hero-cta - Anonymous",
      "rule": "8fe88118-1875-4024-bd50-f459554fbf47",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "0e735aa4-b709-46ba-9f93-23bbf0d991df",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "leo-rcc1"
    },
    {
      "external_segment": null,
      "name": "Mobile Web NFL+ \u003E RedZone \u003E redzone-hero-cta Anonymous",
      "rule": "be206235-e84c-47d7-a9de-ff8a3efd8b76",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "b3daa3a8-e2b1-4ac5-8be7-dd65d0969ce1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "dnhotyne"
    },
    {
      "external_segment": null,
      "name": "Desktop Web NFL+ \u003E RedZone \u003E redzone-hero-cta Anonymous",
      "rule": "134abf36-ace4-4b74-96d4-f00563569d6f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "bde2e8b1-ab2c-409e-b857-5ab07c409bb3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "dnhotyne"
    },
    {
      "external_segment": null,
      "name": "Tablet NFL+ \u003E RedZone \u003E redzone-hero-cta - Anonymous",
      "rule": "2526501b-97f4-4f0b-83bf-bb495951d9db",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "d44a5767-51e7-42c6-bfd1-946431358d07",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "dnhotyne"
    },
    {
      "external_segment": null,
      "name": "Mobile Web NFL+ \u003E redzone-hero-cta Anonymous",
      "rule": "4a27bcf3-3a2b-46ff-ac8a-b51d4d662695",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "e68b804f-f9e7-4e16-8a17-28d7b3d62bc6",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "dnhotppl"
    },
    {
      "external_segment": null,
      "name": "Desktop Web NFL+ \u003E redzone-hero-cta Anonymous",
      "rule": "e533a1f9-069b-4d00-8296-d95d50da647d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "c2b8e74b-acf5-4926-a321-3841c502a86f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "dnhotppl"
    },
    {
      "external_segment": null,
      "name": "Tablet Web NFL+ \u003E redzone-hero-cta - Anonymous",
      "rule": "1e5b6b4b-c8ee-4407-b8ca-84c6125ea56e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "8bd6772f-2e03-40ce-9b79-6cf679fae57c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "dnhotppl"
    },
    {
      "external_segment": null,
      "name": "Mobile Web NFL+ \u003E replay-card Anonymous",
      "rule": "45415f49-42ff-450c-bbd3-61c4d424d878",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "6ee0d573-58c9-4a83-8c2c-858cc68efacd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pyaelycr"
    },
    {
      "external_segment": null,
      "name": "Desktop Web NFL+ \u003E replay-card Anonymous",
      "rule": "fcb4f3b6-ece5-4475-924a-49c538d1f322",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "c9d20fb6-da28-48f1-b8b8-ff7157561b91",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pyaelycr"
    },
    {
      "external_segment": null,
      "name": "Tablet NFL+ \u003E replay-card - Anonymous",
      "rule": "557d251c-687d-45ac-ad89-8b96bf787599",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "a662596a-cb98-41ce-a60b-69319e2777c8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pyaelycr"
    },
    {
      "external_segment": null,
      "name": "Mobile Web NFL+ \u003E listen-live-card Anonymous",
      "rule": "672bc06b-309a-4262-98e0-fa25cba15f75",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "90acc917-39ed-4825-89d2-d1a9c5f988d5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sni-r8xs"
    },
    {
      "external_segment": null,
      "name": "Desktop Web NFL+ \u003E listen-live-card Anonymous",
      "rule": "517374cf-68e9-424a-85d5-05001d7636b4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "22c0a012-69e9-49da-b525-92d8af0945c7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sni-r8xs"
    },
    {
      "external_segment": null,
      "name": "Tablet Web NFL+ \u003E listen-live-card - anonymous",
      "rule": "18710e3f-d3aa-4b83-af30-94f111e95425",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "0b43d078-08b2-47bc-b21e-7929fbd5e0db",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sni-r8xs"
    },
    {
      "external_segment": null,
      "name": "Mobile Web Test All Anonymous",
      "rule": "d771eee2-a70e-47b5-ab1c-01c9f9e31a5d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "bec5b7cd-6489-4611-aa18-c6de8a547d28",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "tst-all-p"
    },
    {
      "external_segment": null,
      "name": "Desktop Web Test All Anonymous",
      "rule": "86faaf7c-6e77-415b-a56e-bb535360cf4f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "d004d79d-854a-42a8-8a50-e809ca4c6758",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "tst-all-p"
    },
    {
      "external_segment": null,
      "name": "Mobile Web Test Premium Anonymous",
      "rule": "e5d5d13d-3cb7-4324-8e6f-13ff3c75097f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "df32ddb0-f5a3-4ddb-992b-b7fd6307d52e",
          "segment": "c886d9ff-9e06-4347-80ab-4071d09c1e5c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "tst-premium-p"
    },
    {
      "external_segment": null,
      "name": "Desktop Web Test Premium Anonymous",
      "rule": "132f2eaa-dc91-47a4-b17c-eb498037f9e4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ac2bd315-859a-4d60-a808-89729c45ab4d",
          "segment": "6f78c3d7-50ec-4423-bf33-b0f0790cf09d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "tst-premium-p"
    },
    {
      "external_segment": null,
      "name": "Marketing All Game Mobile Web Anonymous",
      "rule": "1810cec9-5347-4fb8-b1f6-617e3b3dc0bb",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "f2edb755-a479-4534-b279-3761d62aa434",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-al"
    },
    {
      "external_segment": null,
      "name": "Marketing All Game Desktop Web Anonymous",
      "rule": "56e6a387-6bfb-472d-a5bb-67938c6de59b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "f6200f13-aea3-4a3a-9831-37e851c1643d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-al"
    },
    {
      "external_segment": null,
      "name": "all products tablet web anonymous",
      "rule": "19b52207-6f66-44b6-9e88-41bb4bd260fa",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "667a9bed-dc50-4240-af7f-d1b5709d8d6f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-al"
    },
    {
      "external_segment": null,
      "name": "RedZone Web Tablet Anonymous",
      "rule": "8a8167a9-9b33-477d-b69c-f40c6354e18c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "c7c25b68-33f7-4be8-ab80-8a3889671db1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "rdze"
    },
    {
      "external_segment": null,
      "name": "Mobile Web M Premium Campaign Anonymous",
      "rule": "f2a1195b-f870-4129-a12a-387030bdd7d7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "df32ddb0-f5a3-4ddb-992b-b7fd6307d52e",
          "segment": "d084335a-28b8-49bc-8241-cecae0832b89",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "rdze"
    },
    {
      "external_segment": null,
      "name": "Desktop Web M Premium Campaign Anonymous",
      "rule": "e7883f6f-bf52-4b15-af06-8f66a98fae1c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ac2bd315-859a-4d60-a808-89729c45ab4d",
          "segment": "3992a4fe-c6c2-4391-ac8f-f501aa833256",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "rdze"
    },
    {
      "external_segment": null,
      "name": "generic-premium mobile web anonymous",
      "rule": "8a2a4003-4010-49bd-a076-5c7287bccc0c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "e99cc706-b98e-444f-b2b2-1a448315aedf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pm"
    },
    {
      "external_segment": null,
      "name": "generic-premium tablet web anonymous",
      "rule": "b8c83ee2-4b74-492c-9bf3-1aac9d006147",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "2ae2c7af-1521-435e-8109-325c97a545c2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pm"
    },
    {
      "external_segment": null,
      "name": "generic-premium desktop web anonymous",
      "rule": "031b61c7-3a8e-401b-a0f1-ad5361b5d138",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "3f724b5b-79ae-4c6a-8899-fbaf4230c1a8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pm"
    },
    {
      "external_segment": null,
      "name": "Marketing Custom Game Mobile Web Anonymous",
      "rule": "3cf038a0-4957-4e28-b6c8-a8f8d8342e4a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "a56ae1f7-4535-4154-b1f0-10b238062405",
          "segment": "3a8b7506-f66e-4cea-8229-37f378af1ac3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "le-ge-gc"
    },
    {
      "external_segment": null,
      "name": "Marketing Custom Game Desktop Web Anonymous",
      "rule": "9d175371-ae7a-4354-93a5-6ed13ad65c83",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "917764d9-a0de-4bab-837a-49de1808b651",
          "segment": "afd9384f-7b7f-48bf-a8e1-4af17321819d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "le-ge-gc"
    },
    {
      "external_segment": null,
      "name": "Marketing Custom Game Tablet Web Anonymous",
      "rule": "a87e7814-b976-40d2-950c-e8c2133c7677",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "558e6971-00da-4190-853f-997b63af22d9",
          "segment": "5939febd-11bf-45c5-b58f-a78326cfc1a0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "le-ge-gc"
    },
    {
      "external_segment": null,
      "name": "Fan J Base Monthly Mobile Web Anonymous",
      "rule": "b8896699-a783-4d13-8374-b2350397b8d2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "6fd723c4-2342-44c5-a0d3-95ae223f95d7",
          "segment": "5b6c290c-cf11-4f24-b1cb-54efeacfdf89",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "bc-my"
    },
    {
      "external_segment": null,
      "name": "Fan J Base Monthly Desktop Web Anonymous",
      "rule": "6e42db21-fced-4200-a9ec-e01c0650e3b6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "87333cdc-c3e1-4474-881b-89463a7621b1",
          "segment": "d0d53195-381d-4fc0-a3e1-55adf0174cd8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "bc-my"
    },
    {
      "external_segment": null,
      "name": "Fan J Base Annual Mobile Web Anonymous",
      "rule": "26ffe1dd-a072-4c4f-bd60-8163e3777a8f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "9e2addb5-752b-40c8-824e-e50997379b1f",
          "segment": "a0f3ae41-bc5b-402d-bd7f-ecaebac372cd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "bc-al"
    },
    {
      "external_segment": null,
      "name": "Fan J Base Annual Desktop Web Anonymous",
      "rule": "808d47a9-2d28-411f-ad0f-476cedb04bea",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "eeec8188-3283-402e-91c0-75a52990a2a5",
          "segment": "e9dfea6d-5da6-43ac-a8cc-8c0579eee842",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "bc-al"
    },
    {
      "external_segment": null,
      "name": "Fan J Premium Monthly Mobile Web Anonymous",
      "rule": "ab748ccd-69c6-41e0-9844-db019d34fee7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "de246ff5-93d2-4b28-8c2b-eca06cf93fd5",
          "segment": "83594a7d-62b2-4de0-8ccc-2061fff80e07",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pm-my"
    },
    {
      "external_segment": null,
      "name": "Fan J Premium Monthly Desktop Web Anonymous",
      "rule": "1b4a369a-421a-4b09-bba8-f084bc1623c0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "29b79180-78ed-4a62-9765-ef41cf061037",
          "segment": "e0d0a844-48df-4d27-9116-213b5b9357c2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pm-my"
    },
    {
      "external_segment": null,
      "name": "Fan J Premium Annual Mobile Web Anonymous",
      "rule": "213a95c7-f17a-40cb-84a3-33edd8e8fd25",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "70e4fe0e-f372-4e73-ac68-d0876336644b",
          "segment": "3e57af69-a937-4e42-b906-28fdb7f4e439",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pm-al"
    },
    {
      "external_segment": null,
      "name": "Fan J Premium Annual Desktop Web Anonymous",
      "rule": "c152660e-3894-4b0d-9d13-331e7f2d6096",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "51c383f6-45cb-46a0-9d62-0192900ab49b",
          "segment": "391f588e-7804-430a-abdc-659d9e6baadf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "pm-al"
    },
    {
      "external_segment": null,
      "name": "Top Hat Nav mobile web anonymous",
      "rule": "533c6f00-e3e5-4728-b04c-61e5470aabae",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "6b48e9db-4102-454d-ad6d-e07bb704d5db",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-tp-ht-nv"
    },
    {
      "external_segment": null,
      "name": "Top Hat Nav desktop web anonymous",
      "rule": "fe183a4a-e78b-4b14-a527-3340423fa047",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "269bae37-84ce-463d-9033-0d9c72b15117",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-tp-ht-nv"
    },
    {
      "external_segment": null,
      "name": "Top Hat Nav tablet web anonymous",
      "rule": "8df712cc-5f91-467d-b30a-6c8639f279db",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "d7316285-bc0a-4a00-a226-a784bb43a4b9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-tp-ht-nv"
    },
    {
      "external_segment": null,
      "name": "NFL+ In line promo mobile web anonymous",
      "rule": "6b622411-8375-42c1-b589-185aea6d8453",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "7738187f-46c0-4803-bf92-3911d368959f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ps-in-le-po"
    },
    {
      "external_segment": null,
      "name": "NFL+ In line promo tablet web anonymous",
      "rule": "69d3ff46-4008-4147-b9f8-ecbaa6ae585f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "464d4cac-8f67-428e-9eb2-4de30692e24f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ps-in-le-po"
    },
    {
      "external_segment": null,
      "name": "NFL+ In line promo desktop web anonymous",
      "rule": "8d66072e-bf5e-464b-8aac-cd9a86db61ab",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "8bc4681b-bdbc-455a-a31c-6363ebf84819",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ps-in-le-po"
    },
    {
      "external_segment": null,
      "name": "Promo End Card - NFL+ mobile web anonymous",
      "rule": "5ade7ec7-63fb-40e5-aa5c-c67c158225f7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "731a538c-69be-4cfb-beb6-9dc561854cfe",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-po-ed-cd-ps"
    },
    {
      "external_segment": null,
      "name": "Promo End Card - NFL+ tablet web anonymous",
      "rule": "f6d9751a-4ec7-4fd9-a508-8e07b994ce0f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "ae229670-7fd7-41da-b72f-2a3ab47523a9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-po-ed-cd-ps"
    },
    {
      "external_segment": null,
      "name": "Promo End Card - NFL+ desktop web anonymous",
      "rule": "111607fe-4677-40f0-a7af-be5d943bc713",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "734eb5e6-a71e-4b10-bd4d-524b0723c0b1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-po-ed-cd-ps"
    },
    {
      "external_segment": null,
      "name": "Centerpiece mobile web anonymous",
      "rule": "d85043ef-5359-4c0d-a392-d280ac991b2e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "b5d9a89d-fe2a-4b8c-b887-1d467f8079df",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ce-ps"
    },
    {
      "external_segment": null,
      "name": "Centerpiece tablet web anonymous",
      "rule": "fb2983bc-5fc8-422c-9af2-f9b8dc7346a4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "4c2f59ce-0762-41a4-a3ca-49fe8dc04a7c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ce-ps"
    },
    {
      "external_segment": null,
      "name": "Centerpiece desktop web anonymous",
      "rule": "4b1dd103-293e-4132-b96e-0a3f81028877",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "2a08e9e1-6ca3-4847-ae62-2e7de1cb29ac",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ce-ps"
    },
    {
      "external_segment": null,
      "name": "Editorial tray mobile web anonymous",
      "rule": "0358216b-26ed-4592-a55d-3504bafa493c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "bc46b2af-18e7-40bf-be2f-dfeeaa1db21c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-el-ty-ps"
    },
    {
      "external_segment": null,
      "name": "Editorial tray tablet web anonymous",
      "rule": "5abcc78e-11af-4cc5-9921-2d1c609b7632",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "7371071d-38ce-4510-8d7a-d7a041434252",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-el-ty-ps"
    },
    {
      "external_segment": null,
      "name": "Editorial tray desktop web anonymous",
      "rule": "d6f79c1e-a77e-438c-9a71-41605308a3d7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "4ee18eca-3289-4797-b6b9-96bad035cf22",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-el-ty-ps"
    },
    {
      "external_segment": null,
      "name": "Headline Stack mobile web anonymous",
      "rule": "c1b38794-7232-4d1c-b74a-23ef0cd54c6d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "8fc4f4b0-0b96-4c44-bd15-e12e5d463670",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-he-sk-ps"
    },
    {
      "external_segment": null,
      "name": "Headline Stack tablet web anonymous",
      "rule": "6c196adb-275e-43ab-acb8-4c35159233b6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "fce30c1f-b2ae-403a-b96c-f0414d293867",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-he-sk-ps"
    },
    {
      "external_segment": null,
      "name": "Headline Stack desktop web anonymous",
      "rule": "14aea0ab-b892-4bd1-85bd-48db2e5f6983",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "b2bb6a97-e55b-46a8-b430-b64e525768d5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-he-sk-ps"
    },
    {
      "external_segment": null,
      "name": "Countdown Banner mobile web anonymous",
      "rule": "68197d6f-efb9-4417-a581-edc5eddbde40",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "49a95a2d-84c7-4271-82a2-dde5fb4e6050",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-cn-br-ps"
    },
    {
      "external_segment": null,
      "name": "Countdown Banner tablet web anonymous",
      "rule": "340e8cc4-9a82-4a2c-bad9-bdc9ee37bb1c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "bca8a20f-aa5e-4da2-b0cf-ff84721e2bac",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-cn-br-ps"
    },
    {
      "external_segment": null,
      "name": "Countdown Banner desktop web anonymous",
      "rule": "5b8efb35-16f0-401b-b488-761ec822343a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "e685c049-5726-49f4-9943-5100a201f57c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-cn-br-ps"
    },
    {
      "external_segment": null,
      "name": "Subscribe sub nav button mobile web anonymous",
      "rule": "88a5aedb-2e06-4576-a883-d674a2799bdf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "8d143e47-fcd1-47bf-8a38-91e16035e329",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-se-sb-nv-bn"
    },
    {
      "external_segment": null,
      "name": "Subscribe sub nav button tablet web anonymous",
      "rule": "86ecb66f-df2c-4437-8f9d-24a307be94b1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "bc5f9f95-bb06-4327-9c26-0c155865a82f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-se-sb-nv-bn"
    },
    {
      "external_segment": null,
      "name": "Subscribe sub nav button desktop web anonymous",
      "rule": "88c04737-23c4-44cd-8fc7-d02044f64dc4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "b494ba87-631f-48a4-9f4c-dfa4001f3aaf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-se-sb-nv-bn"
    },
    {
      "external_segment": null,
      "name": "NFL+ Exclusive VOD Card mobile web anonymous",
      "rule": "e1fe930a-ae45-4c66-85da-01ac172c6c8b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "44aad865-3308-4ee6-a695-0fbc2d3febd9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-ee-vd-cd"
    },
    {
      "external_segment": null,
      "name": "NFL+ Exclusive VOD Card tablet web anonymous",
      "rule": "5f49fcd7-404e-4d64-b871-0345687041f0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "a1989687-e79a-416e-9214-9fe732b53de2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-ee-vd-cd"
    },
    {
      "external_segment": null,
      "name": "NFL+ Exclusive VOD Card desktop web anonymous",
      "rule": "7f41f01c-6ba5-4ea5-af88-af31a5349b49",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "0ed529c3-f216-41a7-906f-7f417973c793",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-ee-vd-cd"
    },
    {
      "external_segment": null,
      "name": "Network Hero Card mobile web anonymous",
      "rule": "939ded59-4236-4509-82a2-53bc96d18e35",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "f2319959-002c-4e44-a9f9-d884ab2f73dd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-nk-nk-ho-cd"
    },
    {
      "external_segment": null,
      "name": "Network Hero Card tablet web anonymous",
      "rule": "70205955-20c2-4b91-868d-7ebdd80da1b9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "03bc0c97-90f6-4d32-9c4a-3fdc5d174a0e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-nk-nk-ho-cd"
    },
    {
      "external_segment": null,
      "name": "Network Hero Card desktop web anonymous",
      "rule": "47b63be5-4277-4873-9c3f-88990344f453",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "c834d2fd-f3bd-47eb-bf10-c513c6253f59",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-nk-nk-ho-cd"
    },
    {
      "external_segment": null,
      "name": "Page navigation mobile web anonymous",
      "rule": "59078f7f-0eda-4e0a-a802-62d2143a1790",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "7d8aa7a4-48d2-4092-b265-090fac05a06e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-ss-pe-nn"
    },
    {
      "external_segment": null,
      "name": "Page navigation tablet web anonymous",
      "rule": "1915518a-7552-4f43-947b-3f16a9c33880",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "4e3b1518-162a-416f-9858-6b9f70e6acdd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-ss-pe-nn"
    },
    {
      "external_segment": null,
      "name": "Page navigation desktop web anonymous",
      "rule": "7c76d9df-3ef3-40c4-a48a-c37b6082734b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "39c47285-4615-47cb-930d-5e8f821c066e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-ss-pe-nn"
    },
    {
      "external_segment": null,
      "name": "Hero subscribe mobile web anonymous",
      "rule": "3df006f7-b3d2-4fe5-93e6-3b44d617998e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "99b08424-acb6-4c93-a095-74395ff6a02f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-ho-se"
    },
    {
      "external_segment": null,
      "name": "Hero subscribe tablet web anonymous",
      "rule": "95419420-e156-4e6e-b8c9-ba17637e24ac",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "e7766094-c4b2-4edc-b37c-57496bcae950",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-ho-se"
    },
    {
      "external_segment": null,
      "name": "Hero subscribe desktop web anonymous",
      "rule": "671eb793-612a-49fd-a884-401ad986b04d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "cc572210-30f1-417b-a653-058a5d24e780",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-ho-se"
    },
    {
      "external_segment": null,
      "name": "Floating subscribe mobile web anonymous",
      "rule": "4203949a-136b-4157-984c-4115ef91011a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "2ced8be1-4c70-4c56-a5dd-bb04e79c213f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-fg-se"
    },
    {
      "external_segment": null,
      "name": "Floating subscribe tablet web anonymous",
      "rule": "bb1eee5e-71f2-4564-a24d-4164909927db",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "098d3ac8-3e64-4615-938e-481c2fe00d59",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-fg-se"
    },
    {
      "external_segment": null,
      "name": "Floating subscribe desktop web anonymous",
      "rule": "fb880114-e855-45e3-8324-9ae99ce55744",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "e0f6884d-6998-450a-ab01-96773a420845",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-fg-se"
    },
    {
      "external_segment": null,
      "name": "Games card mobile web anonymous",
      "rule": "a75839c8-45a2-4080-82bb-7e6032a2b1f6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "84aeb748-4de1-4a22-bec6-73f863c596d4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-gs-cd"
    },
    {
      "external_segment": null,
      "name": "Games card tablet web anonymous",
      "rule": "3d127287-dac4-44df-b40e-094c88fcf355",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "2c8f9178-f6ed-4d3c-872a-6718823195c2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-gs-cd"
    },
    {
      "external_segment": null,
      "name": "Games card desktop web anonymous",
      "rule": "0100106d-1592-4a68-a588-589120d536ff",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "ca17f023-5162-4273-ac40-ba00119f9406",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-gs-cd"
    },
    {
      "external_segment": null,
      "name": "NFL+ Exclusive VOD Card mobile web anonymous",
      "rule": "41e347a4-54d7-4d9f-b7bc-f0c8b73b87b5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "01ae68d9-3924-4120-9a32-f24c157b5d8e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-ps-ty"
    },
    {
      "external_segment": null,
      "name": "NFL+ Exclusive VOD Card tablet web anonymous",
      "rule": "b3a39d82-4b86-4c95-827a-d116f23d05c3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "65d4e8b0-be5f-45c6-af4f-5bedd546825a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-ps-ty"
    },
    {
      "external_segment": null,
      "name": "NFL+ Exclusive VOD Card desktop web anonymous",
      "rule": "c3d45db3-79c6-488e-919a-791ddda793a8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "2d49a587-6927-44dd-94e9-4bf71396c3e4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-ps-ty"
    },
    {
      "external_segment": null,
      "name": "network card mobile web anonymous",
      "rule": "6ef9804e-9b8f-447c-8796-f996b44abc61",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "3d1c0bea-c98e-4121-8b76-ac4439c79c96",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-fs-ty"
    },
    {
      "external_segment": null,
      "name": "network card tablet web anonymous",
      "rule": "8d6c12b2-0519-4e9e-8926-aaf8c6edce37",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "22ba6329-04dd-4c97-b367-38f26ec7f43e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-fs-ty"
    },
    {
      "external_segment": null,
      "name": "network card desktop web anonymous",
      "rule": "0475b38b-52cc-4ea4-883d-0176f3d3bab3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "09e90a9d-f386-4b11-893a-52b41e3473ab",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-fs-ty"
    },
    {
      "external_segment": null,
      "name": "watch-live-cta mobile web anonymous",
      "rule": "0d3855c7-5a87-4e1f-94e2-e6ca85eb00fd",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "a3dc7601-6345-4ffc-97c6-6d75b3582965",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-wh-le-ca"
    },
    {
      "external_segment": null,
      "name": "watch-live-cta tablet web anonymous",
      "rule": "a7b268a6-bf19-4870-8f3a-2dbb2765ed8d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "cebdda70-965f-4618-a5de-886f1262f236",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-wh-le-ca"
    },
    {
      "external_segment": null,
      "name": "watch-live-cta desktop web anonymous",
      "rule": "04127638-fe31-4ceb-a723-cf3f11e5aef2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "8ae5ab5b-f948-4e6e-803a-7e6dd85923ea",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-wh-le-ca"
    },
    {
      "external_segment": null,
      "name": "listen-live-cta mobile web anonymous",
      "rule": "acde5db2-8beb-40b4-a929-6e6b6791d631",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "9d146020-7014-49bb-9db8-1fcfe71305c3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ln-le-ca"
    },
    {
      "external_segment": null,
      "name": "listen-live-cta tablet web anonymous",
      "rule": "fe72cf01-5573-4f30-98d8-36f8c7e300b4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "e3fc0adf-8fd2-4894-981c-e0d93764caf5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ln-le-ca"
    },
    {
      "external_segment": null,
      "name": "listen-live-cta desktop web anonymous",
      "rule": "9afe784e-dbd7-47ca-86bb-7d204324e7cd",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "fd019e3f-bc4f-464d-a51b-c1313b87fc2b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ln-le-ca"
    },
    {
      "external_segment": null,
      "name": "VPO subscribe mobile web anonymous",
      "rule": "013ff106-b9a6-4130-b181-d0667f37aebf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "bd8b85ad-3373-4f1c-9b2a-b3c32ad19694",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-vo-se-wh"
    },
    {
      "external_segment": null,
      "name": "VPO subscribe tablet web anonymous",
      "rule": "61099fea-ead2-4a13-a074-f13d28cfdc9a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "41b5960c-acdf-48a6-93be-c9a0559d98d1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-vo-se-wh"
    },
    {
      "external_segment": null,
      "name": "VPO subscribe desktop web anonymous",
      "rule": "00274a4a-f51d-428f-84dd-ecd39a8b76ce",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "ab3a1f0a-1a24-4515-99ae-eefcaa10e589",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-vo-se-wh"
    },
    {
      "external_segment": null,
      "name": "watch-live-card mobile web anonymous",
      "rule": "9955e9b7-f0cf-4e94-9fd1-13d3a34d777b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "601ede8c-ccd1-49e1-a1d0-282adccc7c95",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wh-le-cd"
    },
    {
      "external_segment": null,
      "name": "watch-live-card tablet web anonymous",
      "rule": "7ce48538-937c-4fc1-a18c-3bd7e8c9da8e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "1165d242-f3ca-4b7e-a3b6-231a61b214c3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wh-le-cd"
    },
    {
      "external_segment": null,
      "name": "watch-live-card desktop web anonymous",
      "rule": "aae0ae76-bc36-43ee-a725-accecb9b0baf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "63e05088-5de5-47c9-98d9-7f16ed6e1c69",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wh-le-cd"
    },
    {
      "external_segment": null,
      "name": "listen-live-card mobile web anonymous",
      "rule": "1b4d1718-f181-4637-acb3-55f02459749b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "aa8d0e6f-dbb4-4b3d-9e49-a2cfdc063f96",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ln-le-cd"
    },
    {
      "external_segment": null,
      "name": "listen-live-card tablet web anonymous",
      "rule": "a2a847d9-7b33-4c70-95f7-f77b3a0d4754",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "317c8e73-ea6c-49df-ac66-c5e71355666d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ln-le-cd"
    },
    {
      "external_segment": null,
      "name": "listen-live-card desktop web anonymous",
      "rule": "9008594e-ed42-4c3b-8de6-df206a6f0305",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "f3130e48-e463-419c-b1c2-6e199c84dbb2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ln-le-cd"
    },
    {
      "external_segment": null,
      "name": "listen subscribe cta mobile web anonymous",
      "rule": "096b8d7f-2735-421a-a7c6-3c6f217eb4a3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "69208f50-d25d-471f-aa7b-0654a84b6151",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ln-se-ca"
    },
    {
      "external_segment": null,
      "name": "listen subscribe cta tablet web anonymous",
      "rule": "4ebb46a7-cc3d-4201-88a6-761fe9fe3a25",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "f758afb7-1822-4d10-b5a2-f8bf7cd14a6d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ln-se-ca"
    },
    {
      "external_segment": null,
      "name": "listen subscribe cta desktop web anonymous",
      "rule": "b20deaee-7205-4f69-8d2a-8a641fdade36",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "4de0c415-7685-4c38-88de-a2980b575639",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ln-se-ca"
    },
    {
      "external_segment": null,
      "name": "Favorite Team Card mobile web anonymous",
      "rule": "55047e3b-bfa7-4c8e-94a6-e22d334b9c37",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "488ae52b-c87f-43f3-b7b3-db82d2ff94d7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-fe-tm-cd"
    },
    {
      "external_segment": null,
      "name": "Favorite Team Card desktop web anonymous",
      "rule": "2de564f0-17f8-44c6-b14c-cea6177202cf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "d328992d-afb3-43d9-ab83-298968eef9c2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-fe-tm-cd"
    },
    {
      "external_segment": null,
      "name": "Favorite Team Card tablet web anonymous",
      "rule": "647f0a5f-2dfa-4f2d-b54f-e5d9255595d1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "c379a8a4-6ccc-4bf1-84fe-486de3d30243",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-fe-tm-cd"
    },
    {
      "external_segment": null,
      "name": "Replays Card mobile web anonymous",
      "rule": "7952054f-6a8f-4f14-96cb-0461b9f9480e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "47873714-f3c0-41a2-b3ff-29c9db71e333",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-rs-cd"
    },
    {
      "external_segment": null,
      "name": "Replays Card tablet web anonymous",
      "rule": "5d8ecfa5-de2b-4b3f-a980-01b2b824b192",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "66686620-1290-4cec-90e7-3ce2889eb061",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-rs-cd"
    },
    {
      "external_segment": null,
      "name": "Replays Card desktop web anonymous",
      "rule": "b0e47c4e-87b0-427f-95e5-f21c522c45b8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "d3ae0d58-a109-447c-a1dc-51eadbba1473",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-rs-cd"
    },
    {
      "external_segment": null,
      "name": "NFL+ In line promo premium mobile web anonymous",
      "rule": "91068c76-5b2f-41c5-8bf2-9949770a3434",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "00e304ed-25ad-4eb8-b961-2fef6dea4738",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ps-in-le-po-pm"
    },
    {
      "external_segment": null,
      "name": "NFL+ In line promo premium tablet web anonymous",
      "rule": "1c74a99d-f0a2-4d86-a613-b9c5b8eb6ec5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "05669271-7195-4893-be13-f657fab0de2b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ps-in-le-po-pm"
    },
    {
      "external_segment": null,
      "name": "NFL+ In line promo premium desktop web anonymous",
      "rule": "3e634133-8167-4e2b-8101-7bbe959cb50e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "35499b4a-6e75-4753-b11a-a498b9c99831",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ps-in-le-po-pm"
    },
    {
      "external_segment": null,
      "name": "Promo End Card - NFL + Premium mobile web anonymous",
      "rule": "4db2b2a0-2d3d-43ed-875c-4859756f323c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "de6e7a66-6929-4efe-be6f-52c4a9e9f0d3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-po-ed-cd-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Promo End Card - NFL + Premium tablet web anonymous",
      "rule": "edc4e18c-60a3-484e-9313-60a284696fce",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "fbbdc6d6-5f69-4b66-9cc2-fa0753f854bb",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-po-ed-cd-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Promo End Card - NFL + Premium desktop web anonymous",
      "rule": "617ccda6-988c-42e7-bfa7-5b6c4ffbe30d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "c524d313-67a1-42a4-a7fa-861897ac9c29",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-po-ed-cd-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Centerpiece Premium mobile web anonymous",
      "rule": "da19c01d-e7f5-4042-a68f-bdc17ab036c0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "85320eb5-8bb6-4b6b-95af-cd4e13560645",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ce-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Centerpiece Premium tablet web anonymous",
      "rule": "7e59697e-08f1-4805-9442-6899fe899208",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "0e230d77-e9b7-427a-aa2d-d22b5e766039",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ce-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Centerpiece Premium desktop web anonymous",
      "rule": "ee0e1e4f-0239-4340-a790-f3c3ae0c86a6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "2588ea73-cbd1-4a5e-80d2-a4e3f5063f3e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-ce-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Editorial tray Premium mobile web anonymous",
      "rule": "dfacd281-f856-4e2e-a58a-0fc3b090d7d5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "67eb0314-0ea1-47c1-ad65-8dc7a0ec6094",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-el-ty-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Editorial tray Premium tablet web anonymous",
      "rule": "81082e71-5d88-49e7-a933-1abc0430e7d3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "e6b2ca92-135d-47c8-9dc2-7bf13fa591da",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-el-ty-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Editorial tray Premium desktop web anonymous",
      "rule": "6ac04033-0b47-4798-9a1f-68809a67e77a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "d741cee0-6412-41cc-ba7b-98634423e26e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-el-ty-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Headline Stack Premium mobile web anonymous",
      "rule": "d1d14273-36bb-489d-bef5-59e5947a989e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "47adf8f0-5f97-4317-abb9-b15877eb407a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-he-sk-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Headline Stack Premium tablet web anonymous",
      "rule": "183180b0-be5f-4557-bb09-71911daad810",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "d2e1f8ea-9e6b-41ef-9898-ef6a712f61d4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-he-sk-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Headline Stack Premium desktop web anonymous",
      "rule": "beae483d-9c8d-4ade-ab3a-6b34bf5b7617",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "b8c022bd-82b8-4750-af0f-ac8618e87581",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-he-sk-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Countdown Banner Premium mobile web anonymous",
      "rule": "1222eaa6-14af-482a-b566-1995c826f72a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "2341ed67-b97e-4b2d-a663-137b4b00a5c5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-cn-br-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Countdown Banner Premium tablet web anonymous",
      "rule": "aea27e5d-7636-42b6-a5fa-3099c215acf8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "86d20743-b62f-4fb5-b244-51be734b63ee",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-cn-br-ps-pm"
    },
    {
      "external_segment": null,
      "name": "Countdown Banner Premium desktop web anonymous",
      "rule": "c7a051f2-359c-43ef-946c-64b03046c163",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "6b78e8b0-ee4e-4c9f-b814-06610cb140f7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "he-cn-br-ps-pm"
    },
    {
      "external_segment": null,
      "name": "NFL+ Premium Exclusive VOD Card mobile web anonymous",
      "rule": "b3f9d021-3323-4c08-8f48-82a411bc5760",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "fd1763df-40e2-44b5-adc2-d724badf9f37",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-pm-ee-vd-cd"
    },
    {
      "external_segment": null,
      "name": "NFL+ Premium Exclusive VOD Card tablet web anonymous",
      "rule": "26a743de-867d-439d-8599-48d06b84a6a3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "a7aa528e-281f-42a2-ba2f-7d6743002486",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-pm-ee-vd-cd"
    },
    {
      "external_segment": null,
      "name": "NFL+ Premium Exclusive VOD Card desktop web anonymous",
      "rule": "1fcb0371-e0fb-4bb9-aadb-65e0e5625ea9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "660ca2b8-fc1a-436f-ad20-6aa3c55e5976",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-pm-ee-vd-cd"
    },
    {
      "external_segment": null,
      "name": "RedZone OT Card mobile web anonymous",
      "rule": "390c09d1-2a4e-4f77-a091-62043eb39db5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "630f2deb-5fb2-4c73-a7f8-41ae3ce682ad",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-re-ot-cd"
    },
    {
      "external_segment": null,
      "name": "RedZone OT Card tablet web anonymous",
      "rule": "f00c30da-498d-4134-bf37-770ca602a091",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "5ff3e4b0-8109-4c9d-8174-81cc375c13b9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-re-ot-cd"
    },
    {
      "external_segment": null,
      "name": "RedZone OT Card desktop web anonymous",
      "rule": "5f994165-1505-4319-9852-e5355643d910",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "80991ecb-7c9f-40bb-96ec-7730d8964e69",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-he-re-ot-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card mobile web anonymous",
      "rule": "61638fdd-1b2e-4e96-8065-0aeb7d9b3a8e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a93db37f-d15c-40a6-bcda-61ac3b82a87a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card tablet web anonymous",
      "rule": "8b4e0380-e5fc-4426-9df2-9549bf6a3f97",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "ffb24cb8-e030-4b52-b90c-93549dcee637",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card desktop web anonymous",
      "rule": "9c48e8f7-e547-423c-90d9-44af5a47e3aa",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "d8c5a6fc-a182-40d9-91b9-3b2c12868b28",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-ry-cd"
    },
    {
      "external_segment": null,
      "name": "RedZone OT Card mobile web anonymous",
      "rule": "93dd3a7c-ff13-48f3-8ef6-9955dcba1353",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "52106759-8425-4494-9ba4-c9d1d03a96f0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-re-ot-cd"
    },
    {
      "external_segment": null,
      "name": "RedZone OT Card tablet web anonymous",
      "rule": "14f51234-aea2-4153-984f-3a66f5927f35",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "8dd5c045-07de-4caa-a8a3-db3e03a0ec2e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-re-ot-cd"
    },
    {
      "external_segment": null,
      "name": "RedZone OT Card desktop web anonymous",
      "rule": "1814fe43-aea0-42af-84c9-e0105a345fe5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "280a6437-12cb-450e-9e79-7f36b30c395f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-re-ot-cd"
    },
    {
      "external_segment": null,
      "name": "RZ OT Carousel Subscribe Button mobile web anonymous",
      "rule": "155cde9c-37d3-4d06-ae70-eecb33d37bcb",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "39211d7a-fc06-45e1-b3e2-926edf203944",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-se-bn"
    },
    {
      "external_segment": null,
      "name": "RZ OT Carousel Subscribe Button tablet web anonymous",
      "rule": "270af763-c354-4633-9c06-c5dc5a4bcb11",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "41aa974b-bdbe-4a2c-ba43-d6c1cb6a0938",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-se-bn"
    },
    {
      "external_segment": null,
      "name": "RZ OT Carousel Subscribe Button desktop web anonymous",
      "rule": "36becbd4-6ea3-4892-8611-461db5b8e6b2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "6d7d888d-dfad-4382-bc3f-0f3bb397b1a8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-re-se-bn"
    },
    {
      "external_segment": null,
      "name": "replay-card mobile web anonymous",
      "rule": "b7106589-3306-4de6-b4f0-2f2fd331ef05",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "174cb85e-d8ec-4664-a350-25c7472bac78",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rs-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card tablet web anonymous",
      "rule": "3593b53a-117a-4f82-8b03-bb5077f0cf63",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "f27dde4f-de7c-478b-b0cd-bedc1bb5973d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rs-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card desktop web anonymous",
      "rule": "9f5115ce-dba1-4725-880b-75f00830da6c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "b8c61265-c884-4e28-92d7-5346ed73752b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rs-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card mobile web anonymous",
      "rule": "7893011f-ac3d-4d20-9520-6611727d9426",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "400542c8-2ccb-4278-9870-390d46b0133e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-rs-ty"
    },
    {
      "external_segment": null,
      "name": "replay-card tablet web anonymous",
      "rule": "8e7ffaee-5f5c-46db-be9c-d602ae3eaa64",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "80e1877f-0061-42ba-93af-475a64ef84db",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-rs-ty"
    },
    {
      "external_segment": null,
      "name": "replay-card desktop web anonymous",
      "rule": "490bd464-07e7-487d-be2e-9c09d075885d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "ae028351-d713-4e3a-a1f9-4cf12519b465",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-ig-ge-rs-ty"
    },
    {
      "external_segment": null,
      "name": "replay cta mobile web anonymous",
      "rule": "fee6ff7b-e602-406a-b747-04f32e70be82",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "aa90999f-6ae8-4111-b129-07243ad5b8b1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta tablet web anonymous",
      "rule": "675fb857-dbc3-44fa-98d1-868e0194a8ad",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "7aec1987-baf9-4a2d-8bb0-cbd63c0923ae",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta desktop web anonymous",
      "rule": "08bdd9b8-3455-432f-83d7-3f09e8c07ff0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "ef5ff0fb-cad8-40ba-9916-e68168fe2058",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta mobile web anonymous",
      "rule": "4c6823c6-db14-4be4-98e1-2251c7a8f5f7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "02b0b2bb-5a5a-4694-b1b7-c4d1c56634b9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-tf-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta tablet web anonymous",
      "rule": "980a45ac-efe1-4b22-abf3-06d2c7766c0d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "8eee357d-6e17-4652-840e-12fc7df24b8e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-tf-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta desktop web anonymous",
      "rule": "845519aa-68c4-48ad-8584-2e5f3cb4079b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "fe81af84-0e25-4049-81e2-f58c1c48cd74",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-tf-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta mobile web anonymous",
      "rule": "fe1acfbc-ba0b-4714-872a-46728456648f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "d742937f-6f7b-4ee6-8b6b-9dd420438102",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sf-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta tablet web anonymous",
      "rule": "9a539374-dbab-460b-a570-c6228d207176",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "acb15d52-5617-4f09-aa18-8245850a27bf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sf-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "replay cta desktop web anonymous",
      "rule": "83207109-156e-415b-a3e2-963582aa6b8a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "255b5168-6022-43e4-aa53-6338a6e9029e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sf-se-ry-ca"
    },
    {
      "external_segment": null,
      "name": "full replay mobile web anonymous",
      "rule": "466a15d1-0d9d-4185-8651-4614d01c4ed7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "66b71e14-ae46-4742-a7e8-9e8b3cf9821b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-fl-ry"
    },
    {
      "external_segment": null,
      "name": "full replay tablet web anonymous",
      "rule": "0a591d55-1b2f-44d3-8641-dbff99b5699a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "6049cb23-cf2e-4fe6-8bfc-d89d196109a8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-fl-ry"
    },
    {
      "external_segment": null,
      "name": "full replay desktop web anonymous",
      "rule": "42f7039a-5807-4f37-b15c-07805af3a83d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "45e1acfc-ffbd-45c9-b616-4e165ca41d0c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-fl-ry"
    },
    {
      "external_segment": null,
      "name": "condensed replay mobile web anonymous",
      "rule": "1ba000ea-1837-4f41-99ac-768bde0429da",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "55273e60-0214-4f36-b515-de59ee495450",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-cd-ry"
    },
    {
      "external_segment": null,
      "name": "condensed replay tablet web anonymous",
      "rule": "a03c2281-37ce-44c5-8c67-be0e398eb292",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "a0ae7166-6ac7-4d68-b200-a8ff45d37e7a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-cd-ry"
    },
    {
      "external_segment": null,
      "name": "condensed replay desktop web anonymous",
      "rule": "8b29c301-e6df-48f1-b57c-438e2bca7e21",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "e669ae27-2e4a-46d0-a6c1-a11950b74a73",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-cd-ry"
    },
    {
      "external_segment": null,
      "name": "Coaches film playback mobile web anonymous",
      "rule": "0d59ea78-4c84-4963-bba9-7336f613b2d2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "ddd765a2-0734-4974-8cc4-8eee4c3658b3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-cs-fm-pk"
    },
    {
      "external_segment": null,
      "name": "Coaches film playback tablet web anonymous",
      "rule": "bf082c5e-41d9-4e40-9d4e-0b43613853e9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "8301a487-2747-4e03-adc7-0c6a38772e16",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-cs-fm-pk"
    },
    {
      "external_segment": null,
      "name": "Coaches film playback desktop web anonymous",
      "rule": "56c65f05-b7bd-487d-b3e9-e7d822e93364",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "ce5f51cc-f69a-408a-8923-66472934664e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-cs-fm-pk"
    },
    {
      "external_segment": null,
      "name": "replay-card mobile web anonymous",
      "rule": "c56958d3-afb5-42b6-b83c-14342b2fd2a6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "cb6bb772-419d-4965-b00d-f825f311aa72",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card tablet web anonymous",
      "rule": "586c2750-76db-4111-962c-02bcb9ef9770",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "8560000f-da54-4803-80a9-808955246e1e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay-card desktop web anonymous",
      "rule": "cea23921-2610-444d-af94-6e0cf9da2b32",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "eb5cd418-261b-400d-9fe1-015844a86b74",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ry-cd"
    },
    {
      "external_segment": null,
      "name": "replay subscribe cta mobile web anonymous",
      "rule": "a0be1ad2-3645-437a-a1f0-820c425453c2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a82c4da9-27cf-4196-aaca-b0f7e8cfd4ce",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ry-se-ca"
    },
    {
      "external_segment": null,
      "name": "replay subscribe cta tablet web anonymous",
      "rule": "3b8d385d-d533-414f-a9a1-7dbe25a10972",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "02a2f401-d793-4033-b2fb-f882c5e73349",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ry-se-ca"
    },
    {
      "external_segment": null,
      "name": "replay subscribe cta desktop web anonymous",
      "rule": "2a225563-3640-473e-b888-ee2442a0fcac",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "4652cc14-8e88-44c8-8ed4-bb15a29ddd2b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-ry-se-ca"
    },
    {
      "external_segment": null,
      "name": "Last meeting replay cta mobile web anonymous",
      "rule": "f35c7b93-6c87-4ef1-a2b4-811ae04d9d34",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "ed371927-e4b2-4e58-8037-18fb3859aaae",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-lt-mg-ry-ca"
    },
    {
      "external_segment": null,
      "name": "Last meeting replay cta tablet web anonymous",
      "rule": "4c8b8e38-b8a3-41b7-aa77-d57c322e7f22",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "f6b6a673-b2a4-4452-9e17-8c9a2eb294d9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-lt-mg-ry-ca"
    },
    {
      "external_segment": null,
      "name": "Last meeting replay cta desktop web anonymous",
      "rule": "b4383361-4f92-41e3-bf95-7a2144b98416",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "a7c2014e-65e6-4c2a-b34d-8d6137bc29f2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-lt-mg-ry-ca"
    },
    {
      "external_segment": null,
      "name": "xbox-all-products mobile web anonymous",
      "rule": "03a92a7d-bea7-4ae4-8437-ee27c453c896",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "dd7f1ccb-9b30-4374-81d8-78d85091a880",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "xbx-all-p"
    },
    {
      "external_segment": null,
      "name": "xbox-all-products desktop web anonymous",
      "rule": "81759d06-58c6-4f97-9a36-a6405c493141",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "30a71f57-f9f3-4ee1-8259-ee5330367269",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "xbx-all-p"
    },
    {
      "external_segment": null,
      "name": "xbox-all-products tablet web anonymous",
      "rule": "02f265aa-8e15-48d9-a981-63e9294bae0c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "2c43f116-df95-4ab4-9ae9-5d93d457c04f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "xbx-all-p"
    },
    {
      "external_segment": null,
      "name": "lg-all-products mobile web anonymous",
      "rule": "bc0c778b-247e-4431-b1b1-aed49c41ba95",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "b29c57e1-d108-472b-8a83-4eaa4d8c71f5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "lg-all-p"
    },
    {
      "external_segment": null,
      "name": "lg-all-products desktop web anonymous",
      "rule": "d06e6f91-9755-47e4-9175-7cde8f6a2964",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "d4ef63de-3150-46d8-8f77-c785b7845a30",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "lg-all-p"
    },
    {
      "external_segment": null,
      "name": "lg-all-products tablet web anonymous",
      "rule": "a74b4511-0b41-43ee-a49a-7c5f54ef1b49",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "06ddb95a-420b-4662-812b-0f815623b36a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "lg-all-p"
    },
    {
      "external_segment": null,
      "name": "plus-replay-card-generic mobile web anonymous",
      "rule": "63d58c4e-88f3-431e-afde-3a8978eaf34d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "4af26175-4c63-46ea-bcd4-bf6ce9767b29",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-ry-cd-gc"
    },
    {
      "external_segment": null,
      "name": "plus-replay-card-generic tablet web anonymous",
      "rule": "428797f2-49db-4aa0-8150-4c59b8197938",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "80839bc1-e031-47f6-b0c7-e72005cfc818",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-ry-cd-gc"
    },
    {
      "external_segment": null,
      "name": "plus-replay-card-generic desktop web anonymous",
      "rule": "51e3ec15-3f2f-4321-933b-0867f8dcc0a9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "24fde2fb-7266-442d-aa80-0ae81f3e65c7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-ry-cd-gc"
    },
    {
      "external_segment": null,
      "name": "VPO subscribe replay mobile web anonymous",
      "rule": "940b90fb-a621-463b-a8f5-2ead1ababdca",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "067e6aed-2851-4a8e-b0dc-0cf77ee19cbc",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-vo-se-ry"
    },
    {
      "external_segment": null,
      "name": "VPO subscribe replay tablet web anonymous",
      "rule": "7f9e26f8-ec68-48cd-90d9-04e732c2dd94",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "ccf95409-44fa-42a4-81ad-f1aeb291d816",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-vo-se-ry"
    },
    {
      "external_segment": null,
      "name": "VPO subscribe replay desktop web anonymous",
      "rule": "22fad74b-6707-4999-947a-5faf13425df0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "f0004474-66ad-4b26-a01e-c6d34b32aab1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-vo-se-ry"
    },
    {
      "external_segment": null,
      "name": "Editorial - Video Image Hero Carousel Premium mobile web anonymous",
      "rule": "00e24de0-14e4-40d2-809b-aa65a0353fc9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "5df29fc5-27bf-4e5b-80f5-602725afefa7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-ho-se-pm"
    },
    {
      "external_segment": null,
      "name": "Editorial - Video Image Hero Carousel Premium tablet web anonymous",
      "rule": "dfec54d1-9c3c-469c-952c-1d74667fcb08",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "847d49fb-5eaa-446c-9d30-40a7d7d89071",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-ho-se-pm"
    },
    {
      "external_segment": null,
      "name": "Editorial - Video Image Hero Carousel Premium desktop web anonymous",
      "rule": "0660ad01-07ff-4ecd-abc5-1d213c274e72",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "cff8e960-3a1c-4529-b543-2e7de9cc449c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lm-ho-se-pm"
    },
    {
      "external_segment": null,
      "name": "watch subscribe cta mobile web anonymous",
      "rule": "36071d14-94e9-424b-8ef7-53c0bad2dafc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "7cf3513e-76d1-4d4e-a38b-2c0b0913a809",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wh-se-ca"
    },
    {
      "external_segment": null,
      "name": "watch subscribe cta tablet web anonymous",
      "rule": "ff113521-eeae-4e8b-93ca-4cd51d93fc4f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "724734a9-18e0-4539-972e-d44d75423ae3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wh-se-ca"
    },
    {
      "external_segment": null,
      "name": "watch subscribe cta desktop web anonymous",
      "rule": "b4399ac7-8020-4ba3-add3-81e0118d6103",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "a8a18ad5-742c-413a-ae67-fe20b165a2ab",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wh-se-ca"
    },
    {
      "external_segment": null,
      "name": "generic-placement-plus-basic tablet web anonymous",
      "rule": "2e2ce558-8f74-4559-bd5e-81bb20b17baf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "ebfa094b-63ed-45d0-ba42-f82b43a74567",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pt-ps-bc"
    },
    {
      "external_segment": null,
      "name": "generic-placement-plus-basic mobile web anonymous",
      "rule": "6d91c5b6-224c-4b58-bbb6-8c20f697fe50",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "d3870cff-bd09-49f0-972e-e625bfcabfe5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pt-ps-bc"
    },
    {
      "external_segment": null,
      "name": "generic-placement-plus-basic desktop web anonymous",
      "rule": "b1107efd-7827-4c76-b4e2-86e89430deb2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "77cc949e-ef95-4c99-8264-1d7952cf7abf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pt-ps-bc"
    },
    {
      "external_segment": null,
      "name": "generic-placement-plus-premium mobile web anonymous",
      "rule": "88327c3a-c144-400e-b565-81e769386228",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "27708a9f-dafc-4d4f-ad32-c6f67c58d470",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pt-ps-pm"
    },
    {
      "external_segment": null,
      "name": "generic-placement-plus-premium tablet web anonymous",
      "rule": "fb969c40-04b7-49eb-8102-c147b4a9a7bf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "53f12a73-3a3a-4046-83bc-f793d1fc34b2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pt-ps-pm"
    },
    {
      "external_segment": null,
      "name": "generic-placement-plus-premium desktop web anonymous",
      "rule": "43d62327-8d9d-4e0f-8b3d-5d4164fa15bd",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "81d4489f-f6a4-456c-89f3-73b998899e6c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-pt-ps-pm"
    },
    {
      "external_segment": null,
      "name": "nfl-pro-page-generic mobile web anonymous",
      "rule": "f9eddda9-4b5c-4d49-89c8-8fe548b4c9b9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a76ad56f-bb2b-477e-aa13-42025eb3a861",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-po-pe-gc"
    },
    {
      "external_segment": null,
      "name": "nfl-pro-page-generic tablet web anonymous",
      "rule": "5e65a8bf-3bbd-4cc8-bac8-746f980f1daa",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "62cc53f2-312b-47f9-acf8-c21365b825c7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-po-pe-gc"
    },
    {
      "external_segment": null,
      "name": "nfl-pro-page-generic desktop web anonymous",
      "rule": "540e8886-df9e-4655-b3bd-f2b9ded5ba65",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "6c9a1fb1-1896-4b73-9619-d4e871dc51a7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-po-pe-gc"
    },
    {
      "external_segment": null,
      "name": "NFL+ right rail promo mobile web anonymous",
      "rule": "5ba95122-5904-4650-8bda-c9400c3ba371",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "ffae62bf-db7e-4a35-853a-c9069f9f3c8b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rt-rl-po"
    },
    {
      "external_segment": null,
      "name": "NFL+ right rail promo tablet web anonymous",
      "rule": "fa634403-be95-44db-b841-144c5cc6032c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "befb1e74-9364-4ea0-b349-33c5fe6a3e02",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rt-rl-po"
    },
    {
      "external_segment": null,
      "name": "NFL+ right rail promo desktop web anonymous",
      "rule": "1b18b161-986d-4072-9c2f-884478a1f028",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "60a5976f-fa55-4f07-a8be-57aac350dbb8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rt-rl-po"
    },
    {
      "external_segment": null,
      "name": "NFL+ right rail promo premium mobile web anonymous",
      "rule": "833b1c66-b857-4606-b3e2-940f25e80279",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "c6c0303e-3023-47eb-9bae-3440ab3417a7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rt-rl-po-pm"
    },
    {
      "external_segment": null,
      "name": "NFL+ right rail promo premium tablet web anonymous",
      "rule": "1c8a8b3d-692d-49f0-b644-1e11edec5dd0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "b9137c80-1e84-4aad-b74e-07fdb71a7367",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rt-rl-po-pm"
    },
    {
      "external_segment": null,
      "name": "NFL+ right rail promo premium desktop web anonymous",
      "rule": "1abe5254-cf40-4352-ac7c-fd38cf7883e6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "d60194a4-1a34-4b41-bd4c-3dca28775072",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-rt-rl-po-pm"
    },
    {
      "external_segment": null,
      "name": "nfl-fantasy-page-generic mobile web anonymous",
      "rule": "86b76a08-38e8-4111-b802-3a534ca4673d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "03de318c-4859-4fae-87cd-38949f340a53",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-fy-pe-gc"
    },
    {
      "external_segment": null,
      "name": "nfl-fantasy-page-generic tablet web anonymous",
      "rule": "59c614c7-2649-4c76-a11c-904705e1b97d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "97cd94d2-7780-42c2-abe5-9d51a9c40e7e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-fy-pe-gc"
    },
    {
      "external_segment": null,
      "name": "nfl-fantasy-page-genericdesktop web anonymous",
      "rule": "af17b26d-4b70-47a8-8db6-d880b3f889ff",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "61c67109-fadc-4692-bd6a-d01583741480",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-fy-pe-gc"
    },
    {
      "external_segment": null,
      "name": "Live Tray CTV mobile web anonymous",
      "rule": "945c13b7-3852-4244-9f65-4716eff2c1ad",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "22fbf7e4-693e-45fb-b6d0-8a1e6aa5710e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-le-ty-cv"
    },
    {
      "external_segment": null,
      "name": "Live Tray CTV tablet web anonymous",
      "rule": "08751d74-6292-4e33-b2bd-e68e60f4ddfb",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "ead7a119-3cd4-4698-842b-480b8bb62869",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-le-ty-cv"
    },
    {
      "external_segment": null,
      "name": "Live Tray CTV desktop web anonymous",
      "rule": "59163f86-0531-49c8-9869-26e4f1967d02",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "7b873662-6c56-44ec-b9d5-80ffe6a0e0ca",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-le-ty-cv"
    },
    {
      "external_segment": null,
      "name": "Generic CTA mobile web anonymous",
      "rule": "c2e4d61c-a7cc-4fb1-b34b-ebf9b2788201",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a99f3d0c-2670-4abe-b089-f45386d38e65",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lmp-gc-ca"
    },
    {
      "external_segment": null,
      "name": "Generic CTA tablet web anonymous",
      "rule": "97290afb-daf6-4cb6-8ff3-92010357dae6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "51834e2b-98bc-449d-bb7c-d0e75a08da64",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lmp-gc-ca"
    },
    {
      "external_segment": null,
      "name": "Generic CTA desktop web anonymous",
      "rule": "da04d518-0782-44fc-9e36-0792bc91f48d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "648936e7-b8a8-44c1-8fba-44de212c522d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-lmp-gc-ca"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Watch Live with Nfl+ Basic mobile web anonymous",
      "rule": "e71ed9f0-e877-4d6b-966d-0526dcc6b7f2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "f5f05896-579a-4bd9-b74d-1646c10026ff",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-wh"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Watch Live with Nfl+ Basic desktop web anonymous",
      "rule": "85006b9b-362b-48a4-a528-fc89e89f0d3d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "c53e31bb-a197-495d-8bc6-f90782245fad",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-wh"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Watch Live with Nfl+ Basic tablet web anonymous",
      "rule": "286a0279-d3e4-4d51-9885-ebc8938755e1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "e6ef6944-7c9e-417c-aa09-d9a3827a5d15",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-wh"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Listen Live with NFL+ Basic mobile web anonymous",
      "rule": "68b8d34a-5b74-4778-92a3-5055a35258d4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "ff65d75c-753d-44dd-9dd6-42a5a464531d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-ln"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Listen Live with NFL+ Basic desktop web anonymous",
      "rule": "f737ab7f-bf78-4ac7-9d3a-8f243b3170a7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "17d8c095-1ca4-4f3c-b0fa-ea0c47bd96f7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-ln"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Listen Live with NFL+ Basic tablet web anonymous",
      "rule": "24c658de-36c6-4cb5-95a9-101278dffa5b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "956d4238-6c60-410a-8980-ea43ec6d5e6a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-ln"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Subscribe to RedZone mobile web anonymous",
      "rule": "f589c89f-20b3-430a-abb9-fc9596db168c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "860fb3f3-a16c-4873-bfde-ba4680ac75a2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-re"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Subscribe to RedZone desktop web anonymous",
      "rule": "c20ef8cc-4c47-43ec-aca6-88e36c10b5f4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "9e3bd617-6961-4a64-909d-6e228d878438",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-re"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Subscribe to RedZone tablet web anonymous",
      "rule": "7f996b50-4a4f-4a7a-8e10-c13a307909a8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "e3870093-9848-4bdf-8e97-3bdaccab312f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-re"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner NFL Pro mobile web anonymous",
      "rule": "14d9ff07-3216-48ca-b073-56e75f9d29d6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "1e4f2158-273e-40e1-958b-3b477c2c48eb",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-nlpo"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner NFL Pro desktop web anonymous",
      "rule": "167a581f-a964-487f-981d-957d08ab2bb6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "f5fe05ad-1ceb-447e-9cc7-0f94172359c7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-nlpo"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner NFL Pro tablet web anonymous",
      "rule": "9886cf80-d3f6-4f1e-867e-4883fe65d0b6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "bd04316d-5ca5-416c-ad08-5f562ec0b7ec",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-nlpo"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Full Game Replay mobile web anonymous",
      "rule": "93ebc575-63df-4372-86a2-665257ebe3a5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "e99a4a9d-fb06-47fb-9643-9aebe663f65f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-flgery"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Full Game Replay desktop web anonymous",
      "rule": "137e9c28-66e5-417f-8ebc-e0435580be60",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "e6c6cef2-6479-49a5-9ea8-41ee637e0060",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-flgery"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Full Game Replay tablet web anonymous",
      "rule": "398aa8ef-a468-42fe-9e11-a1fd197570b7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "ccf3a842-b05a-4718-bebc-717a3974c22a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-flgery"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Condensed Replay mobile web anonymous",
      "rule": "62640c82-456c-41ce-ba44-e4e5efa799a1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "07207b0c-dc1d-4309-af12-10d0089b485d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-cdry"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Condensed Replay desktop web anonymous",
      "rule": "c4f09255-851f-4263-becb-fe9d2fadbd70",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "cf9321b2-4759-4b2a-9503-4907ff7772f4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-cdry"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Condensed Replay tablet web anonymous",
      "rule": "567e0053-0880-47eb-90c4-095aa3b505c4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "a4a85db7-e596-4a88-9451-9c0664d6e495",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-cdry"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner All-22 Replay mobile web anonymous",
      "rule": "69633ff7-66f0-4fe2-997c-951955ac959e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "99ddab7c-f0e7-4765-953b-07dfad024f5b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-alry"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner All-22 Replay desktop web anonymous",
      "rule": "6378dc0f-8cc1-42b4-9a23-83c9fc962050",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "cb69317c-603e-4916-8944-10e011ab6eac",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-alry"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner All-22 Replay tablet web anonymous",
      "rule": "d32b5042-e59a-4207-ad0e-34b2ec6bacb9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "2fe7e598-4368-4b57-9c6e-a75c2a83fa21",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-alry"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Upgrade URL for basic subs mobile web anonymous",
      "rule": "77f16e6b-d030-4048-ab5e-faf4a2c501f2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "e671193d-3b22-4a83-865a-ba780ebe0324",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-ue"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Upgrade URL for basic subs desktop web anonymous",
      "rule": "d8775bad-2305-4fe8-ae11-790344e6f2dc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "11629d4d-0e59-4bb1-993b-5126c9e6e415",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-ue"
    },
    {
      "external_segment": null,
      "name": "Embedded Video Banner Upgrade URL for basic subs tablet web anonymous",
      "rule": "3b286d7d-b327-4cea-a6d0-73bd77f8f0e2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "6a3c8f8d-6839-4665-8c7b-a5eb0e563505",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-evb-ue"
    },
    {
      "external_segment": null,
      "name": "Stream Card Watch Live with Nfl+ Basic mobile web anonymous",
      "rule": "e29c9bcd-eeac-44b1-ace7-8fa3560eba8c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "642c5b48-d368-4b1d-a341-38919a2c7294",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-wh"
    },
    {
      "external_segment": null,
      "name": "Stream Card Watch Live with Nfl+ Basic desktop web anonymous",
      "rule": "72aeb611-5af3-4ce0-94d3-90d534e71cd8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "93a1c0d7-08af-4602-904c-9760a87e81f2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-wh"
    },
    {
      "external_segment": null,
      "name": "Stream Card Watch Live with Nfl+ Basic tablet web anonymous",
      "rule": "7fc27f8d-6415-4801-8c2e-b665873bb77f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "3415582d-d4b1-4eb5-b5ef-00edd4f26799",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-wh"
    },
    {
      "external_segment": null,
      "name": "Stream Card Listen Live with NFL+ Basic mobile web anonymous",
      "rule": "6c95024d-70f8-4ce1-86f0-4427c99a06ca",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "ac036ee2-ac8f-4b0f-ba26-da44c59d8a1a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-ln"
    },
    {
      "external_segment": null,
      "name": "Stream Card Listen Live with NFL+ Basic desktop web anonymous",
      "rule": "b6b18845-b073-4e01-8559-1e37a027e310",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "8d64b06a-d570-4829-99f9-6e3206f4d3c8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-ln"
    },
    {
      "external_segment": null,
      "name": "Stream Card Listen Live with NFL+ Basic tablet web anonymous",
      "rule": "5153e78e-be8d-4b94-8970-6691c672d546",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "e0624e38-394d-4010-a6f3-d812e8ce3557",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-ln"
    },
    {
      "external_segment": null,
      "name": "Stream Card Subscribe to RedZone mobile web anonymous",
      "rule": "6dad7487-840a-41c2-af72-bd449e6cd9ff",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "00043564-3b2f-478a-9308-1275b474de81",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-re"
    },
    {
      "external_segment": null,
      "name": "Stream Card Subscribe to RedZone desktop web anonymous",
      "rule": "7e4a0b4f-5864-4483-a2f6-23ce7d00b1af",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "fe3ca848-6b3c-45ea-9847-2238a8344b55",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-re"
    },
    {
      "external_segment": null,
      "name": "Stream Card Subscribe to RedZone tablet web anonymous",
      "rule": "b349bd0f-9290-4475-98d6-7f384c875939",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "3560eae4-8bba-46e1-a85e-59bed0e200cf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-re"
    },
    {
      "external_segment": null,
      "name": "Stream Card NFL Pro mobile web anonymous",
      "rule": "b50eef57-7469-4c17-86b1-1c8131bffce1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "b3e5e4c0-4d69-4000-988a-fe058945d763",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-nlpo"
    },
    {
      "external_segment": null,
      "name": "Stream Card NFL Pro desktop web anonymous",
      "rule": "afc930c7-71e2-4e72-b481-d223d0cf4bf2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "76d8b171-2f1a-4d0e-b668-38dcbe29983a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-nlpo"
    },
    {
      "external_segment": null,
      "name": "Stream Card NFL Pro tablet web anonymous",
      "rule": "b635a97d-d9a7-4efb-b165-8ca06e4fd645",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "fa0772b4-1223-4e79-92a0-e8c329eebda9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-nlpo"
    },
    {
      "external_segment": null,
      "name": "Stream Card Full Game Replay mobile web anonymous",
      "rule": "3662ad2b-7c09-41db-a2b8-72dc25d61ec4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "0ab85699-791e-47d1-ada6-d6e3e0555b9d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-flgery"
    },
    {
      "external_segment": null,
      "name": "Stream Card Full Game Replay desktop web anonymous",
      "rule": "6bc73aae-04b4-4b25-ba9d-e6666fe60a9d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "707ddf6a-853b-4167-88cf-afe1d3fac755",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-flgery"
    },
    {
      "external_segment": null,
      "name": "Stream Card Full Game Replay tablet web anonymous",
      "rule": "9d34e9f9-009d-4442-9b7b-9943686bb741",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "a95cc368-3fde-4f9b-97b8-2e5cb7ff43ee",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-flgery"
    },
    {
      "external_segment": null,
      "name": "Stream Card Condensed Replay mobile web anonymous",
      "rule": "bd1eed2d-fe2f-4aee-be38-a1b72f8c7333",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "75c0be9a-10a6-45a4-b1c3-770f3569a912",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-cdry"
    },
    {
      "external_segment": null,
      "name": "Stream Card Condensed Replay desktop web anonymous",
      "rule": "98e8a3ca-3cb6-4888-86fb-19cf3d9a3c7e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "95494d09-8a9a-429c-87ce-a1681173462b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-cdry"
    },
    {
      "external_segment": null,
      "name": "Stream Card Condensed Replay tablet web anonymous",
      "rule": "fb039955-4728-44b7-9794-73f07e05e7e7",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "ea7c3d19-10f9-4e48-bc48-ca6a7de81a41",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-cdry"
    },
    {
      "external_segment": null,
      "name": "Stream Card All-22 Replay mobile web anonymous",
      "rule": "ba7ce23f-f921-4be5-9842-258796a4acea",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "4e3a63a9-a148-4238-a44f-c181dc2bfd4e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-alry"
    },
    {
      "external_segment": null,
      "name": "Stream Card All-22 Replay desktop web anonymous",
      "rule": "36015a05-1cf6-494e-ab7d-d3ef62a7a768",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "0ae1a6b3-7177-4ea2-97fb-d8d42da3df84",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-alry"
    },
    {
      "external_segment": null,
      "name": "Stream Card All-22 Replay tablet web anonymous",
      "rule": "b3dbc86b-667e-4299-beec-118e4e79c72f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "ae6187a5-ea46-4472-94de-a0582c2da019",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-alry"
    },
    {
      "external_segment": null,
      "name": "Stream Card Upgrade URL for basic subs mobile web anonymous",
      "rule": "1d3b5a19-9bba-41d2-a4ad-9840502c96aa",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "5780f7c8-a1a6-486e-94ae-aadf9c33f473",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-ue"
    },
    {
      "external_segment": null,
      "name": "Stream Card Upgrade URL for basic subs desktop web anonymous",
      "rule": "1052cbd7-e450-4e9a-af34-60a78b6d906c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "fcf8a12b-b29e-4984-8b9e-c1a601f12cac",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-ue"
    },
    {
      "external_segment": null,
      "name": "Stream Card Upgrade URL for basic subs tablet web anonymous",
      "rule": "c32666e5-c4f5-4713-9fcd-a3c4fc054599",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "40bd0b0f-77d5-468c-9ceb-3cfbb2ebd00b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-sm-cd-ue"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Watch Live with Nfl+ Basic mobile web anonymous",
      "rule": "2228dd83-f786-4b82-9764-525ac818d3a1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "a7379730-aff4-4515-8cb7-7b2544f88098",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-wh"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Watch Live with Nfl+ Basic desktop web anonymous",
      "rule": "a446d203-b849-4794-82f1-d1acfc6d0f43",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "65872222-05f0-4635-880a-5b8ce8ed5cbf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-wh"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Watch Live with Nfl+ Basic tablet web anonymous",
      "rule": "a1980876-d163-4b0e-9de0-4d2a89b5f88c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "744fa168-421d-463e-8847-459bfb827abd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-wh"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Listen Live with NFL+ Basic mobile web anonymous",
      "rule": "1a85a512-18ec-4749-9e6d-385224a21e3b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "43a61890-4c77-4fba-a2cd-daef420e2858",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-ln"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Listen Live with NFL+ Basic desktop web anonymous",
      "rule": "6047aac4-51a8-466b-b80a-3bf1be3ae137",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "54dac391-d6e5-49b9-8d60-97633884d312",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-ln"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Listen Live with NFL+ Basic tablet web anonymous",
      "rule": "e9cbf1c5-6742-4f00-b06e-8d7ae423cd1f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "fa7bd25d-d585-4617-9ede-6650493bfba7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-ln"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Subscribe to RedZone mobile web anonymous",
      "rule": "064b6cf7-4359-442e-8298-707247f6ab59",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "44b90229-4fa6-4f03-8746-c7e3b0ebc712",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-re"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Subscribe to RedZone desktop web anonymous",
      "rule": "97fee95d-1a12-40b6-b140-892070848452",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "18a81929-0fc3-4e2f-8e77-2c7f7b2faa6e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-re"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Subscribe to RedZone tablet web anonymous",
      "rule": "a504ec76-cbdd-4e6f-8bea-6b3365dc7208",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "254db2a2-301c-457d-ab34-c340c6ebd9b1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-re"
    },
    {
      "external_segment": null,
      "name": "Promo End Card NFL Pro mobile web anonymous",
      "rule": "be74249c-879d-4fac-a613-b6aa00465bc3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "73277780-5846-46fc-aefa-cdbcc868c97f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-nlpo"
    },
    {
      "external_segment": null,
      "name": "Promo End Card NFL Pro desktop web anonymous",
      "rule": "e8513e0a-7cc6-4c16-8bea-4f68c71af12f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "000c91b0-2b23-4576-aa78-187a0117ce57",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-nlpo"
    },
    {
      "external_segment": null,
      "name": "Promo End Card NFL Pro tablet web anonymous",
      "rule": "2bc4ed25-e3a0-447c-84d5-146223f962cc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "cfd630a2-6543-4761-aa19-c2f41d5ff0f0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-nlpo"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Full Game Replay mobile web anonymous",
      "rule": "f50f3536-2370-46c9-8d9c-68a72c8d3fae",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a48fc1a0-2408-4d10-9054-13ec1ad18bb6",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-flgery"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Full Game Replay desktop web anonymous",
      "rule": "e7e79781-6777-4bee-9e73-5a06b8972553",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "af9ff74c-a452-4348-a459-25693847b8d8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-flgery"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Full Game Replay tablet web anonymous",
      "rule": "20d83a34-937d-46ac-9bec-dd09b922f8cf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "b115f701-d691-49a8-8d29-625819447541",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-flgery"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Condensed Replay mobile web anonymous",
      "rule": "7e2eecca-b675-4f76-958a-1bf799ad1dd2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "c9e70c21-4908-4b4b-ba84-7eb7590e86a0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-cdry"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Condensed Replay desktop web anonymous",
      "rule": "069199d2-e19b-46b3-b130-16c86e78db3e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "8be00ac9-bbf0-462a-8b34-4bf08a4cb9b8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-cdry"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Condensed Replay tablet web anonymous",
      "rule": "99ed0320-12c2-4cd9-89f3-983f58d839a1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "c2413081-e844-4948-ac3e-f19d2d4663ce",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-cdry"
    },
    {
      "external_segment": null,
      "name": "Promo End Card All-22 Replay mobile web anonymous",
      "rule": "022eb7ee-39ad-4673-9cbd-abd4c4ba3eb4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "f379baa4-ca50-4dc6-af81-cff52c97a261",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-alry"
    },
    {
      "external_segment": null,
      "name": "Promo End Card All-22 Replay desktop web anonymous",
      "rule": "f20e4fe1-f518-4d5a-aa55-8065c87160e2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "65b664dc-84c8-46d3-a48e-3810e21a86bf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-alry"
    },
    {
      "external_segment": null,
      "name": "Promo End Card All-22 Replay tablet web anonymous",
      "rule": "54192e72-a5c2-456a-b0d8-13b975603f64",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "d4dd2445-df11-4ce6-b8aa-4593d7be720c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-alry"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Upgrade URL for basic subs mobile web anonymous",
      "rule": "8739b508-0f64-429b-89a5-89630dc489fe",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "e694eeef-aa2d-4675-bb7c-f7b26239637c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-ue"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Upgrade URL for basic subs desktop web anonymous",
      "rule": "c145bf9d-64ed-4988-bac9-7a6ca03921a0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "0b522cc4-dd43-47d4-a342-863517aa4ff1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-ue"
    },
    {
      "external_segment": null,
      "name": "Promo End Card Upgrade URL for basic subs tablet web anonymous",
      "rule": "29192890-6f72-466a-a11a-879b35db8d99",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "82222db2-8e6c-4980-a058-7738bc3b9a09",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-po-ed-cd-ue"
    },
    {
      "external_segment": null,
      "name": "Playlist Highlights NFL+ Basic mobile web anonymous",
      "rule": "9843d023-7ba0-406f-a4d3-f2a8d6dc4669",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "0ebe7747-218c-490d-9372-cb1e1bd73aa3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-pt-hs-nl-bc"
    },
    {
      "external_segment": null,
      "name": "Playlist Highlights NFL+ Basic desktop web anonymous",
      "rule": "ab40eb2e-bd81-4771-8e2b-12c8d744aba1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "0ac87cdd-59f0-48d3-bc38-c7f69da809e4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-pt-hs-nl-bc"
    },
    {
      "external_segment": null,
      "name": "Playlist Highlights NFL+ Basic tablet web anonymous",
      "rule": "74c30069-944f-4be5-84da-43a9f4cc08a1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "9e349f5c-423b-4953-b999-b4c00e88e103",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-pt-hs-nl-bc"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Listen with NFL+ mobile web anonymous",
      "rule": "28e3a187-0dc0-4c18-a561-9f431b3bc627",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "755719b2-402a-4257-8289-dcdf3f95de18",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ln"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Listen with NFL+ desktop web anonymous",
      "rule": "cb352ccf-faf4-41b6-9f53-8e5edb391ba6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "bf5b88f0-15e9-4958-855c-8d8ed57a16dd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ln"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Listen with NFL+ tablet web anonymous",
      "rule": "5b79cffe-1bcb-44bc-b6de-222085b95433",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "f000b083-ec5a-4488-a9fc-d42723cf993c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ln"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Watch with NFL+ mobile web anonymous",
      "rule": "57fd674a-adfd-4c27-8fd2-e3acc24f7470",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "3a055735-e04f-43d0-a823-dba37ef4b5a2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-wh"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Watch with NFL+ desktop web anonymous",
      "rule": "9aca1ff9-b815-4cf8-9b01-f26caa2bdacd",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "ddc9eb30-5849-4dd4-b7f3-3f5dbace7ece",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-wh"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Watch with NFL+ tablet web anonymous",
      "rule": "db761819-9307-4a5a-ade8-bdbd4d44a2b6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "c466045e-58b7-44db-8954-08742ad5dbc7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-wh"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Watch Replay mobile web anonymous",
      "rule": "0574ae52-a620-47b2-9bcf-ba2567265c6b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "86586340-2414-471d-b7df-e0202e30b798",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ry"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Watch Replay desktop web anonymous",
      "rule": "ac369c2c-a6e0-4ebb-a8c0-0b32e21739e6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "26e695df-f23a-4665-975b-2aba8f9f015c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ry"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Watch Replay tablet web anonymous",
      "rule": "2648e6a6-132d-4ff8-a347-5944c03c5865",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "2140c27a-5064-4148-a373-cbc6765eeed2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ry"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Upgrade URL for basic subs mobile web anonymous",
      "rule": "f14c64fd-cc51-4ee4-a62e-3d8e261300b8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "cee79a11-127f-4350-9032-eb506e545d33",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ue"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Upgrade URL for basic subs desktop web anonymous",
      "rule": "50ecd8c7-a28c-4ee3-918d-5c244e149555",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "70861621-cb6d-4795-a1ab-e332ddf68ba0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ue"
    },
    {
      "external_segment": null,
      "name": "Ways to Watch Service Card Upgrade URL for basic subs tablet web anonymous",
      "rule": "3b7e876d-09f3-49b6-9b54-f0fd0ef940ca",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "7d7efb74-e39d-4a4b-bea3-9325a999322b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-ge-ds-wtw-ue"
    },
    {
      "external_segment": null,
      "name": "Right Rail Promo NFL+ Basic mobile web anonymous",
      "rule": "cf39eae7-928e-4a68-b130-232a2b6bdbf3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "7aa4c55c-267e-4818-9385-1b4a571eb2f9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-rrpo-bc"
    },
    {
      "external_segment": null,
      "name": "Right Rail Promo NFL+ Basic desktop web anonymous",
      "rule": "0647b40e-a6a8-40e7-91bc-20e1a1a094da",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "163e0432-5ef0-44dc-8043-16c1949a0b6f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-rrpo-bc"
    },
    {
      "external_segment": null,
      "name": "Right Rail Promo NFL+ Basic tablet web anonymous",
      "rule": "b2c38592-cb50-4633-91c8-15b8507128cf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "602961ec-11e6-436e-be79-eb86b16a0bcd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-rrpo-bc"
    },
    {
      "external_segment": null,
      "name": "Right Rail Promo NFL+ Premium mobile web anonymous",
      "rule": "749a4631-52cb-4b7f-936d-36552f41bbde",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "78a67770-b88a-4a30-a4f5-f700a5ddd11d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-rrpo-pm"
    },
    {
      "external_segment": null,
      "name": "Right Rail Promo NFL+ Premium desktop web anonymous",
      "rule": "c0245395-383d-4a72-b349-a7f3f163a97a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "a22aa328-6197-435d-9d73-f292670d2fa7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-rrpo-pm"
    },
    {
      "external_segment": null,
      "name": "Right Rail Promo NFL+ Premium tablet web anonymous",
      "rule": "2d3103c3-a1ee-40ca-a7b4-df8a28bfe3ff",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "1f14bbc4-35af-49da-ba86-410d02fa40d5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-rrpo-pm"
    },
    {
      "external_segment": null,
      "name": "Last Five Games replays to nfl+ premium mobile web anonymous",
      "rule": "cfd91f60-0ddb-49db-a98b-3212b5c00356",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "6159f2e1-bd48-4fb4-bc3f-bc8ebb8fad60",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-ltfe-gs-ry"
    },
    {
      "external_segment": null,
      "name": "Last Five Games replays to nfl+ premium desktop web anonymous",
      "rule": "d1b6f05b-74f4-4975-a10b-861f1a22fbca",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "794e0ece-b0f8-47d2-8188-443af9a2c7c0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-ltfe-gs-ry"
    },
    {
      "external_segment": null,
      "name": "Last Five Games replays to nfl+ premium tablet web anonymous",
      "rule": "863e3e80-76ca-4640-aaa6-a85ea06b65c4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "717fdb72-70c3-4c5d-a893-e7a19902dc84",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-ltfe-gs-ry"
    },
    {
      "external_segment": null,
      "name": "Previous Match Up NFL+ Premium Replays mobile web anonymous",
      "rule": "62663bde-b5f6-49c8-af65-ba5bb7889d86",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "f9fa3835-d8bc-489e-ad15-a754cab2a681",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-psmhup-ry"
    },
    {
      "external_segment": null,
      "name": "Previous Match Up NFL+ Premium Replays desktop web anonymous",
      "rule": "32fe672b-24f7-4d2e-9090-d6eb7943f506",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "3d366212-c48b-4696-a3a8-72aa6ab72141",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-psmhup-ry"
    },
    {
      "external_segment": null,
      "name": "Previous Match Up NFL+ Premium Replays tablet web anonymous",
      "rule": "288ea6de-fdc6-430e-a5f4-ce4c816c8356",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "c0c02b5a-c049-4aa9-8b9c-7563b1060678",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gs-psmhup-ry"
    },
    {
      "external_segment": null,
      "name": "Promo end card mobile web anonymous",
      "rule": "b6acf633-c785-45bf-9410-0e2246611a0d",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "edc42e95-268c-48d1-bea6-b716cbd55d59",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-pm-ecd"
    },
    {
      "external_segment": null,
      "name": "Promo end card desktop web anonymous",
      "rule": "7cb97a46-47a7-40dc-b9ab-915866c3210b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "107dd73e-e544-4330-855e-601bb7b15090",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-pm-ecd"
    },
    {
      "external_segment": null,
      "name": "Promo end card tablet web anonymous",
      "rule": "d0b75ccf-e834-4faf-8053-2f3179f31267",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "180cf89f-3037-43cd-9022-723b3fc483e7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-pm-ecd"
    },
    {
      "external_segment": null,
      "name": "Video player mobile web anonymous",
      "rule": "bd13dda9-8f21-4236-a481-c7c49a747013",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "8f4b38a0-0b24-4bb4-958f-3c61c46e877a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-vpr"
    },
    {
      "external_segment": null,
      "name": "Video player desktop web anonymous",
      "rule": "ba410414-3568-44ad-a69d-04ce3e997e2e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "5e0759d0-50b1-4279-b111-3b21648ac5a3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-vpr"
    },
    {
      "external_segment": null,
      "name": "Video player tablet web anonymous",
      "rule": "bc6a86a6-b234-4e6c-8ab6-a7f54935cb86",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "259d2463-2090-416e-9e90-ac970139f596",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-vpr"
    },
    {
      "external_segment": null,
      "name": "Video player right rail mobile web anonymous",
      "rule": "ef27dd6c-cba9-4e9d-8fc2-b13abb18707e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "b254519f-c7ae-4ef7-a4a0-5c9a9316da98",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-vpr-rtl"
    },
    {
      "external_segment": null,
      "name": "Video player right rail desktop web anonymous",
      "rule": "3fdea7e7-f1db-4367-9a38-4c03736e32e6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "82ec46d6-1927-4913-bf0b-1743dfbc5857",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-vpr-rtl"
    },
    {
      "external_segment": null,
      "name": "Video player right rail tablet web anonymous",
      "rule": "9fe49863-7f8c-425b-a1be-a260b5d8a340",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "5c074c92-0d40-46b6-a530-e0236036a213",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-vpr-rtl"
    },
    {
      "external_segment": null,
      "name": "Redzone right rail video player mobile web anonymous",
      "rule": "5cc52553-b9b2-42ba-a115-2e30a645cb2e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "78c26fd2-8f8f-44d5-bcc6-2d45d3e00f4f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-re-rtl-vpr"
    },
    {
      "external_segment": null,
      "name": "Redzone right rail video player desktop web anonymous",
      "rule": "2595e4a9-ef4c-4e08-ac57-fffdcfce6839",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "88b4c563-dcd3-4f45-a7e4-99c02c5031be",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-re-rtl-vpr"
    },
    {
      "external_segment": null,
      "name": "Redzone right rail video player tablet web anonymous",
      "rule": "dd30948c-2d2b-48ee-b79e-23533d4f1b24",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "e1d5b3bb-83da-4188-9dc3-37d7d58465b8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "sc-re-rtl-vpr"
    },
    {
      "external_segment": null,
      "name": "Article page promo Basic mobile web anonymous",
      "rule": "29310dc7-2926-4c25-b6be-c39a4f289489",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "2ddbe420-b050-4ebb-bdd7-50b8c0f89310",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "as-pe-po-bs"
    },
    {
      "external_segment": null,
      "name": "Article page promo Basic desktop web anonymous",
      "rule": "ffa81dbc-2cb6-4f35-b0f4-8feb9de31c52",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "e50e9c5a-73c5-428a-a4e8-3ee647a9a366",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "as-pe-po-bs"
    },
    {
      "external_segment": null,
      "name": "Article page promo Basic tablet web anonymous",
      "rule": "7c4f451f-151a-4a0d-9c92-67e49e725c2f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "4ca972f2-5a1d-4eea-a7cd-bc18d8ca38de",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "as-pe-po-bs"
    },
    {
      "external_segment": null,
      "name": "Article page promo Premium mobile web anonymous",
      "rule": "2f5a3e7a-0ad7-41fc-b4c6-e411ded73174",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a62a195b-2016-41b9-9c75-1026457ac817",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "as-pe-po-pm"
    },
    {
      "external_segment": null,
      "name": "Article page promo Premium desktop web anonymous",
      "rule": "52a300eb-eff7-481b-adc1-d11c26c5a58e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "fc2fb796-036e-4bd0-b697-23214b8a7dd4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "as-pe-po-pm"
    },
    {
      "external_segment": null,
      "name": "Article page promo Premium tablet web anonymous",
      "rule": "09cae79d-1430-4c61-8716-aa109888158f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "fa20d6e1-da2b-4eb1-9695-946791a45e18",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "as-pe-po-pm"
    },
    {
      "external_segment": null,
      "name": "fan-journey-all tablet web anonymous",
      "rule": "6cfb273a-00f0-43c1-9c11-7d5b4b2459af",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "ce297831-dba9-4e91-92b9-d8be8bc9ae7e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "fn-jn-al"
    },
    {
      "external_segment": null,
      "name": "fan-journey-all mobile web anonymous",
      "rule": "79e33f80-8e93-49c1-93a2-d6c0bc352002",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "8532134d-d159-4d4c-8aa2-dbf4e7651d1b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "fn-jn-al"
    },
    {
      "external_segment": null,
      "name": "fan-journey-all desktop web anonymous",
      "rule": "6b80a653-e557-47ed-b182-561a1c715d96",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "4a480f64-633f-497f-a943-e1528f46d24d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "fn-jn-al"
    },
    {
      "external_segment": null,
      "name": "fan-journey-premium mobile web anonymous",
      "rule": "c28c4e77-d418-415d-a213-e1ef616bca1f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "5e39505c-9e0c-4f17-b80a-fd1c1100a52c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "fn-jn-pm"
    },
    {
      "external_segment": null,
      "name": "fan-journey-premium tablet web anonymous",
      "rule": "b3c1e499-f7dd-4bfa-bff0-111bddbeb5ed",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "7aaa6411-0c0f-445b-866a-692192e250ca",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "fn-jn-pm"
    },
    {
      "external_segment": null,
      "name": "fan-journey-premium desktop web anonymous",
      "rule": "c8ca031e-7f7c-4558-90fd-c157ce0dfbb0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "078b7bd5-eefe-4c9f-b02b-27cb25256b7e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "fn-jn-pm"
    },
    {
      "external_segment": null,
      "name": "Internal Coupon Distribution Mobile Web Anonymous",
      "rule": "a7aed71d-aaab-4d11-825b-e40505df2973",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "532101b7-2ae8-4401-bba7-647d91ed3da0",
          "segment": "de23a8f2-de1e-42a3-bb70-2041eeb101d0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-cn-dn"
    },
    {
      "external_segment": null,
      "name": "Internal Coupon Distribution Desktop Web Anonymous",
      "rule": "81016b7e-8c7e-4655-ada4-5c9c178b38d2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "960bfa15-d5b4-47e3-b86a-53aad4ea9a33",
          "segment": "14fc1f1b-29eb-428c-a397-d1c362cd28ba",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-cn-dn"
    },
    {
      "external_segment": null,
      "name": "Internal Coupon Distribution Tablet Web Anonymous",
      "rule": "4967d65f-b731-4107-ae3f-abc18114e59a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "da780949-9e81-47bc-9618-158a6232df25",
          "segment": "552432e8-4484-45d6-8a69-9cadc7e5c41d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "il-cn-dn"
    },
    {
      "external_segment": null,
      "name": "preseason Mobile Web Anonymous",
      "rule": "f8132f2d-6db2-4e4b-a306-1f9425008da6",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "c0c122dc-01f4-4a34-9ab5-bdabb843aa73",
          "segment": "7c2b1e09-0f99-4f4a-9156-436b3613a402",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "prsn"
    },
    {
      "external_segment": null,
      "name": "preseason Desktop Web Anonymous",
      "rule": "404544b5-906b-4b60-9493-b8f057a94213",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "04a04dea-a22e-4652-a240-3889b7826045",
          "segment": "f08e56da-d507-4f65-a078-bd028bf22f20",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "prsn"
    },
    {
      "external_segment": null,
      "name": "preseason tablet web anonymous",
      "rule": "1f99e999-ddaf-4e6c-a576-067783729e14",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ece8b1c1-690b-49be-8421-ba2c228ca852",
          "segment": "53acc940-90b3-4430-a62e-6f1ad3b494f9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "prsn"
    },
    {
      "external_segment": null,
      "name": "isg-nflne Mobile Web Anonymous",
      "rule": "ee9b89e0-c7ba-4fc8-8ff8-c74e4de80f74",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "a712cb0a-be8c-4132-bdbb-21575b2b1a8b",
          "segment": "e47905a0-8585-4050-8e3c-a0b288987330",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ig-ne"
    },
    {
      "external_segment": null,
      "name": "isg-nflne Desktop Web Anonymous",
      "rule": "299f966e-78b7-4749-9151-32191507cfb5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "8c94e6ba-f8f1-4e9d-8df1-2f87e6323982",
          "segment": "62dd3533-f406-43e1-a0e5-c4efb8342ed5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ig-ne"
    },
    {
      "external_segment": null,
      "name": "isg-nflne tablet web anonymous",
      "rule": "4b19f3b8-19ac-4f98-93a0-a7878df1e2ea",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "558e6971-00da-4190-853f-997b63af22d9",
          "segment": "991e06dc-284c-414f-90b3-ee103efb888d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ig-ne"
    },
    {
      "external_segment": null,
      "name": "game-replay mobile web anonymous",
      "rule": "6f3acfed-a9f5-4450-81c6-73673e748449",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "5ab85a57-7519-491c-97f8-f292de8f5b8f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ge-ry"
    },
    {
      "external_segment": null,
      "name": "game-replay tablet web anonymous",
      "rule": "b044fada-110f-4665-8d9a-f2e28f2ed38a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "592e3429-a0ea-4cc0-95a6-20b7a35b44d0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ge-ry"
    },
    {
      "external_segment": null,
      "name": "game-replay desktop web anonymous",
      "rule": "960256f2-b806-416c-86f1-e70a7a6ba9f4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "9ff33883-97ef-4bcc-ade4-6579729af20d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ge-ry"
    },
    {
      "external_segment": null,
      "name": "nfl-pro mobile web anonymous",
      "rule": "9673e960-0327-476d-9625-62ec2f9d0f04",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "2fc04648-f8f8-47e9-9fad-54753c2412bf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-po"
    },
    {
      "external_segment": null,
      "name": "nfl-pro tablet web anonymous",
      "rule": "555a7aba-cdc4-495a-bb6c-15766429a5bc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "3a55a557-e95f-487a-9a13-03adf7092e9d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-po"
    },
    {
      "external_segment": null,
      "name": "nfl-pro desktop web anonymous",
      "rule": "e069f7db-994f-4c1d-8dc7-5737845fad9f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "2fb2a3e4-ba3e-4ff8-8912-e4bb339a0f20",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nl-po"
    },
    {
      "external_segment": null,
      "name": "Account Subscribe button Mobile Web Anonymous",
      "rule": "f78b7520-bb40-401b-bcd8-97f13ea719fb",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "89096d76-7b08-407e-b819-28f243381c3c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "id-at-se"
    },
    {
      "external_segment": null,
      "name": "Account Subscribe button Desktop Web Anonymous",
      "rule": "719a9285-24a5-4d30-9e50-068273b05e42",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "130f1815-4d42-4902-ba63-d65ad0460a25",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "id-at-se"
    },
    {
      "external_segment": null,
      "name": "Account Subscribe button tablet web anonymous",
      "rule": "0e5c6b28-a71f-44f5-922b-3188d125efad",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "515f717c-57d6-4f8c-860d-173f3b692796",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "id-at-se"
    },
    {
      "external_segment": null,
      "name": "floating subscribe premium monthly Mobile Web Anonymous",
      "rule": "b341ea78-5edc-4a2a-ba82-f6fba479e5f5",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "de246ff5-93d2-4b28-8c2b-eca06cf93fd5",
          "segment": "c1e4651f-6a26-45c9-bb0c-98fa3e3cbec9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-py"
    },
    {
      "external_segment": null,
      "name": "floating subscribe premium monthly Desktop Web Anonymous",
      "rule": "e9bcb5cc-28e8-4a80-b84a-100d42f00ece",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "29b79180-78ed-4a62-9765-ef41cf061037",
          "segment": "0b854f87-fe81-4586-9736-3985c753b0d2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-py"
    },
    {
      "external_segment": null,
      "name": "floating subscribe premium Annual Mobile Web Anonymous",
      "rule": "d85b7693-ff31-4f34-b61a-cc02f2b9443a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "70e4fe0e-f372-4e73-ac68-d0876336644b",
          "segment": "ba8ee32c-3b89-4555-b30a-188cba2f5c08",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-pl"
    },
    {
      "external_segment": null,
      "name": "floating subscribe premium Annual Desktop Web Anonymous",
      "rule": "a5f0ba2a-f01e-447d-b5ac-77c04a5f644b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "51c383f6-45cb-46a0-9d62-0192900ab49b",
          "segment": "c94f83b8-d468-4ace-87c8-1e0f446d3c1d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-pl"
    },
    {
      "external_segment": null,
      "name": "floating subscribe RedZone mobile web anonymous",
      "rule": "eff6c90e-6f7c-47b8-8d6b-ffb5ba44f6d0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "6598cffc-0834-4ab8-8c0b-6c01e428ee26",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-re"
    },
    {
      "external_segment": null,
      "name": "floating subscribe RedZone desktop web anonymous",
      "rule": "4eabc306-5595-4686-8b44-0163aa626d5f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "683a6617-b03c-415e-942b-78a9c70faa9d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-re"
    },
    {
      "external_segment": null,
      "name": "floating subscribe RedZone tablet web anonymous",
      "rule": "e85d55c9-6784-41d2-9597-392bb9e3568b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "4ef5373b-198e-4171-8217-f9e23ba22a7f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-re"
    },
    {
      "external_segment": null,
      "name": "floating subscribe Replays mobile web anonymous",
      "rule": "9f31e4a4-2ce0-402e-8256-13c622d722ec",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "1fdade3b-c741-45b8-b80c-543d2fa9a9d2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-rs"
    },
    {
      "external_segment": null,
      "name": "floating subscribe Replays desktop web anonymous",
      "rule": "007a0fee-583e-4b33-b448-0863f94d9374",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "000392a9-3ec4-4aed-972c-fa1802113d4c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-rs"
    },
    {
      "external_segment": null,
      "name": "floating subscribe Replays tablet web anonymous",
      "rule": "c247bada-a1d3-466b-90f3-4d2ce6a648e0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "cfa9f904-22da-4775-8152-a37dcebbc246",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-rs"
    },
    {
      "external_segment": null,
      "name": "floating subscribe NFL PRO mobile web anonymous",
      "rule": "54958f0a-930b-4a2c-be56-c328a1abc8ac",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "9defb317-4f9b-487b-b04c-ecb2584a6f3c",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-no"
    },
    {
      "external_segment": null,
      "name": "floating subscribe NFL PRO desktop web anonymous",
      "rule": "3dbad2cc-ece3-4bae-bf68-9840367a70d8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "569e5fd5-ef44-464a-a650-2f1b04fa90c7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-no"
    },
    {
      "external_segment": null,
      "name": "floating subscribe NFL PRO tablet web anonymous",
      "rule": "58745838-8793-48ae-bc2d-16914f403091",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "2a11eae6-aae0-4178-a8fc-c353ac556f59",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-no"
    },
    {
      "external_segment": null,
      "name": "game card premium monthly Mobile Web Anonymous",
      "rule": "e180b75e-4e45-4a8f-a023-ac5302e9ee5c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "de246ff5-93d2-4b28-8c2b-eca06cf93fd5",
          "segment": "0e90a9fc-e509-4e9e-a95a-f26bcb234ed0",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-py"
    },
    {
      "external_segment": null,
      "name": "game card premium monthly Desktop Web Anonymous",
      "rule": "846a476c-d123-4554-9cea-7b297949d1ce",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "29b79180-78ed-4a62-9765-ef41cf061037",
          "segment": "a7748f91-c04e-4507-84af-fc92b2b77326",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-py"
    },
    {
      "external_segment": null,
      "name": "game card premium Annual Mobile Web Anonymous",
      "rule": "dc39c8fe-cc3f-4172-847c-c94c65854c24",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "70e4fe0e-f372-4e73-ac68-d0876336644b",
          "segment": "54bebdf2-1a7b-48b7-adfb-8cfb799c32b6",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-pl"
    },
    {
      "external_segment": null,
      "name": "game card premium Annual Desktop Web Anonymous",
      "rule": "811c02f5-05db-4fc5-99a2-5e847882a838",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "51c383f6-45cb-46a0-9d62-0192900ab49b",
          "segment": "c85b1ae7-9b8d-48a6-af1a-dc6522885710",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-pl"
    },
    {
      "external_segment": null,
      "name": "game card RedZone mobile web anonymous",
      "rule": "49be8ec2-4389-4761-806a-f0488747fbce",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "3b32176c-652b-400f-b8af-6ad3c1286fb6",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-re"
    },
    {
      "external_segment": null,
      "name": "game card RedZone desktop web anonymous",
      "rule": "78822ee4-e2e0-4b29-ab42-4bf9e015b860",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "9a1b3343-f215-4f3f-8902-e2d965dd83cb",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-re"
    },
    {
      "external_segment": null,
      "name": "game card RedZone tablet web anonymous",
      "rule": "6be64d3f-6a32-47bf-b126-d9dc4d060f73",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "850f431f-39d2-42cd-bab8-78adf93f9493",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-re"
    },
    {
      "external_segment": null,
      "name": "game card Replays mobile web anonymous",
      "rule": "cb3556b3-8e8a-4f2d-92f3-24b35e9b6945",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "0a0470df-fd15-4456-a648-f26d256a9739",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-rs"
    },
    {
      "external_segment": null,
      "name": "game card Replays desktop web anonymous",
      "rule": "8675f2f2-9d4f-440b-a584-942873bc91d4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "1fc98e59-3e40-4b37-9f6a-3fbc65399f70",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-rs"
    },
    {
      "external_segment": null,
      "name": "game card Replays tablet web anonymous",
      "rule": "c173fdd4-5b7c-4822-a86d-8f98cfec31ac",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "8c3ad183-019d-4ac2-b73c-24f04fefcfcb",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-rs"
    },
    {
      "external_segment": null,
      "name": "game card NFL PRO mobile web anonymous",
      "rule": "1bac74e4-9eaf-42c7-af3c-95cf9b78eac9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "c81f3db8-b173-4a3e-810a-526638a5a5ba",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-no"
    },
    {
      "external_segment": null,
      "name": "game card NFL PRO desktop web anonymous",
      "rule": "8ff48ef2-393d-4c0a-b9a7-c5565d72f933",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "aa73837a-b710-4663-8f90-80d03e520c6d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-no"
    },
    {
      "external_segment": null,
      "name": "game card NFL PRO tablet web anonymous",
      "rule": "639d574f-ecc5-4e1e-ba5e-4d32bfaf91c9",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "470b99d9-3142-40cc-b790-905ace35d753",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-no"
    },
    {
      "external_segment": null,
      "name": "floating subscribe basic monthly Mobile Web Anonymous",
      "rule": "422bb513-0a4d-47f3-ae59-9274708b6106",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "6fd723c4-2342-44c5-a0d3-95ae223f95d7",
          "segment": "d4383379-561e-472c-bf1d-2018a552ebbf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-by"
    },
    {
      "external_segment": null,
      "name": "floating subscribe basic monthly Desktop Web Anonymous",
      "rule": "f3141f25-fdab-4ce2-9a55-a410e4176297",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "87333cdc-c3e1-4474-881b-89463a7621b1",
          "segment": "f5a10824-9c04-464c-b283-a6c899e366cc",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-by"
    },
    {
      "external_segment": null,
      "name": "floating subscribe basic Annual Mobile Web Anonymous",
      "rule": "10b657c3-c183-4287-86d6-5760b83d4fb2",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "9e2addb5-752b-40c8-824e-e50997379b1f",
          "segment": "bb117eee-90f5-420e-bc08-4178e84b7ef1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-bl"
    },
    {
      "external_segment": null,
      "name": "floating subscribe basic Annual Desktop Web Anonymous",
      "rule": "64f9f561-84ce-4583-89bf-32f947dc56f8",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "eeec8188-3283-402e-91c0-75a52990a2a5",
          "segment": "d7baccfa-3102-44a9-885b-22fbafaa3302",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-bl"
    },
    {
      "external_segment": null,
      "name": "floating subscribe live games mobile web anonymous",
      "rule": "30f9ed19-902e-40b4-b1a4-cf7033145b48",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "d9be8f8e-891e-454f-b6a9-3710a409c294",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-ls"
    },
    {
      "external_segment": null,
      "name": "floating subscribe live games desktop web anonymous",
      "rule": "3105387e-b16c-4642-a588-314131b3cd8b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "32d2f2f3-52f1-4ac2-a760-617ac143e7f6",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-ls"
    },
    {
      "external_segment": null,
      "name": "floating subscribe live games tablet web anonymous",
      "rule": "c8dba245-d849-40d8-8882-eb4b260b5b56",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "20f87055-cf34-44e9-949a-b849b9c23238",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-ls"
    },
    {
      "external_segment": null,
      "name": "game card basic monthly Mobile Web Anonymous",
      "rule": "1c51a235-0317-48f0-aa9b-a325c541ceb0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "6fd723c4-2342-44c5-a0d3-95ae223f95d7",
          "segment": "a35e24b0-a691-487c-8b42-35518f58b8b8",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-by"
    },
    {
      "external_segment": null,
      "name": "game card basic monthly Desktop Web Anonymous",
      "rule": "fc949925-726a-456b-a0ec-0b0b46b2d4cd",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "87333cdc-c3e1-4474-881b-89463a7621b1",
          "segment": "e2c84d4b-fff6-4a10-97d5-e6c46d60d7a9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-by"
    },
    {
      "external_segment": null,
      "name": "game card basic Annual Mobile Web Anonymous",
      "rule": "91fe2c80-81b9-4a5e-b3a0-9fdd4d333592",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "9e2addb5-752b-40c8-824e-e50997379b1f",
          "segment": "da6cbcc4-6dda-4428-a059-9e46692bf006",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-bl"
    },
    {
      "external_segment": null,
      "name": "game card basic Annual Desktop Web Anonymous",
      "rule": "6f476ab4-ae72-4103-9548-fd4898e3cfdc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "eeec8188-3283-402e-91c0-75a52990a2a5",
          "segment": "9c620612-a7f8-4cb4-b32d-2b825703464b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-bl"
    },
    {
      "external_segment": null,
      "name": "game card live games mobile web anonymous",
      "rule": "8387f34b-f69a-422d-b772-20d1c83f76b3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "9c6dea54-75af-4e05-9c8f-b7a28d60af5b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-ls"
    },
    {
      "external_segment": null,
      "name": "game card live games desktop web anonymous",
      "rule": "36834f0e-a03a-4872-b803-5b704f6a11cc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "80e0178d-1a22-482f-87d6-debcec37d2bd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-ls"
    },
    {
      "external_segment": null,
      "name": "game card live games tablet web anonymous",
      "rule": "675b3ee3-05e6-4141-8c82-bbdb58a02dbc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "7eeb7d34-e4f9-4b1c-9477-e8d78c3960b3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-ls"
    },
    {
      "external_segment": null,
      "name": "generic all default annual mobile web anonymous",
      "rule": "b3d07847-d58c-4ff8-a761-0fdf82423d57",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "31f5fdea-f355-4cb8-8b2e-0f2ab01fabac",
          "segment": "dfa7f4b4-fb4e-451b-8a04-189310004971",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-al-dt-al"
    },
    {
      "external_segment": null,
      "name": "generic all default annual desktop web anonymous",
      "rule": "32679660-43b6-4e52-be1f-722ac2437d93",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "567322b4-0a00-4feb-be64-24cfb76bb20a",
          "segment": "297f5a28-9b7d-4fef-b6bb-715eef632094",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-al-dt-al"
    },
    {
      "external_segment": null,
      "name": "generic all default annual tablet web anonymous",
      "rule": "a02d117d-6059-427a-9bec-fab1a67837b3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "c5a91a13-be48-4792-8674-ed4b78ebc6cf",
          "segment": "d811bd1b-ce62-4890-857a-fcc211b7a78d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-al-dt-al"
    },
    {
      "external_segment": null,
      "name": "EXPLORE ALL NFL+ PLANS CTA mobile web anonymous",
      "rule": "cbed0bd7-957d-42c0-a625-500e3f746fb4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "f8f45306-6ecd-4659-aa5e-b9c76cf26720",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-eeal-nlpsca"
    },
    {
      "external_segment": null,
      "name": "EXPLORE ALL NFL+ PLANS CTA desktop web anonymous",
      "rule": "ffdd2f67-20be-4621-80c5-1a5bfa16965f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "026ac6b5-2a39-4f5b-b21f-34d21092819b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-eeal-nlpsca"
    },
    {
      "external_segment": null,
      "name": "EXPLORE ALL NFL+ PLANS CTA tablet web anonymous",
      "rule": "a8904f9b-b769-47b4-affc-af3bfffd17c1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "7d8dda0a-0494-43b1-b912-15e091b909a1",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "gc-eeal-nlpsca"
    },
    {
      "external_segment": null,
      "name": "hero basic monthly Mobile Web Anonymous",
      "rule": "b9e565b6-1792-4468-86c7-64ea74be44dc",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "6fd723c4-2342-44c5-a0d3-95ae223f95d7",
          "segment": "265395ca-b93f-4307-8045-3304dbec1c24",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-by"
    },
    {
      "external_segment": null,
      "name": "hero basic monthly Desktop Web Anonymous",
      "rule": "ecea0d5b-0163-44d1-9c14-7692e84100fd",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "87333cdc-c3e1-4474-881b-89463a7621b1",
          "segment": "e00cfbd7-7880-4b1d-ab53-a04ae83f2b94",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-by"
    },
    {
      "external_segment": null,
      "name": "hero basic annual Mobile Web Anonymous",
      "rule": "3bea2537-2611-4f2d-8766-6c307f4ea740",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "9e2addb5-752b-40c8-824e-e50997379b1f",
          "segment": "77436e57-1ac8-4bb2-b65f-89f06a5f759e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-bl"
    },
    {
      "external_segment": null,
      "name": "hero basic annual Desktop Web Anonymous",
      "rule": "fa8dea08-231f-42c8-912f-183b10736d06",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "eeec8188-3283-402e-91c0-75a52990a2a5",
          "segment": "0546a5ab-49b5-4767-8dca-6eef3f385100",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-bl"
    },
    {
      "external_segment": null,
      "name": "hero premium monthly Mobile Web Anonymous",
      "rule": "7b2c7b4d-39a5-425a-9817-628502efeb0f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "de246ff5-93d2-4b28-8c2b-eca06cf93fd5",
          "segment": "dd3f58f6-31f3-45f6-b29d-5f639461acd4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-py"
    },
    {
      "external_segment": null,
      "name": "hero premium monthly Desktop Web Anonymous",
      "rule": "f91ab7f9-2189-426d-90b7-f5762a57a112",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "29b79180-78ed-4a62-9765-ef41cf061037",
          "segment": "10c04840-75f8-4bed-b395-f9008a351351",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-py"
    },
    {
      "external_segment": null,
      "name": "hero premium annual Mobile Web Anonymous",
      "rule": "051ed734-a450-4af4-a6af-25ac6cac2dd1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "70e4fe0e-f372-4e73-ac68-d0876336644b",
          "segment": "eb5493c1-bbc2-4322-80ac-80d03f296e7b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pl"
    },
    {
      "external_segment": null,
      "name": "hero premium annual Desktop Web Anonymous",
      "rule": "0428d5e1-d0cb-4090-a03b-524a760fd95f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "51c383f6-45cb-46a0-9d62-0192900ab49b",
          "segment": "1992802b-db22-4349-8c8f-eff77d855fdd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pl"
    },
    {
      "external_segment": null,
      "name": "floating subscribe all mobile web anonymous",
      "rule": "62599039-f3fa-45f1-a109-9483d903e222",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "32540fc4-1c5d-4fbd-91fe-2a5b1c926c73",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-al"
    },
    {
      "external_segment": null,
      "name": "floating subscribe all desktop web anonymous",
      "rule": "48f4bc49-cf57-41c7-a702-98a93a970a5b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "fe4f2aa2-0539-4515-a9b7-b1380f4fd25a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-al"
    },
    {
      "external_segment": null,
      "name": "floating subscribe all tablet web anonymous",
      "rule": "e4f2b2e8-3f67-413e-9e01-ad95ec740421",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "960d6c94-4d9b-4839-a81c-d984937c7b94",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-fgse-al"
    },
    {
      "external_segment": null,
      "name": "game card all mobile web anonymous",
      "rule": "44f79baf-3461-4d5c-bcca-33772d2b4cc0",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "b4e997d9-2dee-4f2d-b3d5-fd9c43985d81",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-al"
    },
    {
      "external_segment": null,
      "name": "game card all desktop web anonymous",
      "rule": "f55bb5c9-9767-4057-bb24-bfde6a4e5c89",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "7964d549-88fd-4773-baef-6307f7e815af",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-al"
    },
    {
      "external_segment": null,
      "name": "game card all tablet web anonymous",
      "rule": "c741cdd2-4ba4-4098-93ee-07cafb851649",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "9810959c-1a1a-4ec6-bf4f-db2ce9bd1ad3",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-al"
    },
    {
      "external_segment": null,
      "name": "hero all mobile web anonymous",
      "rule": "c914813f-cfa6-4060-9a32-ebfdd9b48818",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "9d15e2a0-3f62-417a-ad34-0ada2f23cf34",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-al"
    },
    {
      "external_segment": null,
      "name": "hero all desktop web anonymous",
      "rule": "0b1c9fe3-4f3d-4627-848f-8820ef32edde",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "1d1b81cb-de5f-4708-aeef-036c275e92d7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-al"
    },
    {
      "external_segment": null,
      "name": "hero all tablet web anonymous",
      "rule": "6e71226e-1ffa-4ce0-a06d-c19a55769a0a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "8fcfb988-9d55-483f-ae87-8afc7f75ae1d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-al"
    },
    {
      "external_segment": null,
      "name": "game card Preseason mobile web anonymous",
      "rule": "c3e40bfa-17c1-48a0-b8f0-d38b68ecdcef",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "1e136ce2-abf4-4a98-a5c1-697f60ca0054",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-pn"
    },
    {
      "external_segment": null,
      "name": "game card Preseason desktop web anonymous",
      "rule": "8631e95d-867a-4535-b248-de26933e6a56",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "61652e71-d0af-4db4-9308-bb27f1c03f79",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-pn"
    },
    {
      "external_segment": null,
      "name": "game card Preseason tablet web anonymous",
      "rule": "dd46885c-d710-4db3-944d-45c944b04cb3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "0d0b5f19-1449-4270-898c-5c80de465723",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-pn"
    },
    {
      "external_segment": null,
      "name": "game card Network mobile web anonymous",
      "rule": "e7bf8651-b490-4e9c-95fc-dbee91d4b474",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "777ff42b-62d8-4a0a-9403-08df15a89eb2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-nk"
    },
    {
      "external_segment": null,
      "name": "game card Network desktop web anonymous",
      "rule": "64541c4a-0621-4b40-8221-9bfb07df0876",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "5cd87831-71bd-4b3e-b5ed-d1bd3aee21a9",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-nk"
    },
    {
      "external_segment": null,
      "name": "game card Network tablet web anonymous",
      "rule": "b969d425-cd84-42e0-933e-b37c270bb9f1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "aceeb4bb-2945-4211-9aff-6b7024b11852",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-gcd-nk"
    },
    {
      "external_segment": null,
      "name": "hero network  mobile web anonymous",
      "rule": "54590c22-69b0-4d8d-a381-34629239b534",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "cb4c0a9f-0cda-446e-b066-53ad578dd01f",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-nk"
    },
    {
      "external_segment": null,
      "name": "hero network  desktop web anonymous",
      "rule": "3922ec5c-0b38-491e-980a-aa2eb746c212",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "4195544b-5a00-4c64-8ab2-91065dfe8927",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-nk"
    },
    {
      "external_segment": null,
      "name": "hero network  tablet web anonymous",
      "rule": "5d192285-bf82-410f-b4c5-a46a2a328f3f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "e8b76863-8c95-47d8-b6dd-5366f032e322",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-nk"
    },
    {
      "external_segment": null,
      "name": "hero live games mobile web anonymous",
      "rule": "9d3ce04b-5cff-4775-94f6-4ebe4131f26e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "ad4ccf56-6326-4a90-b5ea-3df958dce10e",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-ls"
    },
    {
      "external_segment": null,
      "name": "hero live games desktop web anonymous",
      "rule": "74424857-c50f-4f76-bb05-c5eb0450298b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "ecc34a14-25d2-4544-af80-37ee87b43a9a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-ls"
    },
    {
      "external_segment": null,
      "name": "hero live games tablet web anonymous",
      "rule": "47cb06cd-eb95-4a8a-8cee-23954cdd85cb",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "087f4738-6f52-484a-80fb-a6f232aa7b51",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-ls"
    },
    {
      "external_segment": null,
      "name": "hero preseason mobile web anonymous",
      "rule": "f34eb35d-6958-435c-9d4a-bdf7ef1abd98",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "67d0946e-6102-40f3-84b2-2bb83133691a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pn"
    },
    {
      "external_segment": null,
      "name": "hero preseason desktop web anonymous",
      "rule": "586d72ec-321a-4735-9bf3-a6b6b5c95127",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "638af3a8-382b-4738-9541-2862db9b5643",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pn"
    },
    {
      "external_segment": null,
      "name": "hero preseason tablet web anonymous",
      "rule": "899b1e49-109b-4f96-8f1a-262b904404d3",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "30aeb6c3-8bb0-418b-b1a2-bfea06f04dc2",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pn"
    },
    {
      "external_segment": null,
      "name": "hero post season mobile web anonymous",
      "rule": "c392f522-9195-4624-8cde-159b1d0aef05",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "755fc0fd-6252-4b48-93ce-0f8e2d1fbfcc",
          "segment": "75d98591-bcfe-43ea-a9ac-be4d7449e4f7",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pon"
    },
    {
      "external_segment": null,
      "name": "hero post season desktop web anonymous",
      "rule": "53d5ae36-fd05-4157-9334-92088f42855f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7fc627f3-a98f-4ad9-9496-0f568bee6dce",
          "segment": "f5f2f8c2-ba0d-42a5-afae-f07e4eafdc85",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pon"
    },
    {
      "external_segment": null,
      "name": "hero post season tablet web anonymous",
      "rule": "effca903-d946-497c-9db9-0c7ef2b79826",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "193c11c0-a288-4b4b-8887-66e6ac3aa54c",
          "segment": "649b48de-d840-43f8-bdee-b16cfe7d9801",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-pon"
    },
    {
      "external_segment": null,
      "name": "hero redzone mobile web anonymous",
      "rule": "1c211116-0a4e-4650-b80c-785eee4d4735",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "a3d326bc-130b-4103-b584-d1c01953d544",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-re"
    },
    {
      "external_segment": null,
      "name": "hero redzone desktop web anonymous",
      "rule": "b17439b4-61d1-4a4f-aef5-86af341c7044",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "2bd22bcc-76f1-41e1-aa87-4f1e9c0d8a0d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-re"
    },
    {
      "external_segment": null,
      "name": "hero redzone tablet web anonymous",
      "rule": "8746065c-03b3-4bab-a17e-5d1d96fe55ce",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "e02d433f-28e9-46f0-b425-db8206e415cf",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-re"
    },
    {
      "external_segment": null,
      "name": "hero replays mobile web anonymous",
      "rule": "c06bc85a-4b63-4e15-973b-d8c31f631f9e",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "133df396-7f2f-4561-95a0-7ef712354768",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-rs"
    },
    {
      "external_segment": null,
      "name": "hero replays desktop web anonymous",
      "rule": "dc1ee9ab-4e6f-4ded-b6aa-ae008d968adf",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "ea783cbd-4d63-4413-8ba0-cbd74aaf3518",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-rs"
    },
    {
      "external_segment": null,
      "name": "hero replays tablet web anonymous",
      "rule": "26ae0507-21ba-4cc6-99e3-30434cb05d23",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "02865d30-ca3a-4373-89dc-15c6895a532a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-rs"
    },
    {
      "external_segment": null,
      "name": "hero NFL PRO mobile web anonymous",
      "rule": "6f807fd6-841a-41bd-8ec6-102232c5eb82",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4b44cabb-853b-4ee6-9fd7-a7c522e1de92",
          "segment": "3e082dde-51ce-4f82-8bf5-0c551123ff89",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-no"
    },
    {
      "external_segment": null,
      "name": "hero NFL PRO desktop web anonymous",
      "rule": "781bb1c6-c0c2-48b3-8e6a-d9edce34676c",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "ccfd8d1f-8095-43e0-a390-df1862081b3c",
          "segment": "9cad6a13-b37f-494a-b7b8-2a82fc42e638",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-no"
    },
    {
      "external_segment": null,
      "name": "hero NFL PRO tablet web anonymous",
      "rule": "e457c294-b1a3-4ec6-bc64-0315cbecee3a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "48440e56-cebd-4faf-934c-f827c6951795",
          "segment": "1d335c8c-ca66-4d0d-b00e-bf94e32ad330",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "ps-le-ho-no"
    },
    {
      "external_segment": null,
      "name": "STM Code Redemption Mobile Web Anonymous",
      "rule": "baf62f2c-659f-468a-9e0b-ca8e915b4c41",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "1e08c902-0887-4110-ada6-77d8efff33ad",
          "segment": "73a3433e-cf3a-4c04-bb40-ec02dab5846d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "stm"
    },
    {
      "external_segment": null,
      "name": "STM Code Redemption Desktop Anonymous",
      "rule": "2e3595f8-407a-40a3-ac23-bfc2c257d558",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "1eeabb2b-49c7-44f5-b49d-b3c7d57a6cad",
          "segment": "c656b4be-3193-4dac-9d71-eee7e5d76265",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "stm"
    },
    {
      "external_segment": null,
      "name": "STM Code Redemption Tablet Anonymous",
      "rule": "d053ebf0-028a-41c8-bcad-344b8bbc6d74",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "4d9d4d99-5c1d-4e96-8b80-828524a05883",
          "segment": "18c0fded-f1c2-4381-aec7-46b949dff828",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "stm"
    }
  ]
}
